import React, { createContext, useContext, useState, useEffect, useRef, useMemo } from 'react';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

var VeltContext = createContext({ client: null });
function useVeltClient() {
    return useContext(VeltContext);
}

var loadVelt = function (callback, version, staging, develop, proxyDomain) {
    if (version === void 0) { version = 'latest'; }
    if (staging === void 0) { staging = false; }
    if (develop === void 0) { develop = false; }
    var existingScript = document.getElementById('veltScript');
    if (!existingScript) {
        var script = document.createElement('script');
        if (staging) {
            script.src = "https://us-central1-snipply-sdk-staging.cloudfunctions.net/getprivatenpmpackagefile?packageName=sdk-staging&packageVersion=".concat((!version || version === 'latest') ? '1.0.1' : version, "&filePath=velt.js&orgName=@veltdev");
        }
        else if (develop) {
            script.src = "https://us-central1-snipply-sdk-staging.cloudfunctions.net/getprivatenpmpackagefile?packageName=sdk-dev&packageVersion=".concat((!version || version === 'latest') ? '1.0.1' : version, "&filePath=velt.js&orgName=@veltdev");
        }
        else {
            if (proxyDomain) {
                // remove trailing slash from proxy
                if (proxyDomain[proxyDomain.length - 1] === '/') {
                    proxyDomain = proxyDomain.slice(0, -1);
                }
                script.src = "".concat(proxyDomain, "/lib/sdk@").concat(version, "/velt.js");
            }
            else {
                script.src = "https://cdn.velt.dev/lib/sdk@".concat(version, "/velt.js");
            }
        }
        script.id = 'veltScript';
        script.type = 'module';
        document.body.appendChild(script);
        script.onload = function () {
            if (callback) {
                callback();
            }
        };
    }
    else {
        if (callback) {
            callback();
        }
    }
};

var VELT_SDK_VERSION = '4.3.0';
var VELT_SDK_INIT_EVENT = 'onVeltInit';
var VELT_TAB_ID = 'veltTabId';

var SnippylyProvider = function (props) {
    var apiKey = props.apiKey, user = props.user, config = props.config, documentId = props.documentId, language = props.language, translations = props.translations, autoTranslation = props.autoTranslation, userDataProvider = props.userDataProvider, dataProviders = props.dataProviders, onClientLoad = props.onClientLoad, children = props.children;
    var _a = useState(null), client = _a[0], setClient = _a[1];
    useEffect(function () {
        if (apiKey) {
            loadVelt(function () {
                initVelt();
            }, (config === null || config === void 0 ? void 0 : config.version) || VELT_SDK_VERSION, config === null || config === void 0 ? void 0 : config.staging, config === null || config === void 0 ? void 0 : config.develop, config === null || config === void 0 ? void 0 : config.proxyDomain);
        }
    }, []);
    useEffect(function () {
        if (client && userDataProvider) {
            if (typeof (client === null || client === void 0 ? void 0 : client.setUserDataProvider) === 'function') {
                client === null || client === void 0 ? void 0 : client.setUserDataProvider(userDataProvider);
            }
        }
    }, [client, userDataProvider]);
    useEffect(function () {
        if (client && dataProviders) {
            if (typeof (client === null || client === void 0 ? void 0 : client.setDataProviders) === 'function') {
                client === null || client === void 0 ? void 0 : client.setDataProviders(dataProviders);
            }
        }
    }, [client, dataProviders]);
    var initVelt = function () { return __awaiter(void 0, void 0, void 0, function () {
        var velt, event;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!config) return [3 /*break*/, 2];
                    if (config.staging) {
                        delete config.staging;
                    }
                    if (config.develop) {
                        delete config.develop;
                    }
                    if (config === null || config === void 0 ? void 0 : config.version) {
                        config === null || config === void 0 ? true : delete config.version;
                    }
                    if (config === null || config === void 0 ? void 0 : config.proxyDomain) {
                        delete config.proxyDomain;
                    }
                    return [4 /*yield*/, ((_a = window.Velt) === null || _a === void 0 ? void 0 : _a.init(apiKey, config))];
                case 1:
                    velt = _c.sent();
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, ((_b = window.Velt) === null || _b === void 0 ? void 0 : _b.init(apiKey))];
                case 3:
                    velt = _c.sent();
                    _c.label = 4;
                case 4:
                    // Set language
                    if (language && (velt === null || velt === void 0 ? void 0 : velt.setLanguage)) {
                        velt === null || velt === void 0 ? void 0 : velt.setLanguage(language);
                    }
                    // Set translations
                    if (translations && (velt === null || velt === void 0 ? void 0 : velt.setTranslations)) {
                        if (typeof translations === 'object') {
                            Object.keys(translations).forEach(function (languageCode) {
                                velt === null || velt === void 0 ? void 0 : velt.setTranslations(languageCode, translations[languageCode] || {});
                            });
                        }
                    }
                    if ([true, false].includes(autoTranslation)) {
                        if (autoTranslation && (velt === null || velt === void 0 ? void 0 : velt.enableAutoTranslation)) {
                            velt === null || velt === void 0 ? void 0 : velt.enableAutoTranslation();
                        }
                        else if (!autoTranslation && (velt === null || velt === void 0 ? void 0 : velt.disableAutoTranslation)) {
                            velt === null || velt === void 0 ? void 0 : velt.disableAutoTranslation();
                        }
                    }
                    if (velt === null || velt === void 0 ? void 0 : velt.st) {
                        velt === null || velt === void 0 ? void 0 : velt.st('react');
                    }
                    setClient(velt);
                    if (onClientLoad) {
                        onClientLoad(velt);
                    }
                    if (!user) return [3 /*break*/, 6];
                    return [4 /*yield*/, (velt === null || velt === void 0 ? void 0 : velt.identify(user))];
                case 5:
                    _c.sent();
                    _c.label = 6;
                case 6:
                    if (documentId) {
                        velt === null || velt === void 0 ? void 0 : velt.setDocumentId(documentId);
                    }
                    event = new CustomEvent(VELT_SDK_INIT_EVENT, { detail: velt });
                    window.dispatchEvent(event);
                    return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement(React.Fragment, null,
        React.createElement(VeltContext.Provider, { value: { client: client } }, children)));
};

var SnippylyCommentBubble = function (props) {
    var targetCommentElementId = props.targetCommentElementId, targetElementId = props.targetElementId, avatar = props.avatar, showAvatar = props.showAvatar, commentBubbleTargetPinHover = props.commentBubbleTargetPinHover, children = props.children, shadowDom = props.shadowDom, variant = props.variant, darkMode = props.darkMode, commentCountType = props.commentCountType;
    return (React.createElement("velt-comment-bubble", { "comment-count-type": commentCountType, "target-comment-element-id": targetCommentElementId, "target-element-id": targetElementId, "show-avatar": [true, false].includes(showAvatar) ? (showAvatar ? 'true' : 'false') : undefined, avatar: [true, false].includes(avatar) ? (avatar ? 'true' : 'false') : undefined, "comment-bubble-target-pin-hover": commentBubbleTargetPinHover ? 'true' : undefined, "shadow-dom": [true, false].includes(shadowDom) ? (shadowDom ? 'true' : 'false') : undefined, "dark-mode": [true, false].includes(darkMode) ? (darkMode ? 'true' : 'false') : undefined, variant: variant }, children));
};

var SnippylyComments = function (props) {
    var autoCategorize = props.autoCategorize, streamViewContainerId = props.streamViewContainerId, onSignIn = props.onSignIn, onUpgrade = props.onUpgrade, textMode = props.textMode, popoverMode = props.popoverMode, popoverTriangleComponent = props.popoverTriangleComponent, floatingCommentDialog = props.floatingCommentDialog, moderatorMode = props.moderatorMode, streamMode = props.streamMode, signInButton = props.signInButton, upgradeButton = props.upgradeButton, attachments = props.attachments, recordings = props.recordings, reactions = props.reactions, deviceInfo = props.deviceInfo, commentIndex = props.commentIndex, dialogOnHover = props.dialogOnHover, dialogOnTargetElementClick = props.dialogOnTargetElementClick, priority = props.priority, inboxMode = props.inboxMode, suggestionMode = props.suggestionMode, mobileMode = props.mobileMode, inlineCommentMode = props.inlineCommentMode, privateCommentMode = props.privateCommentMode, minimap = props.minimap, minimapPosition = props.minimapPosition, persistentCommentMode = props.persistentCommentMode, ghostComments = props.ghostComments, ghostCommentsIndicator = props.ghostCommentsIndicator, commentsOnDom = props.commentsOnDom, resolvedCommentsOnDom = props.resolvedCommentsOnDom, bubbleOnPin = props.bubbleOnPin, bubbleOnPinHover = props.bubbleOnPinHover, commentTool = props.commentTool, sidebarButtonOnCommentDialog = props.sidebarButtonOnCommentDialog, deviceIndicatorOnCommentPins = props.deviceIndicatorOnCommentPins, scrollToComment = props.scrollToComment, userMentions = props.userMentions, deleteOnBackspace = props.deleteOnBackspace, hotkey = props.hotkey, recordingSummary = props.recordingSummary, recordingTranscription = props.recordingTranscription, recordingCountdown = props.recordingCountdown, unreadIndicatorMode = props.unreadIndicatorMode, enterKeyToSubmit = props.enterKeyToSubmit, pinShadowDom = props.pinShadowDom, dialogShadowDom = props.dialogShadowDom, persistentCommentShadowDom = props.persistentCommentShadowDom, shadowDom = props.shadowDom, changeDetectionInCommentMode = props.changeDetectionInCommentMode, areaComment = props.areaComment, pinCursorImage = props.pinCursorImage, allowedElementIds = props.allowedElementIds, allowedElementClassNames = props.allowedElementClassNames, allowedElementQuerySelectors = props.allowedElementQuerySelectors, commentPinHighlighter = props.commentPinHighlighter, customReactions = props.customReactions, onCommentAdd = props.onCommentAdd, onCommentUpdate = props.onCommentUpdate, onCommentAccept = props.onCommentAccept, onCommentReject = props.onCommentReject, onSidebarButtonOnCommentDialogClick = props.onSidebarButtonOnCommentDialogClick, onCommentSelectionChange = props.onCommentSelectionChange, customStatus = props.customStatus, customListDataOnAnnotation = props.customListDataOnAnnotation, customListDataOnComment = props.customListDataOnComment, customPriority = props.customPriority, customCategory = props.customCategory, status = props.status, resolveButton = props.resolveButton, darkMode = props.darkMode, onCustomPinInject = props.onCustomPinInject, children = props.children, textCommentToolShadowDom = props.textCommentToolShadowDom, textCommentToolbarShadowDom = props.textCommentToolbarShadowDom, dialogDarkMode = props.dialogDarkMode, pinDarkMode = props.pinDarkMode, textCommentToolDarkMode = props.textCommentToolDarkMode, textCommentToolbarDarkMode = props.textCommentToolbarDarkMode, composerMode = props.composerMode, atHereLabel = props.atHereLabel, atHereDescription = props.atHereDescription, multiThreadMode = props.multiThreadMode, multiThread = props.multiThread, onCopyLink = props.onCopyLink, deleteReplyConfirmation = props.deleteReplyConfirmation, collapsedComments = props.collapsedComments, shortUserName = props.shortUserName, resolveStatusAccessAdminOnly = props.resolveStatusAccessAdminOnly, svgAsImg = props.svgAsImg, seenByUsers = props.seenByUsers, readOnly = props.readOnly, atHereEnabled = props.atHereEnabled, customAutocompleteSearch = props.customAutocompleteSearch, deleteThreadWithFirstComment = props.deleteThreadWithFirstComment, expandMentionGroups = props.expandMentionGroups, showMentionGroupsFirst = props.showMentionGroupsFirst, showMentionGroupsOnly = props.showMentionGroupsOnly, fullExpanded = props.fullExpanded;
    var ref = useRef();
    var onSignInRef = useRef(onSignIn);
    var onUpgradeRef = useRef(onUpgrade);
    var onCommentAddRef = useRef(onCommentAdd);
    var onCommentUpdateRef = useRef(onCommentUpdate);
    var onCommentAcceptRef = useRef(onCommentAccept);
    var onCommentRejectRef = useRef(onCommentReject);
    var onSidebarButtonOnCommentDialogClickRef = useRef(onSidebarButtonOnCommentDialogClick);
    var onCustomPinInjectRef = useRef(onCustomPinInject);
    var onCommentSelectionChangeRef = useRef(onCommentSelectionChange);
    var onCopyLinkRef = useRef(onCopyLink);
    // Update the ref to always point to the latest callback function
    useEffect(function () {
        onSignInRef.current = onSignIn;
    }, [onSignIn]);
    useEffect(function () {
        onCopyLinkRef.current = onCopyLink;
    }, [onCopyLink]);
    useEffect(function () {
        onUpgradeRef.current = onUpgrade;
    }, [onUpgrade]);
    useEffect(function () {
        onCommentAddRef.current = onCommentAdd;
    }, [onCommentAdd]);
    useEffect(function () {
        onCommentUpdateRef.current = onCommentUpdate;
    }, [onCommentUpdate]);
    useEffect(function () {
        onCommentAcceptRef.current = onCommentAccept;
    }, [onCommentAccept]);
    useEffect(function () {
        onCommentRejectRef.current = onCommentReject;
    }, [onCommentReject]);
    useEffect(function () {
        onSidebarButtonOnCommentDialogClickRef.current = onSidebarButtonOnCommentDialogClick;
    }, [onSidebarButtonOnCommentDialogClick]);
    useEffect(function () {
        onCustomPinInjectRef.current = onCustomPinInject;
    }, [onCustomPinInject]);
    useEffect(function () {
        onCommentSelectionChangeRef.current = onCommentSelectionChange;
    }, [onCommentSelectionChange]);
    useEffect(function () {
        var element;
        var handleSignIn = function (event) {
            if (onSignInRef.current) {
                onSignInRef.current(event === null || event === void 0 ? void 0 : event.detail);
            }
        };
        var handleUpgrade = function (event) {
            if (onUpgradeRef.current) {
                onUpgradeRef.current(event === null || event === void 0 ? void 0 : event.detail);
            }
        };
        var handleCommentAdd = function (event) {
            if (onCommentAddRef.current) {
                onCommentAddRef.current(event === null || event === void 0 ? void 0 : event.detail);
            }
        };
        var handleCommentUpdate = function (event) {
            if (onCommentUpdateRef.current) {
                onCommentUpdateRef.current(event === null || event === void 0 ? void 0 : event.detail);
            }
        };
        var handleCommentAccept = function (event) {
            if (onCommentAcceptRef.current) {
                onCommentAcceptRef.current(event === null || event === void 0 ? void 0 : event.detail);
            }
        };
        var handleCommentReject = function (event) {
            if (onCommentRejectRef.current) {
                onCommentRejectRef.current(event === null || event === void 0 ? void 0 : event.detail);
            }
        };
        var handleSidebarButtonOnCommentDialogClick = function (event) {
            if (onSidebarButtonOnCommentDialogClickRef.current) {
                onSidebarButtonOnCommentDialogClickRef.current(event === null || event === void 0 ? void 0 : event.detail);
            }
        };
        var handleCustomPinInject = function (event) {
            if (onCustomPinInjectRef.current) {
                onCustomPinInjectRef.current(event === null || event === void 0 ? void 0 : event.detail);
            }
        };
        var handleCommentSelectionChange = function (event) {
            if (onCommentSelectionChangeRef.current) {
                onCommentSelectionChangeRef.current(event === null || event === void 0 ? void 0 : event.detail);
            }
        };
        var handleCopyLink = function (event) {
            if (onCopyLinkRef.current) {
                onCopyLinkRef.current(event === null || event === void 0 ? void 0 : event.detail);
            }
        };
        if (ref.current) {
            element = ref.current;
            if (element) {
                element.addEventListener('onSignIn', handleSignIn);
                element.addEventListener('onUpgrade', handleUpgrade);
                element.addEventListener('onCommentAdd', handleCommentAdd);
                element.addEventListener('onCommentUpdate', handleCommentUpdate);
                element.addEventListener('onCommentAccept', handleCommentAccept);
                element.addEventListener('onCommentReject', handleCommentReject);
                element.addEventListener('onSidebarButtonOnCommentDialogClick', handleSidebarButtonOnCommentDialogClick);
                element.addEventListener('onCustomPinInject', handleCustomPinInject);
                element.addEventListener('onCommentSelectionChange', handleCommentSelectionChange);
                element.addEventListener('onCopyLink', handleCopyLink);
            }
        }
        return function () {
            if (element) {
                element.removeEventListener('onSignIn', handleSignIn);
                element.removeEventListener('onUpgrade', handleUpgrade);
                element.removeEventListener('onCommentAdd', handleCommentAdd);
                element.removeEventListener('onCommentUpdate', handleCommentUpdate);
                element.removeEventListener('onCommentAccept', handleCommentAccept);
                element.removeEventListener('onCommentReject', handleCommentReject);
                element.removeEventListener('onSidebarButtonOnCommentDialogClick', handleSidebarButtonOnCommentDialogClick);
                element.removeEventListener('onCustomPinInject', handleCustomPinInject);
                element.removeEventListener('onCommentSelectionChange', handleCommentSelectionChange);
                element.removeEventListener('onCopyLink', handleCopyLink);
            }
        };
    }, []);
    return (React.createElement("velt-comments", { ref: ref, "at-here-label": atHereLabel, "at-here-description": atHereDescription, "at-here-enabled": [true, false].includes(atHereEnabled) ? (atHereEnabled ? 'true' : 'false') : undefined, "composer-mode": composerMode, "seen-by-users": [true, false].includes(seenByUsers) ? (seenByUsers ? 'true' : 'false') : undefined, "collapsed-comments": [true, false].includes(collapsedComments) ? (collapsedComments ? 'true' : 'false') : undefined, "short-user-name": [true, false].includes(shortUserName) ? (shortUserName ? 'true' : 'false') : undefined, "resolve-status-access-admin-only": [true, false].includes(resolveStatusAccessAdminOnly) ? (resolveStatusAccessAdminOnly ? 'true' : 'false') : undefined, "delete-reply-confirmation": [true, false].includes(deleteReplyConfirmation) ? (deleteReplyConfirmation ? 'true' : 'false') : undefined, "auto-categorize": [true, false].includes(autoCategorize) ? (autoCategorize ? 'true' : 'false') : undefined, "data-stream-view-container-id": streamViewContainerId, "text-mode": [true, false].includes(textMode) ? (textMode ? 'true' : 'false') : undefined, "popover-mode": [true, false].includes(popoverMode) ? (popoverMode ? 'true' : 'false') : undefined, "popover-triangle-component": [true, false].includes(popoverTriangleComponent) ? (popoverTriangleComponent ? 'true' : 'false') : undefined, "floating-comment-dialog": [true, false].includes(floatingCommentDialog) ? (floatingCommentDialog ? 'true' : 'false') : undefined, "moderator-mode": [true, false].includes(moderatorMode) ? (moderatorMode ? 'true' : 'false') : undefined, "stream-mode": [true, false].includes(streamMode) ? (streamMode ? 'true' : 'false') : undefined, "sign-in-button": [true, false].includes(signInButton) ? (signInButton ? 'true' : 'false') : undefined, "upgrade-button": [true, false].includes(upgradeButton) ? (upgradeButton ? 'true' : 'false') : undefined, attachments: [true, false].includes(attachments) ? (attachments ? 'true' : 'false') : undefined, recordings: recordings, reactions: [true, false].includes(reactions) ? (reactions ? 'true' : 'false') : undefined, "device-info": [true, false].includes(deviceInfo) ? (deviceInfo ? 'true' : 'false') : undefined, "comment-index": [true, false].includes(commentIndex) ? (commentIndex ? 'true' : 'false') : undefined, "dialog-on-hover": [true, false].includes(dialogOnHover) ? (dialogOnHover ? 'true' : 'false') : undefined, "dialog-on-target-element-click": [true, false].includes(dialogOnTargetElementClick) ? (dialogOnTargetElementClick ? 'true' : 'false') : undefined, priority: [true, false].includes(priority) ? (priority ? 'true' : 'false') : undefined, status: [true, false].includes(status) ? (status ? 'true' : 'false') : undefined, "resolve-button": [true, false].includes(resolveButton) ? (resolveButton ? 'true' : 'false') : undefined, "inbox-mode": [true, false].includes(inboxMode) ? (inboxMode ? 'true' : 'false') : undefined, "suggestion-mode": [true, false].includes(suggestionMode) ? (suggestionMode ? 'true' : 'false') : undefined, "mobile-mode": [true, false].includes(mobileMode) ? (mobileMode ? 'true' : 'false') : undefined, "inline-comment-mode": [true, false].includes(inlineCommentMode) ? (inlineCommentMode ? 'true' : 'false') : undefined, "private-comment-mode": [true, false].includes(privateCommentMode) ? (privateCommentMode ? 'true' : 'false') : undefined, minimap: [true, false].includes(minimap) ? (minimap ? 'true' : 'false') : undefined, "minimap-position": minimapPosition, "persistent-comment-mode": [true, false].includes(persistentCommentMode) ? (persistentCommentMode ? 'true' : 'false') : undefined, "ghost-comments": [true, false].includes(ghostComments) ? (ghostComments ? 'true' : 'false') : undefined, "ghost-comments-indicator": [true, false].includes(ghostCommentsIndicator) ? (ghostCommentsIndicator ? 'true' : 'false') : undefined, "comments-on-dom": [true, false].includes(commentsOnDom) ? (commentsOnDom ? 'true' : 'false') : undefined, "resolved-comments-on-dom": [true, false].includes(resolvedCommentsOnDom) ? (resolvedCommentsOnDom ? 'true' : 'false') : undefined, "bubble-on-pin": [true, false].includes(bubbleOnPin) ? (bubbleOnPin ? 'true' : 'false') : undefined, "bubble-on-pin-hover": [true, false].includes(bubbleOnPinHover) ? (bubbleOnPinHover ? 'true' : 'false') : undefined, "comment-tool": [true, false].includes(commentTool) ? (commentTool ? 'true' : 'false') : undefined, "sidebar-button-on-comment-dialog": [true, false].includes(sidebarButtonOnCommentDialog) ? (sidebarButtonOnCommentDialog ? 'true' : 'false') : undefined, "device-indicator-on-comment-pins": [true, false].includes(deviceIndicatorOnCommentPins) ? (deviceIndicatorOnCommentPins ? 'true' : 'false') : undefined, "scroll-to-comment": [true, false].includes(scrollToComment) ? (scrollToComment ? 'true' : 'false') : undefined, "user-mentions": [true, false].includes(userMentions) ? (userMentions ? 'true' : 'false') : undefined, "delete-on-backspace": [true, false].includes(deleteOnBackspace) ? (deleteOnBackspace ? 'true' : 'false') : undefined, hotkey: [true, false].includes(hotkey) ? (hotkey ? 'true' : 'false') : undefined, "recording-summary": [true, false].includes(recordingSummary) ? (recordingSummary ? 'true' : 'false') : undefined, "recording-transcription": [true, false].includes(recordingTranscription) ? (recordingTranscription ? 'true' : 'false') : undefined, "recording-countdown": [true, false].includes(recordingCountdown) ? (recordingCountdown ? 'true' : 'false') : undefined, "unread-indicator-mode": unreadIndicatorMode, "enter-key-to-submit": [true, false].includes(enterKeyToSubmit) ? (enterKeyToSubmit ? 'true' : 'false') : undefined, "pin-shadow-dom": [true, false].includes(pinShadowDom) ? (pinShadowDom ? 'true' : 'false') : undefined, "dialog-shadow-dom": [true, false].includes(dialogShadowDom) ? (dialogShadowDom ? 'true' : 'false') : undefined, "shadow-dom": [true, false].includes(shadowDom) ? (shadowDom ? 'true' : 'false') : undefined, "text-comment-tool-shadow-dom": [true, false].includes(textCommentToolShadowDom) ? (textCommentToolShadowDom ? 'true' : 'false') : undefined, "text-comment-toolbar-shadow-dom": [true, false].includes(textCommentToolbarShadowDom) ? (textCommentToolbarShadowDom ? 'true' : 'false') : undefined, "persistent-comment-shadow-dom": [true, false].includes(persistentCommentShadowDom) ? (persistentCommentShadowDom ? 'true' : 'false') : undefined, "change-detection-in-comment-mode": [true, false].includes(changeDetectionInCommentMode) ? (changeDetectionInCommentMode ? 'true' : 'false') : undefined, "area-comment": [true, false].includes(areaComment) ? (areaComment ? 'true' : 'false') : undefined, "pin-cursor-image": pinCursorImage, "allowed-element-ids": JSON.stringify(allowedElementIds), "allowed-element-class-names": JSON.stringify(allowedElementClassNames), "allowed-element-query-selectors": JSON.stringify(allowedElementQuerySelectors), "comment-pin-highlighter": [true, false].includes(commentPinHighlighter) ? (commentPinHighlighter ? 'true' : 'false') : undefined, "custom-reactions": JSON.stringify(customReactions), "custom-status": JSON.stringify(customStatus), "custom-list-data-on-annotation": JSON.stringify(customListDataOnAnnotation), "custom-list-data-on-comment": JSON.stringify(customListDataOnComment), "custom-priority": JSON.stringify(customPriority), "custom-category": JSON.stringify(customCategory), "dark-mode": [true, false].includes(darkMode) ? (darkMode ? 'true' : 'false') : undefined, "dialog-dark-mode": [true, false].includes(dialogDarkMode) ? (dialogDarkMode ? 'true' : 'false') : undefined, "pin-dark-mode": [true, false].includes(pinDarkMode) ? (pinDarkMode ? 'true' : 'false') : undefined, "text-comment-tool-dark-mode": [true, false].includes(textCommentToolDarkMode) ? (textCommentToolDarkMode ? 'true' : 'false') : undefined, "text-comment-toolbar-dark-mode": [true, false].includes(textCommentToolbarDarkMode) ? (textCommentToolbarDarkMode ? 'true' : 'false') : undefined, "multi-thread-mode": [true, false].includes(multiThreadMode) ? (multiThreadMode ? 'true' : 'false') : undefined, "multi-thread": [true, false].includes(multiThread) ? (multiThread ? 'true' : 'false') : undefined, "read-only": [true, false].includes(readOnly) ? (readOnly ? 'true' : 'false') : undefined, "custom-autocomplete-search": [true, false].includes(customAutocompleteSearch) ? (customAutocompleteSearch ? 'true' : 'false') : undefined, "delete-thread-with-first-comment": [true, false].includes(deleteThreadWithFirstComment) ? (deleteThreadWithFirstComment ? 'true' : 'false') : undefined, "svg-as-img": [true, false].includes(svgAsImg) ? (svgAsImg ? 'true' : 'false') : undefined, "expand-mention-groups": [true, false].includes(expandMentionGroups) ? (expandMentionGroups ? 'true' : 'false') : undefined, "show-mention-groups-first": [true, false].includes(showMentionGroupsFirst) ? (showMentionGroupsFirst ? 'true' : 'false') : undefined, "show-mention-groups-only": [true, false].includes(showMentionGroupsOnly) ? (showMentionGroupsOnly ? 'true' : 'false') : undefined, "full-expanded": [true, false].includes(fullExpanded) ? (fullExpanded ? 'true' : 'false') : undefined }, children));
};

var SnippylyCommentsSidebar = function (props) {
    var embedMode = props.embedMode; props.floatingMode; var enableUrlNavigation = props.enableUrlNavigation, urlNavigation = props.urlNavigation, queryParamsComments = props.queryParamsComments, pageMode = props.pageMode, currentLocationSuffix = props.currentLocationSuffix, sortData = props.sortData, filterConfig = props.filterConfig, groupConfig = props.groupConfig, filters = props.filters, excludeLocationIds = props.excludeLocationIds, variant = props.variant, pageModeComposerVariant = props.pageModeComposerVariant, dialogVariant = props.dialogVariant, shadowDom = props.shadowDom, searchPlaceholder = props.searchPlaceholder, openSidebar = props.openSidebar, onSidebarOpen = props.onSidebarOpen, onSidebarCommentClick = props.onSidebarCommentClick, onCommentClick = props.onCommentClick, onSidebarClose = props.onSidebarClose, darkMode = props.darkMode, position = props.position, filterPanelLayout = props.filterPanelLayout, customActions = props.customActions, focusedThreadDialogVariant = props.focusedThreadDialogVariant, focusedThreadMode = props.focusedThreadMode, onCommentNavigationButtonClick = props.onCommentNavigationButtonClick, filterOptionLayout = props.filterOptionLayout, filterCount = props.filterCount, fullExpanded = props.fullExpanded;
    var ref = useRef();
    var openSidebarRef = useRef(openSidebar);
    var onSidebarOpenRef = useRef(onSidebarOpen);
    var onSidebarCommentClickRef = useRef(onSidebarCommentClick);
    var onCommentClickRef = useRef(onCommentClick);
    var onSidebarCloseRef = useRef(onSidebarClose);
    var onCommentNavigationButtonClickRef = useRef(onCommentNavigationButtonClick);
    // Update the ref to always point to the latest callback function
    useEffect(function () {
        openSidebarRef.current = openSidebar;
    }, [openSidebar]);
    useEffect(function () {
        onSidebarOpenRef.current = onSidebarOpen;
    }, [onSidebarOpen]);
    useEffect(function () {
        onSidebarCommentClickRef.current = onSidebarCommentClick;
    }, [onSidebarCommentClick]);
    useEffect(function () {
        onSidebarCloseRef.current = onSidebarClose;
    }, [onSidebarClose]);
    useEffect(function () {
        onCommentClickRef.current = onCommentClick;
    }, [onCommentClick]);
    useEffect(function () {
        onCommentNavigationButtonClickRef.current = onCommentNavigationButtonClick;
    }, [onCommentNavigationButtonClick]);
    useEffect(function () {
        var element;
        var handleSidebarOpen = function (event) {
            if (openSidebarRef.current) {
                openSidebarRef.current(event === null || event === void 0 ? void 0 : event.detail);
            }
            if (onSidebarOpenRef.current) {
                onSidebarOpenRef.current(event === null || event === void 0 ? void 0 : event.detail);
            }
        };
        var handleSidebarCommentClick = function (event) {
            if (onSidebarCommentClickRef.current) {
                onSidebarCommentClickRef.current(event === null || event === void 0 ? void 0 : event.detail);
            }
            if (onCommentClickRef.current) {
                onCommentClickRef.current(event === null || event === void 0 ? void 0 : event.detail);
            }
        };
        var handleSidebarClose = function (event) {
            if (onSidebarCloseRef.current) {
                onSidebarCloseRef.current(event === null || event === void 0 ? void 0 : event.detail);
            }
        };
        var handleCommentNavigationButtonClick = function (event) {
            if (onCommentNavigationButtonClickRef.current) {
                onCommentNavigationButtonClickRef.current(event === null || event === void 0 ? void 0 : event.detail);
            }
        };
        if (ref.current) {
            element = ref.current;
            if (element) {
                element.addEventListener('onSidebarOpen', handleSidebarOpen);
                element.addEventListener('onSidebarCommentClick', handleSidebarCommentClick);
                element.addEventListener('onSidebarClose', handleSidebarClose);
                element.addEventListener('onCommentNavigationButtonClick', handleCommentNavigationButtonClick);
            }
        }
        return function () {
            if (element) {
                element.removeEventListener('onSidebarOpen', handleSidebarOpen);
                element.removeEventListener('onSidebarCommentClick', handleSidebarCommentClick);
                element.removeEventListener('onSidebarClose', handleSidebarClose);
                element.removeEventListener('onCommentNavigationButtonClick', handleCommentNavigationButtonClick);
            }
        };
    }, []);
    return (React.createElement("velt-comments-sidebar", { ref: ref, position: position, "filter-panel-layout": filterPanelLayout, "focused-thread-mode": [true, false].includes(focusedThreadMode) ? (focusedThreadMode ? 'true' : 'false') : undefined, "focused-thread-dialog-variant": focusedThreadDialogVariant, "custom-actions": [true, false].includes(customActions) ? (customActions ? 'true' : 'false') : undefined, "shadow-dom": [true, false].includes(shadowDom) ? (shadowDom ? 'true' : 'false') : undefined, "embed-mode": [true, false].includes(embedMode) ? (embedMode ? 'true' : 'false') : undefined, "enable-url-navigation": [true, false].includes(enableUrlNavigation) ? (enableUrlNavigation ? 'true' : 'false') : undefined, "url-navigation": [true, false].includes(urlNavigation) ? (urlNavigation ? 'true' : 'false') : undefined, "query-params-comments": [true, false].includes(queryParamsComments) ? (queryParamsComments ? 'true' : 'false') : undefined, "page-mode": [true, false].includes(pageMode) ? (pageMode ? 'true' : 'false') : undefined, "current-location-suffix": [true, false].includes(currentLocationSuffix) ? (currentLocationSuffix ? 'true' : 'false') : undefined, "filter-config": filterConfig ? JSON.stringify(filterConfig) : undefined, "group-config": groupConfig ? JSON.stringify(groupConfig) : undefined, filters: filters ? JSON.stringify(filters) : undefined, "exclude-location-ids": excludeLocationIds ? JSON.stringify(excludeLocationIds) : undefined, variant: variant, "page-mode-composer-variant": pageModeComposerVariant, "dialog-variant": dialogVariant, "sort-data": sortData, "search-placeholder": searchPlaceholder, "dark-mode": [true, false].includes(darkMode) ? (darkMode ? 'true' : 'false') : undefined, "floating-mode": [true, false].includes(embedMode) ? (embedMode ? 'true' : 'false') : undefined, "filter-option-layout": filterOptionLayout, "filter-count": [true, false].includes(filterCount) ? (filterCount ? 'true' : 'false') : undefined, "full-expanded": [true, false].includes(fullExpanded) ? (fullExpanded ? 'true' : 'false') : undefined }));
};

var SnippylyCommentTool = function (props) {
    var targetCommentElementId = props.targetCommentElementId, targetElementId = props.targetElementId, onCommentModeChange = props.onCommentModeChange, sourceId = props.sourceId, children = props.children, darkMode = props.darkMode, variant = props.variant, shadowDom = props.shadowDom;
    var ref = useRef();
    var onCommentModeChangeRef = useRef(onCommentModeChange);
    // Update the ref to always point to the latest callback function
    useEffect(function () {
        onCommentModeChangeRef.current = onCommentModeChange;
    }, [onCommentModeChange]);
    useEffect(function () {
        var element;
        var handleCommentModeChange = function (event) {
            if (onCommentModeChangeRef.current) {
                onCommentModeChangeRef.current(event === null || event === void 0 ? void 0 : event.detail);
            }
        };
        if (ref.current) {
            element = ref.current;
            if (element) {
                element.addEventListener('onCommentModeChange', handleCommentModeChange);
            }
        }
        return function () {
            if (element) {
                element.removeEventListener('onCommentModeChange', handleCommentModeChange);
            }
        };
    }, []);
    return (React.createElement("velt-comment-tool", { ref: ref, "target-comment-element-id": targetCommentElementId, "target-element-id": targetElementId, "source-id": sourceId, variant: variant, "shadow-dom": [true, false].includes(shadowDom) ? (shadowDom ? 'true' : 'false') : undefined, "dark-mode": [true, false].includes(darkMode) ? (darkMode ? 'true' : 'false') : undefined }, children));
};

var SnippylyCursor = function (props) {
    var allowedElementIds = props.allowedElementIds, avatarMode = props.avatarMode, inactivityTime = props.inactivityTime, onCursorUsersChanged = props.onCursorUsersChanged, onCursorUserChange = props.onCursorUserChange, children = props.children;
    var ref = useRef();
    var onCursorUsersChangedRef = useRef(onCursorUsersChanged);
    var onCursorUserChangeRef = useRef(onCursorUserChange);
    // Update the ref to always point to the latest callback function
    useEffect(function () {
        onCursorUsersChangedRef.current = onCursorUsersChanged;
    }, [onCursorUsersChanged]);
    useEffect(function () {
        onCursorUserChangeRef.current = onCursorUserChange;
    }, [onCursorUserChange]);
    useEffect(function () {
        var element;
        var handleCursorUserChange = function (event) {
            if (onCursorUsersChangedRef.current) {
                onCursorUsersChangedRef.current(event === null || event === void 0 ? void 0 : event.detail);
            }
            if (onCursorUserChangeRef.current) {
                onCursorUserChangeRef.current(event === null || event === void 0 ? void 0 : event.detail);
            }
        };
        if (ref.current) {
            element = ref.current;
            if (element) {
                element.addEventListener('onCursorUserChange', handleCursorUserChange);
            }
        }
        return function () {
            if (element) {
                element.removeEventListener('onCursorUserChange', handleCursorUserChange);
            }
        };
    }, []);
    return (React.createElement("velt-cursor", { ref: ref, "allowed-element-ids": allowedElementIds, "avatar-mode": avatarMode ? 'true' : undefined, "inactivity-time": inactivityTime }, children));
};

var SnippylyHuddle = function (props) {
    var chat = props.chat, flockModeOnAvatarClick = props.flockModeOnAvatarClick;
    return (React.createElement("velt-huddle", { chat: [true, false].includes(chat) ? (chat ? 'true' : 'false') : undefined, "flock-mode-on-avatar-click": [true, false].includes(flockModeOnAvatarClick) ? (flockModeOnAvatarClick ? 'true' : 'false') : undefined }));
};

var SnippylyHuddleTool = function (props) {
    var type = props.type, children = props.children, darkMode = props.darkMode;
    return (React.createElement("velt-huddle-tool", { type: type, "dark-mode": [true, false].includes(darkMode) ? (darkMode ? 'true' : 'false') : undefined }, children));
};

var SnippylyPresence = function (props) {
    var maxUsers = props.maxUsers, inactivityTime = props.inactivityTime, documentParams = props.documentParams, location = props.location, self = props.self, onPresenceUserClick = props.onPresenceUserClick, onUsersChanged = props.onUsersChanged, onPresenceUserChange = props.onPresenceUserChange, disableFlockNavigation = props.disableFlockNavigation, defaultFlockNavigation = props.defaultFlockNavigation, onNavigate = props.onNavigate, flockMode = props.flockMode;
    var ref = useRef();
    var onUsersChangedRef = useRef(onUsersChanged);
    var onPresenceUserChangeRef = useRef(onPresenceUserChange);
    var onNavigateRef = useRef(onNavigate);
    var onPresenceUserClickRef = useRef(onPresenceUserClick);
    // Update the ref to always point to the latest callback function
    useEffect(function () {
        onUsersChangedRef.current = onUsersChanged;
    }, [onUsersChanged]);
    useEffect(function () {
        onPresenceUserChangeRef.current = onPresenceUserChange;
    }, [onPresenceUserChange]);
    useEffect(function () {
        onNavigateRef.current = onNavigate;
    }, [onNavigate]);
    useEffect(function () {
        onPresenceUserClickRef.current = onPresenceUserClick;
    }, [onPresenceUserClick]);
    useEffect(function () {
        var element;
        var handlePresenceUserChange = function (event) {
            if (onUsersChangedRef.current) {
                onUsersChangedRef.current(event === null || event === void 0 ? void 0 : event.detail);
            }
            if (onPresenceUserChangeRef.current) {
                onPresenceUserChangeRef.current(event === null || event === void 0 ? void 0 : event.detail);
            }
        };
        var handleNavigate = function (event) {
            if (onNavigateRef.current) {
                onNavigateRef.current(event === null || event === void 0 ? void 0 : event.detail);
            }
        };
        var handlePresenceUserClick = function (event) {
            if (onPresenceUserClickRef.current) {
                onPresenceUserClickRef.current(event === null || event === void 0 ? void 0 : event.detail);
            }
        };
        if (ref.current) {
            element = ref.current;
            if (element) {
                element.addEventListener('onPresenceUserChange', handlePresenceUserChange);
                element.addEventListener('onNavigate', handleNavigate);
                element.addEventListener('onPresenceUserClick', handlePresenceUserClick);
            }
        }
        return function () {
            if (element) {
                element.removeEventListener('onPresenceUserChange', handlePresenceUserChange);
                element.removeEventListener('onNavigate', handleNavigate);
                element.removeEventListener('onPresenceUserClick', handlePresenceUserClick);
            }
        };
    }, []);
    return (React.createElement("velt-presence", { ref: ref, "flock-mode": [true, false].includes(flockMode) ? (flockMode ? 'true' : 'false') : undefined, "max-users": maxUsers, "inactivity-time": inactivityTime, "document-params": (typeof documentParams === 'object') ? JSON.stringify(documentParams) : (documentParams ? documentParams : undefined), "disable-flock-navigation": [true, false].includes(disableFlockNavigation) ? (disableFlockNavigation ? 'true' : 'false') : undefined, "default-flock-navigation": [true, false].includes(defaultFlockNavigation) ? (defaultFlockNavigation ? 'true' : 'false') : undefined, self: [true, false].includes(self) ? (self ? 'true' : 'false') : undefined, location: (typeof location === 'object') ? JSON.stringify(location) : (location ? location : undefined) }));
};

var SnippylyRecorderControlPanel = function (props) {
    var mode = props.mode, panelId = props.panelId, onRecordedData = props.onRecordedData, recordingCountdown = props.recordingCountdown, recordingTranscription = props.recordingTranscription, videoEditor = props.videoEditor;
    var ref = useRef();
    var onRecordedDataRef = useRef(onRecordedData);
    // Update the ref to always point to the latest callback function
    useEffect(function () {
        onRecordedDataRef.current = onRecordedData;
    }, [onRecordedData]);
    useEffect(function () {
        var element;
        var handleRecordedData = function (event) {
            if (onRecordedDataRef.current) {
                onRecordedDataRef.current(event === null || event === void 0 ? void 0 : event.detail);
            }
        };
        if (ref.current) {
            element = ref.current;
            if (element) {
                element.addEventListener('onRecordedData', handleRecordedData);
            }
        }
        return function () {
            if (element) {
                element.removeEventListener('onRecordedData', handleRecordedData);
            }
        };
    }, []);
    return (React.createElement("velt-recorder-control-panel", { ref: ref, mode: mode, "panel-id": panelId, "recording-countdown": [true, false].includes(recordingCountdown) ? (recordingCountdown ? 'true' : 'false') : undefined, "recording-transcription": [true, false].includes(recordingTranscription) ? (recordingTranscription ? 'true' : 'false') : undefined, "video-editor": [true, false].includes(videoEditor) ? (videoEditor ? 'true' : 'false') : undefined }));
};

var SnippylyRecorderNotes = function (props) {
    var shadowDom = props.shadowDom, children = props.children, videoEditor = props.videoEditor, recordingCountdown = props.recordingCountdown, recordingTranscription = props.recordingTranscription;
    return (React.createElement("velt-recorder-notes", { "shadow-dom": [true, false].includes(shadowDom) ? (shadowDom ? 'true' : 'false') : undefined, "video-editor": [true, false].includes(videoEditor) ? (videoEditor ? 'true' : 'false') : undefined, "recording-countdown": [true, false].includes(recordingCountdown) ? (recordingCountdown ? 'true' : 'false') : undefined, "recording-transcription": [true, false].includes(recordingTranscription) ? (recordingTranscription ? 'true' : 'false') : undefined }, children));
};

var SnippylyRecorderPlayer = function (props) {
    var recorderId = props.recorderId, onDelete = props.onDelete, showSummary = props.showSummary, summary = props.summary, shadowDom = props.shadowDom, videoEditor = props.videoEditor;
    var ref = useRef();
    var onDeleteRef = useRef(onDelete);
    // Update the ref to always point to the latest callback function
    useEffect(function () {
        onDeleteRef.current = onDelete;
    }, [onDelete]);
    useEffect(function () {
        var element;
        var handleOnDelete = function (event) {
            if (onDeleteRef.current) {
                onDeleteRef.current(event === null || event === void 0 ? void 0 : event.detail);
            }
        };
        if (ref.current) {
            element = ref.current;
            if (element) {
                element === null || element === void 0 ? void 0 : element.addEventListener('onDelete', handleOnDelete);
            }
        }
        return function () {
            if (element) {
                element === null || element === void 0 ? void 0 : element.removeEventListener('onDelete', handleOnDelete);
            }
        };
    }, []);
    return (React.createElement("velt-recorder-player", { ref: ref, "recorder-id": recorderId, "shadow-dom": [true, false].includes(shadowDom) ? (shadowDom ? 'true' : 'false') : undefined, "show-summary": [true, false].includes(showSummary) ? (showSummary ? 'true' : 'false') : undefined, summary: [true, false].includes(summary) ? (summary ? 'true' : 'false') : undefined, "video-editor": [true, false].includes(videoEditor) ? (videoEditor ? 'true' : 'false') : undefined }));
};

var SnippylyRecorderTool = function (props) {
    var type = props.type, panelId = props.panelId, buttonLabel = props.buttonLabel, children = props.children, darkMode = props.darkMode, shadowDom = props.shadowDom, recordingCountdown = props.recordingCountdown;
    return (React.createElement("velt-recorder-tool", { type: type, "panel-id": panelId, "button-label": buttonLabel, "dark-mode": [true, false].includes(darkMode) ? (darkMode ? 'true' : 'false') : undefined, "shadow-dom": [true, false].includes(shadowDom) ? (shadowDom ? 'true' : 'false') : undefined, "recording-countdown": [true, false].includes(recordingCountdown) ? (recordingCountdown ? 'true' : 'false') : undefined }, children));
};

var SnippylySidebarButton = function (props) {
    var tooltipText = props.tooltipText, children = props.children, darkMode = props.darkMode, shadowDom = props.shadowDom, floatingMode = props.floatingMode, pageMode = props.pageMode, sortData = props.sortData, urlNavigation = props.urlNavigation, currentLocationSuffix = props.currentLocationSuffix, filterConfig = props.filterConfig, groupConfig = props.groupConfig, filters = props.filters, excludeLocationIds = props.excludeLocationIds, dialogVariant = props.dialogVariant, pageModeComposerVariant = props.pageModeComposerVariant, sidebarShadowDom = props.sidebarShadowDom, sidebarVariant = props.sidebarVariant, position = props.position, onCommentClick = props.onCommentClick, onSidebarOpen = props.onSidebarOpen, filterPanelLayout = props.filterPanelLayout;
    var ref = useRef();
    var onSidebarOpenRef = useRef(onSidebarOpen);
    var onCommentClickRef = useRef(onCommentClick);
    useEffect(function () {
        onCommentClickRef.current = onCommentClick;
    }, [onCommentClick]);
    useEffect(function () {
        onSidebarOpenRef.current = onSidebarOpen;
    }, [onSidebarOpen]);
    useEffect(function () {
        var element;
        var handleSidebarOpen = function (event) {
            if (onSidebarOpenRef.current) {
                onSidebarOpenRef.current(event === null || event === void 0 ? void 0 : event.detail);
            }
        };
        var handleSidebarCommentClick = function (event) {
            if (onCommentClickRef.current) {
                onCommentClickRef.current(event === null || event === void 0 ? void 0 : event.detail);
            }
        };
        if (ref.current) {
            element = ref.current;
            if (element) {
                element.addEventListener('onSidebarOpen', handleSidebarOpen);
                element.addEventListener('onCommentClick', handleSidebarCommentClick);
            }
        }
        return function () {
            if (element) {
                element.removeEventListener('onSidebarOpen', handleSidebarOpen);
                element.removeEventListener('onCommentClick', handleSidebarCommentClick);
            }
        };
    });
    return (React.createElement("velt-sidebar-button", { "tooltip-text": tooltipText, "shadow-dom": [true, false].includes(shadowDom) ? (shadowDom ? 'true' : 'false') : undefined, "dark-mode": [true, false].includes(darkMode) ? (darkMode ? 'true' : 'false') : undefined, "floating-mode": [true, false].includes(floatingMode) ? (floatingMode ? 'true' : 'false') : undefined, ref: ref, "page-mode": [true, false].includes(pageMode) ? (pageMode ? 'true' : 'false') : undefined, "sort-data": sortData, "url-navigation": [true, false].includes(urlNavigation) ? (urlNavigation ? 'true' : 'false') : undefined, "current-location-suffix": [true, false].includes(currentLocationSuffix) ? (currentLocationSuffix ? 'true' : 'false') : undefined, "filter-config": filterConfig ? JSON.stringify(filterConfig) : undefined, "group-config": groupConfig ? JSON.stringify(groupConfig) : undefined, filters: filters ? JSON.stringify(filters) : undefined, "exclude-location-ids": excludeLocationIds ? JSON.stringify(excludeLocationIds) : undefined, "dialog-variant": dialogVariant, "page-mode-composer-variant": pageModeComposerVariant, "sidebar-shadow-dom": [true, false].includes(sidebarShadowDom) ? (sidebarShadowDom ? 'true' : 'false') : undefined, "sidebar-variant": sidebarVariant, position: position, "filter-panel-layout": filterPanelLayout }, children));
};

var VeltCommentsSidebarButton = function (props) {
    var tooltipText = props.tooltipText, children = props.children, darkMode = props.darkMode, shadowDom = props.shadowDom, floatingMode = props.floatingMode, pageMode = props.pageMode, sortData = props.sortData, urlNavigation = props.urlNavigation, currentLocationSuffix = props.currentLocationSuffix, filterConfig = props.filterConfig, groupConfig = props.groupConfig, filters = props.filters, excludeLocationIds = props.excludeLocationIds, dialogVariant = props.dialogVariant, pageModeComposerVariant = props.pageModeComposerVariant, sidebarShadowDom = props.sidebarShadowDom, sidebarVariant = props.sidebarVariant, position = props.position, onCommentClick = props.onCommentClick, onSidebarOpen = props.onSidebarOpen, filterPanelLayout = props.filterPanelLayout;
    var ref = useRef();
    var onSidebarOpenRef = useRef(onSidebarOpen);
    var onCommentClickRef = useRef(onCommentClick);
    useEffect(function () {
        onCommentClickRef.current = onCommentClick;
    }, [onCommentClick]);
    useEffect(function () {
        onSidebarOpenRef.current = onSidebarOpen;
    }, [onSidebarOpen]);
    useEffect(function () {
        var element;
        var handleSidebarOpen = function (event) {
            if (onSidebarOpenRef.current) {
                onSidebarOpenRef.current(event === null || event === void 0 ? void 0 : event.detail);
            }
        };
        var handleSidebarCommentClick = function (event) {
            if (onCommentClickRef.current) {
                onCommentClickRef.current(event === null || event === void 0 ? void 0 : event.detail);
            }
        };
        if (ref.current) {
            element = ref.current;
            if (element) {
                element.addEventListener('onSidebarOpen', handleSidebarOpen);
                element.addEventListener('onCommentClick', handleSidebarCommentClick);
            }
        }
        return function () {
            if (element) {
                element.removeEventListener('onSidebarOpen', handleSidebarOpen);
                element.removeEventListener('onCommentClick', handleSidebarCommentClick);
            }
        };
    });
    return (React.createElement("velt-comments-sidebar-button", { "tooltip-text": tooltipText, "shadow-dom": [true, false].includes(shadowDom) ? (shadowDom ? 'true' : 'false') : undefined, "dark-mode": [true, false].includes(darkMode) ? (darkMode ? 'true' : 'false') : undefined, "floating-mode": [true, false].includes(floatingMode) ? (floatingMode ? 'true' : 'false') : undefined, ref: ref, "page-mode": [true, false].includes(pageMode) ? (pageMode ? 'true' : 'false') : undefined, "sort-data": sortData, "url-navigation": [true, false].includes(urlNavigation) ? (urlNavigation ? 'true' : 'false') : undefined, "current-location-suffix": [true, false].includes(currentLocationSuffix) ? (currentLocationSuffix ? 'true' : 'false') : undefined, "filter-config": filterConfig ? JSON.stringify(filterConfig) : undefined, "group-config": groupConfig ? JSON.stringify(groupConfig) : undefined, filters: filters ? JSON.stringify(filters) : undefined, "exclude-location-ids": excludeLocationIds ? JSON.stringify(excludeLocationIds) : undefined, "dialog-variant": dialogVariant, "page-mode-composer-variant": pageModeComposerVariant, "sidebar-shadow-dom": [true, false].includes(sidebarShadowDom) ? (sidebarShadowDom ? 'true' : 'false') : undefined, "sidebar-variant": sidebarVariant, position: position, "filter-panel-layout": filterPanelLayout }, children));
};

var SnippylyTags = function (props) {
    var pinHighlighterClass = props.pinHighlighterClass;
    return (React.createElement("velt-tags", { "pin-highlighter-class": pinHighlighterClass }));
};

var SnippylyTagTool = function (props) {
    var targetTagElementId = props.targetTagElementId, children = props.children;
    return (React.createElement("velt-tag-tool", { "target-tag-element-id": targetTagElementId }, children));
};

var SnippylyArrows = function () {
    return (React.createElement("velt-arrows", null));
};

var SnippylyArrowTool = function (props) {
    var children = props.children, darkMode = props.darkMode;
    return (React.createElement("velt-arrow-tool", { "dark-mode": [true, false].includes(darkMode) ? (darkMode ? 'true' : 'false') : undefined }, children));
};

var SnippylyUserInviteTool = function (props) {
    var type = props.type, source = props.source, title = props.title, placeholder = props.placeholder, inviteUrl = props.inviteUrl, accessControlDropdown = props.accessControlDropdown, documentUserAccessList = props.documentUserAccessList, children = props.children, darkMode = props.darkMode;
    return (React.createElement("velt-user-invite-tool", { type: type, source: source, title: title, placeholder: placeholder, "invite-url": inviteUrl, "access-control-dropdown": [true, false].includes(accessControlDropdown) ? accessControlDropdown : undefined, "document-user-access-list": [true, false].includes(documentUserAccessList) ? documentUserAccessList : undefined, "dark-mode": [true, false].includes(darkMode) ? (darkMode ? 'true' : 'false') : undefined }, children));
};

var SnippylyUserRequestTool = function (props) {
    var type = props.type;
    return (React.createElement("velt-user-request-tool", { type: type }));
};

var VeltCommentPlayerTimeline = function (props) {
    var totalMediaLength = props.totalMediaLength, offset = props.offset, onCommentClick = props.onCommentClick, shadowDom = props.shadowDom, videoPlayerId = props.videoPlayerId, onReactionClick = props.onReactionClick;
    var ref = useRef();
    var onCommentClickRef = useRef(onCommentClick);
    var onReactionClickRef = useRef(onReactionClick);
    // Update the ref to always point to the latest callback function
    useEffect(function () {
        onCommentClickRef.current = onCommentClick;
    }, [onCommentClick]);
    useEffect(function () {
        onReactionClickRef.current = onReactionClick;
    }, [onReactionClick]);
    useEffect(function () {
        var element;
        var handleCommentClick = function (event) {
            if (onCommentClickRef.current) {
                onCommentClickRef.current(event === null || event === void 0 ? void 0 : event.detail);
            }
        };
        var handleReactionClick = function (event) {
            if (onReactionClickRef.current) {
                onReactionClickRef.current(event === null || event === void 0 ? void 0 : event.detail);
            }
        };
        if (ref.current) {
            element = ref.current;
            if (element) {
                element.addEventListener('onCommentClick', handleCommentClick);
                element.addEventListener('onReactionClick', handleReactionClick);
            }
        }
        return function () {
            if (element) {
                element.removeEventListener('onCommentClick', handleCommentClick);
                element.removeEventListener('onReactionClick', handleReactionClick);
            }
        };
    }, []);
    return (React.createElement("velt-comment-player-timeline", { ref: ref, "shadow-dom": [true, false].includes(shadowDom) ? (shadowDom ? 'true' : 'false') : undefined, "total-media-length": totalMediaLength, offset: offset, "video-player-id": videoPlayerId }));
};

var VeltVideoPlayer = function (props) {
    var darkMode = props.darkMode, src = props.src, sync = props.sync, commentTool = props.commentTool, shadowDom = props.shadowDom;
    return (React.createElement("velt-video-player", { "shadow-dom": [true, false].includes(shadowDom) ? (shadowDom ? 'true' : 'false') : undefined, src: src, "dark-mode": [true, false].includes(darkMode) ? (darkMode ? 'true' : 'false') : undefined, sync: [true, false].includes(sync) ? (sync ? 'true' : 'false') : undefined, "comment-tool": [true, false].includes(commentTool) ? (commentTool ? 'true' : 'false') : undefined }));
};

var VeltViewAnalytics = function (props) {
    var type = props.type, locationId = props.locationId;
    return (React.createElement("velt-view-analytics", { type: type, "location-id": locationId }));
};

var VeltCommentThread = function (props) {
    var annotationId = props.annotationId, annotation = props.annotation, onCommentClick = props.onCommentClick, darkMode = props.darkMode, variant = props.variant, shadowDom = props.shadowDom, dialogVariant = props.dialogVariant, fullExpanded = props.fullExpanded;
    var ref = useRef();
    var onCommentClickRef = useRef(onCommentClick);
    useEffect(function () {
        onCommentClickRef.current = onCommentClick;
    }, [onCommentClick]);
    useEffect(function () {
        var element;
        var handleCommentClick = function (event) {
            if (onCommentClickRef.current) {
                onCommentClickRef.current(event === null || event === void 0 ? void 0 : event.detail);
            }
        };
        if (ref.current) {
            element = ref.current;
            if (element) {
                element.addEventListener('onCommentClick', handleCommentClick);
            }
        }
        return function () {
            if (element) {
                element.removeEventListener('onCommentClick', handleCommentClick);
            }
        };
    }, []);
    return (React.createElement("velt-comment-thread", { ref: ref, "annotation-id": annotationId, annotation: annotation ? JSON.stringify(annotation) : undefined, variant: variant, "dialog-variant": dialogVariant, "shadow-dom": [true, false].includes(shadowDom) ? (shadowDom ? 'true' : 'false') : undefined, "dark-mode": [true, false].includes(darkMode) ? (darkMode ? 'true' : 'false') : undefined, "full-expanded": [true, false].includes(fullExpanded) ? (fullExpanded ? 'true' : 'false') : undefined }));
};

var VeltNotificationsTool = function (props) {
    var children = props.children, darkMode = props.darkMode, onNotificationClick = props.onNotificationClick, shadowDom = props.shadowDom, panelShadowDom = props.panelShadowDom, variant = props.variant, maxDays = props.maxDays, tabConfig = props.tabConfig, panelOpenMode = props.panelOpenMode, panelVariant = props.panelVariant, readNotificationsOnForYouTab = props.readNotificationsOnForYouTab;
    var ref = useRef();
    var onNotificationClickRef = useRef(onNotificationClick);
    // Update the ref to always point to the latest callback function
    useEffect(function () {
        onNotificationClickRef.current = onNotificationClick;
    }, [onNotificationClick]);
    useEffect(function () {
        var element;
        var handleNotificationClick = function (event) {
            if (onNotificationClickRef.current) {
                onNotificationClickRef.current(event === null || event === void 0 ? void 0 : event.detail);
            }
        };
        if (ref.current) {
            element = ref.current;
            if (element) {
                element === null || element === void 0 ? void 0 : element.addEventListener('onNotificationClick', handleNotificationClick);
            }
        }
        return function () {
            if (element) {
                element === null || element === void 0 ? void 0 : element.removeEventListener('onNotificationClick', handleNotificationClick);
            }
        };
    }, []);
    return (React.createElement("velt-notifications-tool", { ref: ref, "panel-open-mode": panelOpenMode, panelVariant: panelVariant, "tab-config": JSON.stringify(tabConfig), variant: variant, "max-days": (maxDays && maxDays > 0) ? maxDays + '' : undefined, "panel-shadow-dom": [true, false].includes(panelShadowDom) ? (panelShadowDom ? 'true' : 'false') : undefined, "shadow-dom": [true, false].includes(shadowDom) ? (shadowDom ? 'true' : 'false') : undefined, "dark-mode": [true, false].includes(darkMode) ? (darkMode ? 'true' : 'false') : undefined, "read-notifications-on-for-you-tab": [true, false].includes(readNotificationsOnForYouTab) ? (readNotificationsOnForYouTab ? 'true' : 'false') : undefined }, children));
};

var VeltNotificationsPanel = function (props) {
    var darkMode = props.darkMode, onNotificationClick = props.onNotificationClick, shadowDom = props.shadowDom, tabConfig = props.tabConfig, variant = props.variant, readNotificationsOnForYouTab = props.readNotificationsOnForYouTab;
    var ref = useRef();
    var onNotificationClickRef = useRef(onNotificationClick);
    // Update the ref to always point to the latest callback function
    useEffect(function () {
        onNotificationClickRef.current = onNotificationClick;
    }, [onNotificationClick]);
    useEffect(function () {
        var element;
        var handleNotificationClick = function (event) {
            if (onNotificationClickRef.current) {
                onNotificationClickRef.current(event === null || event === void 0 ? void 0 : event.detail);
            }
        };
        if (ref.current) {
            element = ref.current;
            if (element) {
                element === null || element === void 0 ? void 0 : element.addEventListener('onNotificationClick', handleNotificationClick);
            }
        }
        return function () {
            if (element) {
                element === null || element === void 0 ? void 0 : element.removeEventListener('onNotificationClick', handleNotificationClick);
            }
        };
    }, []);
    return (React.createElement("velt-notifications-panel", { ref: ref, variant: variant, "tab-config": JSON.stringify(tabConfig), "shadow-dom": [true, false].includes(shadowDom) ? (shadowDom ? 'true' : 'false') : undefined, "dark-mode": [true, false].includes(darkMode) ? (darkMode ? 'true' : 'false') : undefined, "read-notifications-on-for-you-tab": [true, false].includes(readNotificationsOnForYouTab) ? (readNotificationsOnForYouTab ? 'true' : 'false') : undefined }));
};

var VeltNotificationsHistoryPanel = function (props) {
    var embedMode = props.embedMode, darkMode = props.darkMode, onNotificationClick = props.onNotificationClick;
    var ref = useRef();
    var onNotificationClickRef = useRef(onNotificationClick);
    // Update the ref to always point to the latest callback function
    useEffect(function () {
        onNotificationClickRef.current = onNotificationClick;
    }, [onNotificationClick]);
    useEffect(function () {
        var element;
        var handleNotificationClick = function (event) {
            if (onNotificationClickRef.current) {
                onNotificationClickRef.current(event === null || event === void 0 ? void 0 : event.detail);
            }
        };
        if (ref.current) {
            element = ref.current;
            if (element) {
                element === null || element === void 0 ? void 0 : element.addEventListener('onNotificationClick', handleNotificationClick);
            }
        }
        return function () {
            if (element) {
                element === null || element === void 0 ? void 0 : element.removeEventListener('onNotificationClick', handleNotificationClick);
            }
        };
    }, []);
    return (React.createElement("velt-notifications-history-panel", { ref: ref, "embed-mode": [true, false].includes(embedMode) ? (embedMode ? 'true' : 'false') : undefined, "dark-mode": [true, false].includes(darkMode) ? (darkMode ? 'true' : 'false') : undefined }));
};

var VeltChartComment = function (props) {
    var commentMetadata = props.commentMetadata, dialogMetadataTemplate = props.dialogMetadataTemplate, children = props.children, ghostComment = props.ghostComment;
    return (React.createElement("velt-chart-comment", { "comment-metadata": commentMetadata ? JSON.stringify(commentMetadata) : undefined, "dialog-metadata-template": (dialogMetadataTemplate === null || dialogMetadataTemplate === void 0 ? void 0 : dialogMetadataTemplate.length) ? JSON.stringify(dialogMetadataTemplate) : undefined, "ghost-comment": [true, false].includes(ghostComment) ? (ghostComment ? 'true' : 'false') : undefined }, children));
};

var VeltNivoChartComments = function (_a) {
    var _b, _c, _d, _e, _f;
    var chartComputedData = _a.chartComputedData, dialogMetadataTemplate = _a.dialogMetadataTemplate, id = _a.id;
    var client = useVeltClient().client;
    var _g = React.useState({ comments: [] }), ghostCommentsData = _g[0], setGhostCommentsData = _g[1];
    var _h = React.useState(null), documentPathsSubscription = _h[0], setDocumentPathsSubscription = _h[1];
    var _j = React.useState(null), commentSubscription = _j[0], setCommentSubscription = _j[1];
    // Unsubscribe from the subscriptions when the component is unmounted
    useEffect(function () {
        return function () {
            unsubscribeDocumentPathsSubscription();
            unsubscribeCommentSubscription();
        };
    }, []);
    useEffect(function () {
        getCommentAnnotations();
    }, [chartComputedData === null || chartComputedData === void 0 ? void 0 : chartComputedData.data]);
    useEffect(function () {
        if (client) {
            getCommentAnnotations();
        }
    }, [client]);
    var getCommentAnnotations = function () {
        var _a;
        try {
            unsubscribeDocumentPathsSubscription();
            unsubscribeCommentSubscription();
            if (client) {
                var subscription = (_a = client === null || client === void 0 ? void 0 : client.docService) === null || _a === void 0 ? void 0 : _a.getDocumentPaths$().subscribe(function (paths) {
                    var _a;
                    if (paths === null || paths === void 0 ? void 0 : paths.clientDocumentId) {
                        unsubscribeCommentSubscription();
                        var commentElement = client.getCommentElement();
                        var subscription_1 = (_a = commentElement === null || commentElement === void 0 ? void 0 : commentElement.getAllCommentAnnotations(paths === null || paths === void 0 ? void 0 : paths.clientDocumentId)) === null || _a === void 0 ? void 0 : _a.subscribe(function (comments) {
                            filterGhostComments(comments);
                        });
                        setCommentSubscription(subscription_1);
                    }
                });
                setDocumentPathsSubscription(subscription);
            }
        }
        catch (err) {
        }
    };
    var filterGhostComments = function (comments) {
        var _a, _b, _c;
        try {
            var chartComments = (_a = comments === null || comments === void 0 ? void 0 : comments.filter(function (annotation) { return annotation.commentType === 'chart'; })) === null || _a === void 0 ? void 0 : _a.filter(function (annotation) { var _a; return ((_a = annotation === null || annotation === void 0 ? void 0 : annotation.metadata) === null || _a === void 0 ? void 0 : _a.id) === id; });
            if ((_b = chartComputedData === null || chartComputedData === void 0 ? void 0 : chartComputedData.bars) === null || _b === void 0 ? void 0 : _b.length) {
                var ghostComments_1 = [];
                chartComments.forEach(function (annotation) {
                    var _a;
                    var metadata = annotation.metadata;
                    var groupId = metadata === null || metadata === void 0 ? void 0 : metadata.groupId;
                    var value = metadata === null || metadata === void 0 ? void 0 : metadata.value;
                    var label = metadata === null || metadata === void 0 ? void 0 : metadata.label;
                    if (groupId && value && label) {
                        var bar = (_a = chartComputedData.bars) === null || _a === void 0 ? void 0 : _a.find(function (bar) { var _a, _b, _c; return ((_a = bar === null || bar === void 0 ? void 0 : bar.data) === null || _a === void 0 ? void 0 : _a.id) === groupId && ((_b = bar === null || bar === void 0 ? void 0 : bar.data) === null || _b === void 0 ? void 0 : _b.value) === value && ((_c = bar === null || bar === void 0 ? void 0 : bar.data) === null || _c === void 0 ? void 0 : _c.indexValue) === label; });
                        if (!bar) {
                            ghostComments_1.push(annotation);
                        }
                    }
                });
                var width = ((_c = chartComputedData === null || chartComputedData === void 0 ? void 0 : chartComputedData.bars[0]) === null || _c === void 0 ? void 0 : _c.width) || 0;
                setGhostCommentsData({ comments: ghostComments_1, width: width, type: 'bar' });
            }
            else if (chartComputedData === null || chartComputedData === void 0 ? void 0 : chartComputedData.points) {
                var ghostComments_2 = [];
                chartComments.forEach(function (annotation) {
                    var _a;
                    var metadata = annotation.metadata;
                    var groupId = metadata === null || metadata === void 0 ? void 0 : metadata.groupId;
                    var value = metadata === null || metadata === void 0 ? void 0 : metadata.value;
                    var label = metadata === null || metadata === void 0 ? void 0 : metadata.label;
                    if (groupId && value && label) {
                        var point = (_a = chartComputedData.points) === null || _a === void 0 ? void 0 : _a.find(function (point) { var _a, _b; return (point === null || point === void 0 ? void 0 : point.serieId) === groupId && ((_a = point === null || point === void 0 ? void 0 : point.data) === null || _a === void 0 ? void 0 : _a.y) === value && ((_b = point === null || point === void 0 ? void 0 : point.data) === null || _b === void 0 ? void 0 : _b.x) === label; });
                        if (!point) {
                            ghostComments_2.push(annotation);
                        }
                    }
                });
                var width = 0;
                setGhostCommentsData({ comments: ghostComments_2, width: width, type: 'line' });
            }
        }
        catch (err) {
        }
    };
    var polarToCartesian = function (centerX, centerY, radius, angleInRadians) {
        return {
            x: centerX + radius * Math.cos(angleInRadians - Math.PI / 2),
            y: centerY + radius * Math.sin(angleInRadians - Math.PI / 2)
        };
    };
    var unsubscribeDocumentPathsSubscription = function () {
        try {
            if (documentPathsSubscription) {
                documentPathsSubscription === null || documentPathsSubscription === void 0 ? void 0 : documentPathsSubscription.unsubscribe();
            }
        }
        catch (err) {
        }
    };
    var unsubscribeCommentSubscription = function () {
        try {
            if (commentSubscription) {
                commentSubscription === null || commentSubscription === void 0 ? void 0 : commentSubscription.unsubscribe();
            }
        }
        catch (err) {
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("foreignObject", null,
            React.createElement("style", null, "\n                        .nivo-chart-comment-point {\n                            opacity: 0 !important;\n                            visibility: hidden !important;\n                          }\n                          \n                          .nivo-chart-comment-tool {\n                            opacity: 0;\n                          }\n                          \n                          .nivo-chart-comment-tool:hover {\n                            opacity: 1;\n                            visibility: visible;\n                            transition: 0.3s;\n                          }\n                          \n                          .nivo-chart-comment-container {\n                            position: relative;\n                            display: flex;\n                            flex-direction: column;\n                            align-items: center;\n                            justify-content: center;\n                            width: 100%;\n                            height: 100%;\n                          }\n                          \n                          .nivo-chart-comment-container velt-comment-tool {\n                            display: flex;\n                            cursor: pointer;\n                          }\n                          \n                          .nivo-chart-container snippyly-comment-pin-portal {\n                              /* hide it */\n                              display: none;\n                          }\n                    ")),
        ((_b = chartComputedData === null || chartComputedData === void 0 ? void 0 : chartComputedData.points) === null || _b === void 0 ? void 0 : _b.length) && chartComputedData.points.map(function (point, index) {
            var _a, _b;
            var commentMetadata = {
                id: id,
                label: (_a = point === null || point === void 0 ? void 0 : point.data) === null || _a === void 0 ? void 0 : _a.x,
                groupId: point === null || point === void 0 ? void 0 : point.serieId,
                value: (_b = point === null || point === void 0 ? void 0 : point.data) === null || _b === void 0 ? void 0 : _b.y,
            };
            return (React.createElement("g", { transform: "translate(".concat(point.x, ", ").concat(point.y, ")"), key: point.id },
                React.createElement("foreignObject", { x: -12, y: -40, width: "24", height: "24" },
                    React.createElement("div", { className: 'nivo-chart-comment-container' },
                        React.createElement(VeltChartComment, { commentMetadata: commentMetadata, dialogMetadataTemplate: dialogMetadataTemplate || ['groupId', 'label', 'value'] })))));
        }),
        ((_c = chartComputedData === null || chartComputedData === void 0 ? void 0 : chartComputedData.bars) === null || _c === void 0 ? void 0 : _c.length) && chartComputedData.bars.map(function (point, index) {
            var _a, _b, _c;
            var commentMetadata = {
                id: id,
                label: (_a = point === null || point === void 0 ? void 0 : point.data) === null || _a === void 0 ? void 0 : _a.indexValue,
                groupId: (_b = point === null || point === void 0 ? void 0 : point.data) === null || _b === void 0 ? void 0 : _b.id,
                value: (_c = point === null || point === void 0 ? void 0 : point.data) === null || _c === void 0 ? void 0 : _c.value,
            };
            return (React.createElement("g", { transform: "translate(".concat(point.x + point.width, ", ").concat(point.y, ")"), key: point.key },
                React.createElement("foreignObject", { x: 0, y: -8, width: "24", height: "24" },
                    React.createElement("div", { className: 'nivo-chart-comment-container' },
                        React.createElement(VeltChartComment, { commentMetadata: commentMetadata, dialogMetadataTemplate: dialogMetadataTemplate || ['groupId', 'label', 'value'] })))));
        }),
        ((_d = chartComputedData === null || chartComputedData === void 0 ? void 0 : chartComputedData.dataWithArc) === null || _d === void 0 ? void 0 : _d.length) && chartComputedData.dataWithArc.map(function (arcData, index) {
            var midAngle = (arcData.arc.startAngle + arcData.arc.endAngle) / 2;
            var radiusOffset = 20; // Extend beyond the outer radius for visibility
            var position = polarToCartesian(chartComputedData.centerX, chartComputedData.centerY, arcData.arc.outerRadius + radiusOffset, midAngle);
            var commentMetadata = {
                id: id,
                label: arcData === null || arcData === void 0 ? void 0 : arcData.label,
                value: arcData === null || arcData === void 0 ? void 0 : arcData.value,
            };
            return (React.createElement("g", { transform: "translate(".concat(position.x, ", ").concat(position.y, ")"), key: arcData.id },
                React.createElement("foreignObject", { width: "100", height: "50", x: "-50", y: "-25", style: { overflow: 'visible' } },
                    React.createElement("div", { className: 'nivo-chart-comment-container' },
                        React.createElement(VeltChartComment, { commentMetadata: commentMetadata, dialogMetadataTemplate: dialogMetadataTemplate || ['label', 'value'] })))));
        }),
        ((_e = ghostCommentsData === null || ghostCommentsData === void 0 ? void 0 : ghostCommentsData.comments) === null || _e === void 0 ? void 0 : _e.length) && ((_f = ghostCommentsData === null || ghostCommentsData === void 0 ? void 0 : ghostCommentsData.comments) === null || _f === void 0 ? void 0 : _f.map(function (annotation) {
            var metadata = annotation.metadata;
            var groupId = metadata === null || metadata === void 0 ? void 0 : metadata.groupId;
            var value = metadata === null || metadata === void 0 ? void 0 : metadata.value;
            var label = metadata === null || metadata === void 0 ? void 0 : metadata.label;
            var x = (chartComputedData === null || chartComputedData === void 0 ? void 0 : chartComputedData.xScale) ? chartComputedData.xScale(label) : 0;
            var y = (chartComputedData === null || chartComputedData === void 0 ? void 0 : chartComputedData.yScale) ? chartComputedData.yScale(value) : 0;
            var point = { x: x, y: y, width: (ghostCommentsData === null || ghostCommentsData === void 0 ? void 0 : ghostCommentsData.width) || 0, key: annotation.annotationId };
            var commentMetadata = {
                id: id,
                label: label,
                groupId: groupId,
                value: value,
            };
            switch (ghostCommentsData === null || ghostCommentsData === void 0 ? void 0 : ghostCommentsData.type) {
                case 'bar':
                    return (React.createElement("g", { transform: "translate(".concat(point.x + point.width, ", ").concat(point.y, ")"), key: point.key },
                        React.createElement("foreignObject", { x: 0, y: -8, width: "24", height: "24" },
                            React.createElement("div", { className: 'nivo-chart-comment-container' },
                                React.createElement(VeltChartComment, { ghostComment: true, commentMetadata: commentMetadata, dialogMetadataTemplate: dialogMetadataTemplate || ['groupId', 'label', 'value'] })))));
                case 'line':
                    return (React.createElement("g", { transform: "translate(".concat(point.x + point.width, ", ").concat(point.y, ")"), key: point.key },
                        React.createElement("foreignObject", { x: -12, y: -48, width: "24", height: "24" },
                            React.createElement("div", { className: 'nivo-chart-comment-container' },
                                React.createElement(VeltChartComment, { ghostComment: true, commentMetadata: commentMetadata, dialogMetadataTemplate: dialogMetadataTemplate || ['groupId', 'label', 'value'] })))));
                default:
                    return null;
            }
        }))));
};

var VeltHighChartComments = function (_a) {
    var chartComputedData = _a.chartComputedData, id = _a.id, dialogMetadataTemplate = _a.dialogMetadataTemplate, Highcharts = _a.Highcharts;
    var _b = useState([]), points = _b[0], setPoints = _b[1];
    var _c = useState([]), ghostPoints = _c[0], setGhostPoints = _c[1];
    var chartRef = useRef(chartComputedData);
    var commentsRef = useRef([]);
    var client = useVeltClient().client;
    var _d = React.useState(null), documentPathsSubscription = _d[0], setDocumentPathsSubscription = _d[1];
    var _e = useState(null), commentSubscription = _e[0], setCommentSubscription = _e[1];
    // Unsubscribe from the subscriptions when the component is unmounted
    useEffect(function () {
        return function () {
            unsubscribeDocumentPathsSubscription();
            unsubscribeCommentSubscription();
        };
    }, []);
    useEffect(function () {
        if (client) {
            getCommentAnnotations();
        }
    }, [client]);
    var getCommentAnnotations = function () {
        var _a;
        try {
            unsubscribeDocumentPathsSubscription();
            unsubscribeCommentSubscription();
            if (client) {
                var subscription = (_a = client === null || client === void 0 ? void 0 : client.docService) === null || _a === void 0 ? void 0 : _a.getDocumentPaths$().subscribe(function (paths) {
                    var _a;
                    if (paths === null || paths === void 0 ? void 0 : paths.clientDocumentId) {
                        unsubscribeCommentSubscription();
                        var commentElement = client.getCommentElement();
                        var subscription_1 = (_a = commentElement === null || commentElement === void 0 ? void 0 : commentElement.getAllCommentAnnotations(paths === null || paths === void 0 ? void 0 : paths.clientDocumentId)) === null || _a === void 0 ? void 0 : _a.subscribe(function (comments) {
                            commentsRef.current = comments;
                            filterGhostComments(comments);
                        });
                        setCommentSubscription(subscription_1);
                    }
                });
                setDocumentPathsSubscription(subscription);
            }
        }
        catch (err) {
        }
    };
    var filterGhostComments = function (comments) {
        var _a;
        try {
            var chartComments = (_a = comments === null || comments === void 0 ? void 0 : comments.filter(function (annotation) { return annotation.commentType === 'chart'; })) === null || _a === void 0 ? void 0 : _a.filter(function (annotation) { var _a; return ((_a = annotation === null || annotation === void 0 ? void 0 : annotation.metadata) === null || _a === void 0 ? void 0 : _a.id) === id; });
            var ghostPoints_1 = [];
            chartComments.forEach(function (annotation) {
                var metadata = annotation.metadata;
                var groupId = metadata === null || metadata === void 0 ? void 0 : metadata.groupId;
                var value = metadata === null || metadata === void 0 ? void 0 : metadata.value;
                var label = metadata === null || metadata === void 0 ? void 0 : metadata.label;
                if (groupId && value && label) {
                    var series = chartRef.current.chart.series.find(function (series) { return series.name === groupId; });
                    if (series === null || series === void 0 ? void 0 : series.visible) {
                        switch (series.type) {
                            case 'line':
                                var linePoint = series.points.find(function (point) { return point.y === value && point.x === label; });
                                if (!linePoint) {
                                    var x = series.xAxis.toPixels(label, true);
                                    var y = series.yAxis.toPixels(value, true);
                                    ghostPoints_1.push({
                                        x: x,
                                        y: y,
                                        seriesName: groupId,
                                        yValue: value,
                                        transform: 'translate(-50%, -150%)',
                                        id: "".concat(groupId, "-").concat(label, "-").concat(value),
                                        metadata: {
                                            id: id,
                                            groupId: groupId,
                                            label: label,
                                            value: value,
                                        },
                                    });
                                }
                                break;
                            case 'bar':
                            case 'column':
                                var barPoint = series.points.find(function (point) { return point.y === value && point.category === label; });
                                if (!barPoint) {
                                    var categoryIndex = series.xAxis.categories.indexOf(label);
                                    var x = series.xAxis.toPixels(categoryIndex, true);
                                    var y = series.yAxis.toPixels(value, true);
                                    // const width = series.xAxis.toPixels(categoryIndex + 1, true) - x;
                                    ghostPoints_1.push({
                                        x: x,
                                        y: y,
                                        seriesName: groupId,
                                        yValue: value,
                                        id: "".concat(groupId, "-").concat(label, "-").concat(value),
                                        // width: width,
                                        transform: 'translate(-50%, -100%)',
                                        metadata: {
                                            id: id,
                                            groupId: groupId,
                                            label: label,
                                            value: value,
                                        },
                                    });
                                }
                        }
                    }
                }
            });
            setGhostPoints(ghostPoints_1);
        }
        catch (err) {
        }
    };
    useEffect(function () {
        // Attach the redraw event listener when the chart updates
        if (chartRef.current && chartRef.current.chart) {
            var currentChart_1 = chartRef.current.chart;
            window.chart = currentChart_1;
            // Define the callback to execute on chart redraw
            var onRedraw_1 = function () {
                calculatePoints();
                filterGhostComments(commentsRef.current);
            };
            if (Highcharts) {
                // Attach the event listener
                Highcharts.addEvent(currentChart_1, 'redraw', onRedraw_1);
            }
            // Perform the initial calculation
            calculatePoints();
            // Clean up the event listener when the component unmounts or chart changes
            return function () {
                if (Highcharts) {
                    Highcharts.removeEvent(currentChart_1, 'redraw', onRedraw_1);
                }
            };
        }
    }, [chartComputedData]);
    var calculatePoints = function (from) {
        var _a, _b;
        if (!((_b = (_a = chartRef.current) === null || _a === void 0 ? void 0 : _a.chart) === null || _b === void 0 ? void 0 : _b.series)) {
            return;
        }
        // Create an array of points from all series
        var newPoints = chartRef.current.chart.series.filter(function (series) { return series.visible; }).reduce(function (acc, series) {
            var seriesPoints = [];
            switch (series.type) {
                case 'line':
                    seriesPoints = series.points.map(function (point) { return ({
                        x: point.plotX,
                        y: point.plotY,
                        seriesName: series.name,
                        yValue: point.y,
                        transform: 'translate(-50%, -150%)',
                        id: "".concat(series.name, "-").concat(point.x, "-").concat(point.y),
                        metadata: {
                            id: id,
                            groupId: series.name,
                            label: point.x,
                            value: point.y,
                        },
                    }); });
                    break;
                case 'bar':
                case 'column':
                    seriesPoints = series.points.map(function (point) {
                        var _a, _b, _c, _d, _e, _f, _g;
                        var x = (_a = point.shapeArgs) === null || _a === void 0 ? void 0 : _a.x;
                        var y = (_b = point.shapeArgs) === null || _b === void 0 ? void 0 : _b.y;
                        var transform = 'translate(-50%, -100%)';
                        var width = (_c = point.shapeArgs) === null || _c === void 0 ? void 0 : _c.width;
                        (_d = point.shapeArgs) === null || _d === void 0 ? void 0 : _d.height;
                        if (series.type === 'column') {
                            // Center horizontally for columns
                            x += point.shapeArgs.width / 2;
                        }
                        else if (series.type === 'bar') {
                            // Center vertically for bars
                            // y += point.shapeArgs!.height / 2;
                            x = (_e = point.shapeArgs) === null || _e === void 0 ? void 0 : _e.brBoxHeight;
                            transform = null;
                            (_f = point.shapeArgs) === null || _f === void 0 ? void 0 : _f.width;
                            width = null;
                            // y = (point.shapeArgs?.x! / 2) + (point.shapeArgs?.width! / 2);
                            // x = point.plotX! - (point?.shapeArgs?.width! / 2);
                            y = (_g = point.shapeArgs) === null || _g === void 0 ? void 0 : _g.x;
                        }
                        return {
                            x: x,
                            y: y,
                            seriesName: series.name,
                            yValue: point.y,
                            id: "".concat(series.name, "-").concat(point.x, "-").concat(point.y),
                            width: width,
                            // height: height,
                            transform: transform,
                            metadata: {
                                id: id,
                                groupId: series.name,
                                label: point.category,
                                value: point.y,
                            },
                        };
                    });
                    break;
            }
            return __spreadArray(__spreadArray([], acc, true), seriesPoints, true);
        }, []);
        setPoints(newPoints);
    };
    var unsubscribeDocumentPathsSubscription = function () {
        try {
            if (documentPathsSubscription) {
                documentPathsSubscription === null || documentPathsSubscription === void 0 ? void 0 : documentPathsSubscription.unsubscribe();
            }
        }
        catch (err) {
        }
    };
    var unsubscribeCommentSubscription = function () {
        try {
            if (commentSubscription) {
                commentSubscription === null || commentSubscription === void 0 ? void 0 : commentSubscription.unsubscribe();
            }
        }
        catch (err) {
        }
    };
    return (React.createElement("div", { className: 'velt-chart-comments-container', style: {
            zIndex: 100000,
            position: 'absolute',
            top: 0,
            left: 0,
        } },
        React.createElement("style", null, "\n                        .velt-chart-comments-container .point-container {\n                            opacity: 0 !important;\n                            visibility: hidden !important;\n                        }\n                    "),
        points.map(function (point, index) { return (React.createElement("div", { key: index, style: {
                position: 'absolute',
                left: "".concat(chartRef.current.chart.plotLeft + point.x, "px"),
                top: "".concat(chartRef.current.chart.plotTop + point.y, "px"),
                transform: point.transform,
                padding: '2px 5px',
                color: '#fff',
                borderRadius: '3px',
                fontSize: '10px',
                width: "".concat(point.width, "px"),
                height: "".concat(point.height, "px"),
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                userSelect: 'none',
                boxSizing: 'border-box',
            } },
            React.createElement(VeltChartComment, { commentMetadata: point.metadata, dialogMetadataTemplate: dialogMetadataTemplate || point.dialogMetadataTemplate || ['groupId', 'label', 'value'] }))); }),
        ghostPoints.map(function (point, index) { return (React.createElement("div", { id: point.id, key: index, style: {
                position: 'absolute',
                left: "".concat(chartRef.current.chart.plotLeft + point.x, "px"),
                top: "".concat(chartRef.current.chart.plotTop + point.y, "px"),
                transform: point.transform,
                padding: '2px 5px',
                color: '#fff',
                borderRadius: '3px',
                fontSize: '10px',
                width: "".concat(point.width, "px"),
                height: "".concat(point.height, "px"),
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                userSelect: 'none',
                boxSizing: 'border-box',
            } },
            React.createElement(VeltChartComment, { ghostComment: true, commentMetadata: point.metadata, dialogMetadataTemplate: dialogMetadataTemplate || point.dialogMetadataTemplate || ['groupId', 'label', 'value'] }))); })));
};

var VeltAutocomplete = function (props) {
    var hotkey = props.hotkey, listData = props.listData;
    return (React.createElement("velt-autocomplete", { hotkey: hotkey, "list-data": (typeof listData === 'object') ? JSON.stringify(listData) : undefined }));
};

var VeltInlineCommentsSection = function (props) {
    var config = props.config, children = props.children, darkMode = props.darkMode, variant = props.variant, shadowDom = props.shadowDom, dialogVariant = props.dialogVariant, targetInlineCommentElementId = props.targetInlineCommentElementId, targetCommentElementId = props.targetCommentElementId, targetElementId = props.targetElementId, multiThread = props.multiThread, sortData = props.sortData, composerVariant = props.composerVariant, composerPosition = props.composerPosition, sortBy = props.sortBy, sortOrder = props.sortOrder, fullExpanded = props.fullExpanded;
    return (React.createElement("velt-inline-comments-section", { "target-inline-comment-element-id": targetInlineCommentElementId, "target-comment-element-id": targetCommentElementId, "target-element-id": targetElementId, config: JSON.stringify(config), variant: variant, "dialog-variant": dialogVariant, "sort-data": sortData, "shadow-dom": [true, false].includes(shadowDom) ? (shadowDom ? 'true' : 'false') : undefined, "dark-mode": [true, false].includes(darkMode) ? (darkMode ? 'true' : 'false') : undefined, "multi-thread": [true, false].includes(multiThread) ? (multiThread ? 'true' : 'false') : undefined, "composer-variant": composerVariant, "composer-position": composerPosition, "sort-by": sortBy, "sort-order": sortOrder, "full-expanded": [true, false].includes(fullExpanded) ? (fullExpanded ? 'true' : 'false') : undefined }, children));
};

var VeltCommentPin = function (props) {
    var children = props.children, annotationId = props.annotationId, multiThreadAnnotationId = props.multiThreadAnnotationId, variant = props.variant;
    return (React.createElement("velt-comment-pin", { "annotation-id": annotationId, "multi-thread-annotation-id": multiThreadAnnotationId, variant: variant }, children));
};

var VeltCommentText = function (props) {
    var children = props.children, annotationId = props.annotationId, multiThreadAnnotationId = props.multiThreadAnnotationId;
    return (React.createElement("velt-comment-text", { "annotation-id": annotationId, "multi-thread-annotation-id": multiThreadAnnotationId }, children));
};

var VeltCanvasComment = function (props) {
    var children = props.children, canvasId = props.canvasId, position = props.position;
    return (React.createElement("velt-canvas-comment", { "canvas-id": canvasId, position: JSON.stringify(position) }, children));
};

var VeltData = function (props) {
    var path = props.path, field = props.field;
    var ref = useRef();
    return (React.createElement("velt-data", { ref: ref, path: path, field: field }));
};

var VeltIf = function (props) {
    var condition = props.condition, children = props.children;
    var ref = useRef();
    return (React.createElement("velt-if", { ref: ref, condition: condition }, children));
};

var VeltCommentsMinimap = function (props) {
    var position = props.position, targetScrollableElementId = props.targetScrollableElementId;
    return (React.createElement("velt-comments-minimap", { position: position, "target-scrollable-element-id": targetScrollableElementId }));
};

var VeltReactionTool = function (props) {
    var videoPlayerId = props.videoPlayerId, onReactionToolClick = props.onReactionToolClick;
    var ref = useRef();
    var onReactionToolClickRef = useRef(onReactionToolClick);
    useEffect(function () {
        onReactionToolClickRef.current = onReactionToolClick;
    }, [onReactionToolClick]);
    useEffect(function () {
        var element;
        var handleReactionToolClick = function (event) {
            if (onReactionToolClickRef.current) {
                onReactionToolClickRef.current(event === null || event === void 0 ? void 0 : event.detail);
            }
        };
        if (ref.current) {
            element = ref.current;
            if (element) {
                element.addEventListener('onReactionToolClick', handleReactionToolClick);
            }
        }
        return function () {
            if (element) {
                element.removeEventListener('onReactionToolClick', handleReactionToolClick);
            }
        };
    }, []);
    return (React.createElement("velt-reaction-tool", { ref: ref, "video-player-id": videoPlayerId }));
};

var VeltInlineReactionsSection = function (props) {
    var children = props.children, darkMode = props.darkMode, variant = props.variant, shadowDom = props.shadowDom, targetReactionElementId = props.targetReactionElementId, customReactions = props.customReactions;
    return (React.createElement("velt-inline-reactions-section", { "target-reaction-element-id": targetReactionElementId, variant: variant, "custom-reactions": JSON.stringify(customReactions), "shadow-dom": [true, false].includes(shadowDom) ? (shadowDom ? 'true' : 'false') : undefined, "dark-mode": [true, false].includes(darkMode) ? (darkMode ? 'true' : 'false') : undefined }, children));
};

var VeltCommentComposer = function (props) {
    var darkMode = props.darkMode, variant = props.variant, shadowDom = props.shadowDom, dialogVariant = props.dialogVariant;
    return (React.createElement("velt-comment-composer", { variant: variant, "dialog-variant": dialogVariant, "shadow-dom": [true, false].includes(shadowDom) ? (shadowDom ? 'true' : 'false') : undefined, "dark-mode": [true, false].includes(darkMode) ? (darkMode ? 'true' : 'false') : undefined }));
};

var VeltWireframe = function (props) {
    var children = props.children;
    return (React.createElement("velt-wireframe", { style: { display: 'none' } }, children));
};

var validProps = ['veltIf', 'veltClass', 'className'];
var transformWireframeProps = function (props) {
    try {
        var transformedProps_1 = {};
        Object.entries(props).forEach(function (_a) {
            var key = _a[0], value = _a[1];
            if (key === 'children' || key === 'ref' || !validProps.includes(key)) {
                transformedProps_1[key] = value;
                return;
            }
            if (key === 'className') {
                transformedProps_1['class'] = value;
                return;
            }
            // Convert camelCase to dash-case
            var dashKey = key.replace(/[A-Z]/g, function (letter) { return "-".concat(letter.toLowerCase()); });
            transformedProps_1[dashKey] = value;
            // // Handle boolean values - only convert if explicitly true/false
            // if (typeof value === 'boolean') {
            //     transformedProps[dashKey] = [true, false].includes(value) ? (value ? 'true' : 'false') : undefined;
            // } else {
            //     transformedProps[dashKey] = value;
            // }
        });
        return transformedProps_1;
    }
    catch (error) {
        return props;
    }
};

var VeltCommentDialogAllComment = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-all-comment-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentDialogApprove = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-approve-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentDialogAssignMenu = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-assign-menu-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentDialogAssigneeBannerResolveButton = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-assignee-banner-resolve-button-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentDialogAssigneeBannerUserAvatar = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-assignee-banner-user-avatar-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentDialogAssigneeBannerUserName = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-assignee-banner-user-name-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentDialogAssigneeBannerUnresolveButton = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-assignee-banner-unresolve-button-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentDialogAssigneeBanner = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-assignee-banner-wireframe", __assign({}, transformedProps), children));
};
VeltCommentDialogAssigneeBanner.ResolveButton = VeltCommentDialogAssigneeBannerResolveButton;
VeltCommentDialogAssigneeBanner.UserAvatar = VeltCommentDialogAssigneeBannerUserAvatar;
VeltCommentDialogAssigneeBanner.UserName = VeltCommentDialogAssigneeBannerUserName;
VeltCommentDialogAssigneeBanner.UnresolveButton = VeltCommentDialogAssigneeBannerUnresolveButton;

var VeltCommentDialogBody = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-body-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentDialogCommentCategory = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-comment-category-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentDialogCommentIndex = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-comment-index-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentDialogCommentSuggestionStatus = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-comment-suggestion-status-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentDialogComposerActionButton = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-composer-action-button-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentDialogComposerAssignUser = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-composer-assign-user-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentDialogComposerAttachmentsInvalidItemPreview = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-composer-attachments-invalid-item-preview-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentDialogComposerAttachmentsInvalidItemMessage = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-composer-attachments-invalid-item-message-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentDialogComposerAttachmentsInvalidItemDelete = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-composer-attachments-invalid-item-delete-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentDialogComposerAttachmentsInvalidItem = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-composer-attachments-invalid-item-wireframe", __assign({}, transformedProps), children));
};
VeltCommentDialogComposerAttachmentsInvalidItem.Preview = VeltCommentDialogComposerAttachmentsInvalidItemPreview;
VeltCommentDialogComposerAttachmentsInvalidItem.Message = VeltCommentDialogComposerAttachmentsInvalidItemMessage;
VeltCommentDialogComposerAttachmentsInvalidItem.Delete = VeltCommentDialogComposerAttachmentsInvalidItemDelete;

var VeltCommentDialogComposerAttachmentsInvalid = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-composer-attachments-invalid-wireframe", __assign({}, transformedProps), children));
};
VeltCommentDialogComposerAttachmentsInvalid.Item = VeltCommentDialogComposerAttachmentsInvalidItem;

var VeltCommentDialogComposerAttachmentsImagePreview = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-composer-attachments-image-preview-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentDialogComposerAttachmentsImageDelete = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-composer-attachments-image-delete-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentDialogComposerAttachmentsImageLoading = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-composer-attachments-image-loading-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentDialogComposerAttachmentsImage = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-composer-attachments-image-wireframe", __assign({}, transformedProps), children));
};
VeltCommentDialogComposerAttachmentsImage.Preview = VeltCommentDialogComposerAttachmentsImagePreview;
VeltCommentDialogComposerAttachmentsImage.Loading = VeltCommentDialogComposerAttachmentsImageLoading;
VeltCommentDialogComposerAttachmentsImage.Delete = VeltCommentDialogComposerAttachmentsImageDelete;

var VeltCommentDialogComposerAttachmentsOtherDelete = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-composer-attachments-other-delete-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentDialogComposerAttachmentsOtherIcon = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-composer-attachments-other-icon-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentDialogComposerAttachmentsOtherLoading = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-composer-attachments-other-loading-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentDialogComposerAttachmentsOtherName = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-composer-attachments-other-name-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentDialogComposerAttachmentsOtherSize = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-composer-attachments-other-size-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentDialogComposerAttachmentsOther = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-composer-attachments-other-wireframe", __assign({}, transformedProps), children));
};
VeltCommentDialogComposerAttachmentsOther.Delete = VeltCommentDialogComposerAttachmentsOtherDelete;
VeltCommentDialogComposerAttachmentsOther.Loading = VeltCommentDialogComposerAttachmentsOtherLoading;
VeltCommentDialogComposerAttachmentsOther.Icon = VeltCommentDialogComposerAttachmentsOtherIcon;
VeltCommentDialogComposerAttachmentsOther.Name = VeltCommentDialogComposerAttachmentsOtherName;
VeltCommentDialogComposerAttachmentsOther.Size = VeltCommentDialogComposerAttachmentsOtherSize;

var VeltCommentDialogComposerAttachmentsSelected = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-composer-attachments-selected-wireframe", __assign({}, transformedProps), children));
};
VeltCommentDialogComposerAttachmentsSelected.Image = VeltCommentDialogComposerAttachmentsImage;
VeltCommentDialogComposerAttachmentsSelected.Other = VeltCommentDialogComposerAttachmentsOther;

var VeltCommentDialogComposerAttachments = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-composer-attachments-wireframe", __assign({}, transformedProps), children));
};
VeltCommentDialogComposerAttachments.Invalid = VeltCommentDialogComposerAttachmentsInvalid;
VeltCommentDialogComposerAttachments.Selected = VeltCommentDialogComposerAttachmentsSelected;

var VeltCommentDialogComposerInput = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-composer-input-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentDialogComposerRecordings = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-composer-recordings-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentDialogComposerPrivateBadge = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-composer-private-badge-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentDialogComposerAvatar = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-composer-avatar-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentDialogComposer = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-composer-wireframe", __assign({}, transformedProps), children));
};
VeltCommentDialogComposer.ActionButton = VeltCommentDialogComposerActionButton;
VeltCommentDialogComposer.AssignUser = VeltCommentDialogComposerAssignUser;
VeltCommentDialogComposer.Attachments = VeltCommentDialogComposerAttachments;
VeltCommentDialogComposer.Input = VeltCommentDialogComposerInput;
VeltCommentDialogComposer.Recordings = VeltCommentDialogComposerRecordings;
VeltCommentDialogComposer.PrivateBadge = VeltCommentDialogComposerPrivateBadge;
VeltCommentDialogComposer.Avatar = VeltCommentDialogComposerAvatar;

var VeltCommentDialogCopyLink = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-copy-link-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentDialogGhostBanner = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-ghost-banner-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentDialogHeader = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-header-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentDialogMoreReply = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-more-reply-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentDialogOptionsDropdownContentAssignWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-options-dropdown-content-assign-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentDialogOptionsDropdownContentDeleteCommentWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    return (React.createElement("velt-comment-dialog-options-dropdown-content-delete-comment-wireframe", __assign({}, remainingProps), children));
};

var VeltCommentDialogOptionsDropdownContentDeleteThreadWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    return (React.createElement("velt-comment-dialog-options-dropdown-content-delete-thread-wireframe", __assign({}, remainingProps), children));
};

var VeltCommentDialogOptionsDropdownContentDeleteWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-options-dropdown-content-delete-wireframe", __assign({}, transformedProps), children));
};
VeltCommentDialogOptionsDropdownContentDeleteWireframe.Comment = VeltCommentDialogOptionsDropdownContentDeleteCommentWireframe;
VeltCommentDialogOptionsDropdownContentDeleteWireframe.Thread = VeltCommentDialogOptionsDropdownContentDeleteThreadWireframe;

var VeltCommentDialogOptionsDropdownContentEditWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-options-dropdown-content-edit-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentDialogOptionsDropdownContentMakePrivateDisableWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    return (React.createElement("velt-comment-dialog-options-dropdown-content-make-private-disable-wireframe", __assign({}, remainingProps), children));
};

var VeltCommentDialogOptionsDropdownContentMakePrivateEnableWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    return (React.createElement("velt-comment-dialog-options-dropdown-content-make-private-enable-wireframe", __assign({}, remainingProps), children));
};

var VeltCommentDialogOptionsDropdownContentMakePrivateWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-options-dropdown-content-make-private-wireframe", __assign({}, transformedProps), children));
};
VeltCommentDialogOptionsDropdownContentMakePrivateWireframe.Enable = VeltCommentDialogOptionsDropdownContentMakePrivateEnableWireframe;
VeltCommentDialogOptionsDropdownContentMakePrivateWireframe.Disable = VeltCommentDialogOptionsDropdownContentMakePrivateDisableWireframe;

var VeltCommentDialogOptionsDropdownContentNotificationSubscribeWireframe = function (props) {
    var children = props.children;
    return (React.createElement("velt-comment-dialog-options-dropdown-content-notification-subscribe-wireframe", null, children));
};

var VeltCommentDialogOptionsDropdownContentNotificationUnsubscribeWireframe = function (props) {
    var children = props.children;
    return (React.createElement("velt-comment-dialog-options-dropdown-content-notification-unsubscribe-wireframe", null, children));
};

var VeltCommentDialogOptionsDropdownContentNotificationWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-options-dropdown-content-notification-wireframe", __assign({}, transformedProps), children));
};
VeltCommentDialogOptionsDropdownContentNotificationWireframe.Subscribe = VeltCommentDialogOptionsDropdownContentNotificationSubscribeWireframe;
VeltCommentDialogOptionsDropdownContentNotificationWireframe.Unsubscribe = VeltCommentDialogOptionsDropdownContentNotificationUnsubscribeWireframe;

var VeltCommentDialogOptionsDropdownContentWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-options-dropdown-content-wireframe", __assign({}, transformedProps), children));
};
VeltCommentDialogOptionsDropdownContentWireframe.Assign = VeltCommentDialogOptionsDropdownContentAssignWireframe;
VeltCommentDialogOptionsDropdownContentWireframe.MakePrivate = VeltCommentDialogOptionsDropdownContentMakePrivateWireframe;
VeltCommentDialogOptionsDropdownContentWireframe.Edit = VeltCommentDialogOptionsDropdownContentEditWireframe;
VeltCommentDialogOptionsDropdownContentWireframe.Delete = VeltCommentDialogOptionsDropdownContentDeleteWireframe;
VeltCommentDialogOptionsDropdownContentWireframe.Notification = VeltCommentDialogOptionsDropdownContentNotificationWireframe;

var VeltCommentDialogOptionsDropdownTriggerWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-options-dropdown-trigger-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentDialogOptions = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-options-wireframe", __assign({}, transformedProps), children));
};
VeltCommentDialogOptions.Content = VeltCommentDialogOptionsDropdownContentWireframe;
VeltCommentDialogOptions.Trigger = VeltCommentDialogOptionsDropdownTriggerWireframe;

var VeltCommentDialogPriorityDropdownContentItemIconWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-priority-dropdown-content-item-icon-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentDialogPriorityDropdownContentItemNameWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-priority-dropdown-content-item-name-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentDialogPriorityDropdownContentItemTickWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-priority-dropdown-content-item-tick-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentDialogPriorityDropdownContentItemWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-priority-dropdown-content-item-wireframe", __assign({}, transformedProps), children));
};
VeltCommentDialogPriorityDropdownContentItemWireframe.Icon = VeltCommentDialogPriorityDropdownContentItemIconWireframe;
VeltCommentDialogPriorityDropdownContentItemWireframe.Name = VeltCommentDialogPriorityDropdownContentItemNameWireframe;
VeltCommentDialogPriorityDropdownContentItemWireframe.Tick = VeltCommentDialogPriorityDropdownContentItemTickWireframe;

var VeltCommentDialogPriorityDropdownContentWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-priority-dropdown-content-wireframe", __assign({}, transformedProps), children));
};
VeltCommentDialogPriorityDropdownContentWireframe.Item = VeltCommentDialogPriorityDropdownContentItemWireframe;

var VeltCommentDialogPriorityDropdownTriggerArrowWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-priority-dropdown-trigger-arrow-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentDialogPriorityDropdownTriggerIconWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-priority-dropdown-trigger-icon-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentDialogPriorityDropdownTriggerNameWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-priority-dropdown-trigger-name-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentDialogPriorityDropdownTriggerWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-priority-dropdown-trigger-wireframe", __assign({}, transformedProps), children));
};
VeltCommentDialogPriorityDropdownTriggerWireframe.Arrow = VeltCommentDialogPriorityDropdownTriggerArrowWireframe;
VeltCommentDialogPriorityDropdownTriggerWireframe.Name = VeltCommentDialogPriorityDropdownTriggerNameWireframe;
VeltCommentDialogPriorityDropdownTriggerWireframe.Icon = VeltCommentDialogPriorityDropdownTriggerIconWireframe;

var VeltCommentDialogPriority = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-priority-wireframe", __assign({}, transformedProps), children));
};
VeltCommentDialogPriority.Content = VeltCommentDialogPriorityDropdownContentWireframe;
VeltCommentDialogPriority.Trigger = VeltCommentDialogPriorityDropdownTriggerWireframe;

var VeltCommentDialogPrivateBanner = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-private-banner-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentDialogResolveButton = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-resolve-button-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentDialogSignIn = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-sign-in-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentDialogStatusDropdownContentItemIconWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-status-dropdown-content-item-icon-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentDialogStatusDropdownContentItemNameWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-status-dropdown-content-item-name-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentDialogStatusDropdownContentItemWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-status-dropdown-content-item-wireframe", __assign({}, transformedProps), children));
};
VeltCommentDialogStatusDropdownContentItemWireframe.Icon = VeltCommentDialogStatusDropdownContentItemIconWireframe;
VeltCommentDialogStatusDropdownContentItemWireframe.Name = VeltCommentDialogStatusDropdownContentItemNameWireframe;

var VeltCommentDialogStatusDropdownContentWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-status-dropdown-content-wireframe", __assign({}, transformedProps), children));
};
VeltCommentDialogStatusDropdownContentWireframe.Item = VeltCommentDialogStatusDropdownContentItemWireframe;

var VeltCommentDialogStatusDropdownTriggerArrowWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-status-dropdown-trigger-arrow-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentDialogStatusDropdownTriggerIconWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-status-dropdown-trigger-icon-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentDialogStatusDropdownTriggerNameWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-status-dropdown-trigger-name-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentDialogStatusDropdownTriggerWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-status-dropdown-trigger-wireframe", __assign({}, transformedProps), children));
};
VeltCommentDialogStatusDropdownTriggerWireframe.Arrow = VeltCommentDialogStatusDropdownTriggerArrowWireframe;
VeltCommentDialogStatusDropdownTriggerWireframe.Name = VeltCommentDialogStatusDropdownTriggerNameWireframe;
VeltCommentDialogStatusDropdownTriggerWireframe.Icon = VeltCommentDialogStatusDropdownTriggerIconWireframe;

var VeltCommentDialogStatus = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-status-wireframe", __assign({}, transformedProps), children));
};
VeltCommentDialogStatus.Content = VeltCommentDialogStatusDropdownContentWireframe;
VeltCommentDialogStatus.Trigger = VeltCommentDialogStatusDropdownTriggerWireframe;

var VeltCommentDialogSuggestionActionAccept = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-suggestion-action-accept-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentDialogSuggestionActionReject = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-suggestion-action-reject-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentDialogSuggestionAction = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-suggestion-action-wireframe", __assign({}, transformedProps), children));
};
VeltCommentDialogSuggestionAction.Accept = VeltCommentDialogSuggestionActionAccept;
VeltCommentDialogSuggestionAction.Reject = VeltCommentDialogSuggestionActionReject;

var VeltCommentDialogThreadCardAttachmentsImagePreview = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-thread-card-attachments-image-preview-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentDialogThreadCardAttachmentsImageDelete = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-thread-card-attachments-image-delete-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentDialogThreadCardAttachmentsImageDownload = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-thread-card-attachments-image-download-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentDialogThreadCardAttachmentsImage = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-thread-card-attachments-image-wireframe", __assign({}, transformedProps), children));
};
VeltCommentDialogThreadCardAttachmentsImage.Preview = VeltCommentDialogThreadCardAttachmentsImagePreview;
VeltCommentDialogThreadCardAttachmentsImage.Download = VeltCommentDialogThreadCardAttachmentsImageDownload;
VeltCommentDialogThreadCardAttachmentsImage.Delete = VeltCommentDialogThreadCardAttachmentsImageDelete;

var VeltCommentDialogThreadCardAttachmentsOtherDelete = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-thread-card-attachments-other-delete-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentDialogThreadCardAttachmentsOtherDownload = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-thread-card-attachments-other-download-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentDialogThreadCardAttachmentsOtherIcon = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-thread-card-attachments-other-icon-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentDialogThreadCardAttachmentsOtherName = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-thread-card-attachments-other-name-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentDialogThreadCardAttachmentsOtherSize = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-thread-card-attachments-other-size-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentDialogThreadCardAttachmentsOther = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-thread-card-attachments-other-wireframe", __assign({}, transformedProps), children));
};
VeltCommentDialogThreadCardAttachmentsOther.Icon = VeltCommentDialogThreadCardAttachmentsOtherIcon;
VeltCommentDialogThreadCardAttachmentsOther.Name = VeltCommentDialogThreadCardAttachmentsOtherName;
VeltCommentDialogThreadCardAttachmentsOther.Size = VeltCommentDialogThreadCardAttachmentsOtherSize;
VeltCommentDialogThreadCardAttachmentsOther.Download = VeltCommentDialogThreadCardAttachmentsOtherDownload;
VeltCommentDialogThreadCardAttachmentsOther.Delete = VeltCommentDialogThreadCardAttachmentsOtherDelete;

var VeltCommentDialogThreadCardAttachments = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-thread-card-attachments-wireframe", __assign({}, transformedProps), children));
};
VeltCommentDialogThreadCardAttachments.Other = VeltCommentDialogThreadCardAttachmentsOther;
VeltCommentDialogThreadCardAttachments.Image = VeltCommentDialogThreadCardAttachmentsImage;

var VeltCommentDialogThreadCardAvatar = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-thread-card-avatar-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentDialogThreadCardDeviceType = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-thread-card-device-type-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentDialogThreadCardDraft = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-thread-card-draft-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentDialogThreadCardMessage = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-thread-card-message-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentDialogThreadCardName = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-thread-card-name-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentDialogThreadCardOptions = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-thread-card-options-wireframe", __assign({}, transformedProps), children));
};
VeltCommentDialogThreadCardOptions.Content = VeltCommentDialogOptionsDropdownContentWireframe;
VeltCommentDialogThreadCardOptions.Trigger = VeltCommentDialogOptionsDropdownTriggerWireframe;

var VeltCommentDialogThreadCardReactionTool = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-thread-card-reaction-tool-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentDialogThreadCardReactions = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-thread-card-reactions-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentDialogThreadCardRecordings = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-thread-card-recordings-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentDialogThreadCardTime = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-thread-card-time-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentDialogThreadCardUnread = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-thread-card-unread-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentDialogThreadCardSeenDropdownContentTitle = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-thread-card-seen-dropdown-content-title-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentDialogThreadCardSeenDropdownContentItemAvatar = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-thread-card-seen-dropdown-content-item-avatar-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentDialogThreadCardSeenDropdownContentItemName = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-thread-card-seen-dropdown-content-item-name-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentDialogThreadCardSeenDropdownContentItemTime = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-thread-card-seen-dropdown-content-item-time-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentDialogThreadCardSeenDropdownContentItem = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-thread-card-seen-dropdown-content-item-wireframe", __assign({}, transformedProps), children));
};
VeltCommentDialogThreadCardSeenDropdownContentItem.Avatar = VeltCommentDialogThreadCardSeenDropdownContentItemAvatar;
VeltCommentDialogThreadCardSeenDropdownContentItem.Name = VeltCommentDialogThreadCardSeenDropdownContentItemName;
VeltCommentDialogThreadCardSeenDropdownContentItem.Time = VeltCommentDialogThreadCardSeenDropdownContentItemTime;

var VeltCommentDialogThreadCardSeenDropdownContentItems = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-thread-card-seen-dropdown-content-items-wireframe", __assign({}, transformedProps), children));
};
VeltCommentDialogThreadCardSeenDropdownContentItems.Item = VeltCommentDialogThreadCardSeenDropdownContentItem;

var VeltCommentDialogThreadCardSeenDropdownContent = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-thread-card-seen-dropdown-content-wireframe", __assign({}, transformedProps), children));
};
VeltCommentDialogThreadCardSeenDropdownContent.Title = VeltCommentDialogThreadCardSeenDropdownContentTitle;
VeltCommentDialogThreadCardSeenDropdownContent.Items = VeltCommentDialogThreadCardSeenDropdownContentItems;

var VeltCommentDialogThreadCardSeenDropdownTrigger = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-thread-card-seen-dropdown-trigger-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentDialogThreadCardSeenDropdown = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-thread-card-seen-dropdown-wireframe", __assign({}, transformedProps), children));
};
VeltCommentDialogThreadCardSeenDropdown.Trigger = VeltCommentDialogThreadCardSeenDropdownTrigger;
VeltCommentDialogThreadCardSeenDropdown.Content = VeltCommentDialogThreadCardSeenDropdownContent;

// Main Thread Card component
var VeltCommentDialogThreadCard = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-thread-card-wireframe", __assign({}, transformedProps), children));
};
// Attach the Sub component as a static property of the main Thread Card component
VeltCommentDialogThreadCard.Avatar = VeltCommentDialogThreadCardAvatar;
VeltCommentDialogThreadCard.DeviceType = VeltCommentDialogThreadCardDeviceType;
VeltCommentDialogThreadCard.Attachments = VeltCommentDialogThreadCardAttachments;
VeltCommentDialogThreadCard.Message = VeltCommentDialogThreadCardMessage;
VeltCommentDialogThreadCard.Name = VeltCommentDialogThreadCardName;
VeltCommentDialogThreadCard.Options = VeltCommentDialogThreadCardOptions;
VeltCommentDialogThreadCard.Reactions = VeltCommentDialogThreadCardReactions;
VeltCommentDialogThreadCard.ReactionTool = VeltCommentDialogThreadCardReactionTool;
VeltCommentDialogThreadCard.Recordings = VeltCommentDialogThreadCardRecordings;
VeltCommentDialogThreadCard.Time = VeltCommentDialogThreadCardTime;
VeltCommentDialogThreadCard.Unread = VeltCommentDialogThreadCardUnread;
VeltCommentDialogThreadCard.Draft = VeltCommentDialogThreadCardDraft;
VeltCommentDialogThreadCard.SeenDropdown = VeltCommentDialogThreadCardSeenDropdown;

var VeltCommentDialogThreads = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-threads-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentDialogToggleReplyCount = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-toggle-reply-count-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentDialogToggleReplyText = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-toggle-reply-text-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentDialogToggleReplyIcon = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-toggle-reply-icon-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentDialogToggleReply = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-toggle-reply-wireframe", __assign({}, transformedProps), children));
};
VeltCommentDialogToggleReply.Icon = VeltCommentDialogToggleReplyIcon;
VeltCommentDialogToggleReply.Text = VeltCommentDialogToggleReplyText;
VeltCommentDialogToggleReply.Count = VeltCommentDialogToggleReplyCount;

var VeltCommentDialogUpgrade = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-upgrade-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentDialogCustomAnnotationDropdownContentItemIcon = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-custom-annotation-dropdown-content-item-icon-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentDialogCustomAnnotationDropdownContentItemLabel = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-custom-annotation-dropdown-content-item-label-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentDialogCustomAnnotationDropdownContentItem = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-custom-annotation-dropdown-content-item-wireframe", __assign({}, transformedProps), children));
};
VeltCommentDialogCustomAnnotationDropdownContentItem.Label = VeltCommentDialogCustomAnnotationDropdownContentItemLabel;
VeltCommentDialogCustomAnnotationDropdownContentItem.Icon = VeltCommentDialogCustomAnnotationDropdownContentItemIcon;

var VeltCommentDialogCustomAnnotationDropdownContent = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-custom-annotation-dropdown-content-wireframe", __assign({}, transformedProps), children));
};
VeltCommentDialogCustomAnnotationDropdownContent.Item = VeltCommentDialogCustomAnnotationDropdownContentItem;

var VeltCommentDialogCustomAnnotationDropdownTriggerArrow = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-custom-annotation-dropdown-trigger-arrow-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentDialogCustomAnnotationDropdownTriggerListItem = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-custom-annotation-dropdown-trigger-list-item-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentDialogCustomAnnotationDropdownTriggerList = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-custom-annotation-dropdown-trigger-list-wireframe", __assign({}, transformedProps), children));
};
VeltCommentDialogCustomAnnotationDropdownTriggerList.Item = VeltCommentDialogCustomAnnotationDropdownTriggerListItem;

var VeltCommentDialogCustomAnnotationDropdownTriggerRemainingCount = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-custom-annotation-dropdown-trigger-remaining-count-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentDialogCustomAnnotationDropdownTriggerPlaceholder = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-custom-annotation-dropdown-trigger-placeholder-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentDialogCustomAnnotationDropdownTrigger = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-custom-annotation-dropdown-trigger-wireframe", __assign({}, transformedProps), children));
};
VeltCommentDialogCustomAnnotationDropdownTrigger.Arrow = VeltCommentDialogCustomAnnotationDropdownTriggerArrow;
VeltCommentDialogCustomAnnotationDropdownTrigger.List = VeltCommentDialogCustomAnnotationDropdownTriggerList;
VeltCommentDialogCustomAnnotationDropdownTrigger.RemainingCount = VeltCommentDialogCustomAnnotationDropdownTriggerRemainingCount;
VeltCommentDialogCustomAnnotationDropdownTrigger.Placeholder = VeltCommentDialogCustomAnnotationDropdownTriggerPlaceholder;

var VeltCommentDialogCustomAnnotationDropdown = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-custom-annotation-dropdown-wireframe", __assign({}, transformedProps), children));
};
VeltCommentDialogCustomAnnotationDropdown.Content = VeltCommentDialogCustomAnnotationDropdownContent;
VeltCommentDialogCustomAnnotationDropdown.Trigger = VeltCommentDialogCustomAnnotationDropdownTrigger;

var VeltCommentDialogDeleteButton = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-delete-button-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentDialogCloseButton = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-close-button-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentDialogUnresolveButton = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-unresolve-button-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentDialogNavigationButton = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-navigation-button-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentDialogWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-wireframe", __assign({}, transformedProps), children));
};
VeltCommentDialogWireframe.AllComment = VeltCommentDialogAllComment;
VeltCommentDialogWireframe.Approve = VeltCommentDialogApprove;
VeltCommentDialogWireframe.AssigneeBanner = VeltCommentDialogAssigneeBanner;
VeltCommentDialogWireframe.AssignMenu = VeltCommentDialogAssignMenu;
VeltCommentDialogWireframe.Body = VeltCommentDialogBody;
VeltCommentDialogWireframe.CommentCategory = VeltCommentDialogCommentCategory;
VeltCommentDialogWireframe.CommentIndex = VeltCommentDialogCommentIndex;
VeltCommentDialogWireframe.CommentSuggestionStatus = VeltCommentDialogCommentSuggestionStatus;
VeltCommentDialogWireframe.Composer = VeltCommentDialogComposer;
VeltCommentDialogWireframe.CopyLink = VeltCommentDialogCopyLink;
VeltCommentDialogWireframe.GhostBanner = VeltCommentDialogGhostBanner;
VeltCommentDialogWireframe.Header = VeltCommentDialogHeader;
VeltCommentDialogWireframe.MoreReply = VeltCommentDialogMoreReply;
VeltCommentDialogWireframe.Options = VeltCommentDialogOptions;
VeltCommentDialogWireframe.Priority = VeltCommentDialogPriority;
VeltCommentDialogWireframe.PrivateBanner = VeltCommentDialogPrivateBanner;
VeltCommentDialogWireframe.ResolveButton = VeltCommentDialogResolveButton;
VeltCommentDialogWireframe.UnresolveButton = VeltCommentDialogUnresolveButton;
VeltCommentDialogWireframe.SignIn = VeltCommentDialogSignIn;
VeltCommentDialogWireframe.Status = VeltCommentDialogStatus;
VeltCommentDialogWireframe.SuggestionAction = VeltCommentDialogSuggestionAction;
VeltCommentDialogWireframe.ThreadCard = VeltCommentDialogThreadCard;
VeltCommentDialogWireframe.Threads = VeltCommentDialogThreads;
VeltCommentDialogWireframe.ToggleReply = VeltCommentDialogToggleReply;
VeltCommentDialogWireframe.Upgrade = VeltCommentDialogUpgrade;
VeltCommentDialogWireframe.CustomAnnotationDropdown = VeltCommentDialogCustomAnnotationDropdown;
VeltCommentDialogWireframe.DeleteButton = VeltCommentDialogDeleteButton;
VeltCommentDialogWireframe.CloseButton = VeltCommentDialogCloseButton;
VeltCommentDialogWireframe.NavigationButton = VeltCommentDialogNavigationButton;

var VeltCommentsSidebarCloseButton = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-close-button-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentsSidebarEmptyPlaceholder = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-empty-placeholder-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentsSidebarFilterItemCheckboxChecked = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-filter-item-checkbox-checked-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentsSidebarFilterItemCheckboxUnchecked = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-filter-item-checkbox-unchecked-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentsSidebarFilterItemCheckbox = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-filter-item-checkbox-wireframe", __assign({}, transformedProps), children));
};
VeltCommentsSidebarFilterItemCheckbox.Checked = VeltCommentsSidebarFilterItemCheckboxChecked;
VeltCommentsSidebarFilterItemCheckbox.Unchecked = VeltCommentsSidebarFilterItemCheckboxUnchecked;

var VeltCommentsSidebarFilterItemCount = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-filter-item-count-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentsSidebarFilterItemName = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-filter-item-name-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentsSidebarFilterItem = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-filter-item-wireframe", __assign({}, transformedProps), children));
};
VeltCommentsSidebarFilterItem.Checkbox = VeltCommentsSidebarFilterItemCheckbox;
VeltCommentsSidebarFilterItem.Count = VeltCommentsSidebarFilterItemCount;
VeltCommentsSidebarFilterItem.Name = VeltCommentsSidebarFilterItemName;

var VeltCommentsSidebarFilterName = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-filter-name-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentsSidebarFilterSearchDropdownIcon = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-filter-search-dropdown-icon-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentsSidebarFilterSearchHiddenCount = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-filter-search-hidden-count-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentsSidebarFilterSearchInput = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-filter-search-input-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentsSidebarFilterSearchTagsItemName = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-filter-search-tags-item-name-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentsSidebarFilterSearchTagsItemClose = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-filter-search-tags-item-close-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentsSidebarFilterSearchTagsItem = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-filter-search-tags-item-wireframe", __assign({}, transformedProps), children));
};
VeltCommentsSidebarFilterSearchTagsItem.Name = VeltCommentsSidebarFilterSearchTagsItemName;
VeltCommentsSidebarFilterSearchTagsItem.Close = VeltCommentsSidebarFilterSearchTagsItemClose;

var VeltCommentsSidebarFilterSearchTags = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-filter-search-tags-wireframe", __assign({}, transformedProps), children));
};
VeltCommentsSidebarFilterSearchTags.Item = VeltCommentsSidebarFilterSearchTagsItem;

var VeltCommentsSidebarFilterSearch = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-filter-search-wireframe", __assign({}, transformedProps), children));
};
VeltCommentsSidebarFilterSearch.DropdownIcon = VeltCommentsSidebarFilterSearchDropdownIcon;
VeltCommentsSidebarFilterSearch.Tags = VeltCommentsSidebarFilterSearchTags;
VeltCommentsSidebarFilterSearch.HiddenCount = VeltCommentsSidebarFilterSearchHiddenCount;
VeltCommentsSidebarFilterSearch.Input = VeltCommentsSidebarFilterSearchInput;

var VeltCommentsSidebarFilterCategory = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-filter-category-wireframe", __assign({}, transformedProps), children));
};
VeltCommentsSidebarFilterCategory.Name = VeltCommentsSidebarFilterName;
VeltCommentsSidebarFilterCategory.Item = VeltCommentsSidebarFilterItem;
VeltCommentsSidebarFilterCategory.Search = VeltCommentsSidebarFilterSearch;

var VeltCommentsSidebarFilterCloseButton = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-filter-close-button-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentsSidebarFilterCommentType = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-filter-comment-type-wireframe", __assign({}, transformedProps), children));
};
VeltCommentsSidebarFilterCommentType.Name = VeltCommentsSidebarFilterName;
VeltCommentsSidebarFilterCommentType.Item = VeltCommentsSidebarFilterItem;

var VeltCommentsSidebarFilterDoneButton = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-filter-done-button-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentsSidebarFilterGroupBy = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-filter-group-by-wireframe", __assign({}, transformedProps), children));
};
VeltCommentsSidebarFilterGroupBy.Name = VeltCommentsSidebarFilterName;
VeltCommentsSidebarFilterGroupBy.Item = VeltCommentsSidebarFilterItem;

var VeltCommentsSidebarFilterViewAll = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-filter-view-all-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentsSidebarFilterLocation = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-filter-location-wireframe", __assign({}, transformedProps), children));
};
VeltCommentsSidebarFilterLocation.Name = VeltCommentsSidebarFilterName;
VeltCommentsSidebarFilterLocation.Item = VeltCommentsSidebarFilterItem;
VeltCommentsSidebarFilterLocation.ViewAll = VeltCommentsSidebarFilterViewAll;
VeltCommentsSidebarFilterLocation.Search = VeltCommentsSidebarFilterSearch;

var VeltCommentsSidebarFilterPeople = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-filter-people-wireframe", __assign({}, transformedProps), children));
};
VeltCommentsSidebarFilterPeople.Name = VeltCommentsSidebarFilterName;
VeltCommentsSidebarFilterPeople.Item = VeltCommentsSidebarFilterItem;
VeltCommentsSidebarFilterPeople.Search = VeltCommentsSidebarFilterSearch;

var VeltCommentsSidebarFilterPriority = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-filter-priority-wireframe", __assign({}, transformedProps), children));
};
VeltCommentsSidebarFilterPriority.Name = VeltCommentsSidebarFilterName;
VeltCommentsSidebarFilterPriority.Item = VeltCommentsSidebarFilterItem;
VeltCommentsSidebarFilterPriority.Search = VeltCommentsSidebarFilterSearch;

var VeltCommentsSidebarFilterTitle = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-filter-title-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentsSidebarFilterVersions = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-filter-versions-wireframe", __assign({}, transformedProps), children));
};
VeltCommentsSidebarFilterVersions.Name = VeltCommentsSidebarFilterName;
VeltCommentsSidebarFilterVersions.Item = VeltCommentsSidebarFilterItem;
VeltCommentsSidebarFilterVersions.Search = VeltCommentsSidebarFilterSearch;

var VeltCommentsSidebarFilterStatus = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-filter-status-wireframe", __assign({}, transformedProps), children));
};
VeltCommentsSidebarFilterStatus.Name = VeltCommentsSidebarFilterName;
VeltCommentsSidebarFilterStatus.Item = VeltCommentsSidebarFilterItem;
VeltCommentsSidebarFilterStatus.Search = VeltCommentsSidebarFilterSearch;

var VeltCommentsSidebarFilterResetButton = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-filter-reset-button-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentsSidebarFilterAssigned = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-filter-assigned-wireframe", __assign({}, transformedProps), children));
};
VeltCommentsSidebarFilterAssigned.Name = VeltCommentsSidebarFilterName;
VeltCommentsSidebarFilterAssigned.Item = VeltCommentsSidebarFilterItem;
VeltCommentsSidebarFilterAssigned.Search = VeltCommentsSidebarFilterSearch;

var VeltCommentsSidebarFilterTagged = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-filter-tagged-wireframe", __assign({}, transformedProps), children));
};
VeltCommentsSidebarFilterTagged.Name = VeltCommentsSidebarFilterName;
VeltCommentsSidebarFilterTagged.Item = VeltCommentsSidebarFilterItem;
VeltCommentsSidebarFilterTagged.Search = VeltCommentsSidebarFilterSearch;

var VeltCommentsSidebarFilter = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-filter-wireframe", __assign({}, transformedProps), children));
};
VeltCommentsSidebarFilter.Category = VeltCommentsSidebarFilterCategory;
VeltCommentsSidebarFilter.CloseButton = VeltCommentsSidebarFilterCloseButton;
VeltCommentsSidebarFilter.CommentType = VeltCommentsSidebarFilterCommentType;
VeltCommentsSidebarFilter.DoneButton = VeltCommentsSidebarFilterDoneButton;
VeltCommentsSidebarFilter.GroupBy = VeltCommentsSidebarFilterGroupBy;
VeltCommentsSidebarFilter.Location = VeltCommentsSidebarFilterLocation;
VeltCommentsSidebarFilter.People = VeltCommentsSidebarFilterPeople;
VeltCommentsSidebarFilter.Assigned = VeltCommentsSidebarFilterAssigned;
VeltCommentsSidebarFilter.Tagged = VeltCommentsSidebarFilterTagged;
VeltCommentsSidebarFilter.Priority = VeltCommentsSidebarFilterPriority;
VeltCommentsSidebarFilter.Title = VeltCommentsSidebarFilterTitle;
VeltCommentsSidebarFilter.Versions = VeltCommentsSidebarFilterVersions;
VeltCommentsSidebarFilter.Item = VeltCommentsSidebarFilterItem;
VeltCommentsSidebarFilter.Status = VeltCommentsSidebarFilterStatus;
VeltCommentsSidebarFilter.ResetButton = VeltCommentsSidebarFilterResetButton;
VeltCommentsSidebarFilter.Search = VeltCommentsSidebarFilterSearch;

var VeltCommentsSidebarFilterButton = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-filter-button-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentsSidebarHeader = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-header-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentsSidebarListItemDialogContainer = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-list-item-dialog-container-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentsSidebarListItemGroupCount = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-list-item-group-count-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentsSidebarListItemGroupArrow = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-list-item-group-arrow-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentsSidebarListItemGroupName = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-list-item-group-name-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentsSidebarListItemGroup = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-list-item-group-wireframe", __assign({}, transformedProps), children));
};
VeltCommentsSidebarListItemGroup.Count = VeltCommentsSidebarListItemGroupCount;
VeltCommentsSidebarListItemGroup.Arrow = VeltCommentsSidebarListItemGroupArrow;
VeltCommentsSidebarListItemGroup.Name = VeltCommentsSidebarListItemGroupName;

var VeltCommentsSidebarListItem = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-list-item-wireframe", __assign({}, transformedProps), children));
};
VeltCommentsSidebarListItem.DialogContainer = VeltCommentsSidebarListItemDialogContainer;
VeltCommentsSidebarListItem.Group = VeltCommentsSidebarListItemGroup;

var VeltCommentsSidebarList = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-list-wireframe", __assign({}, transformedProps), children));
};
VeltCommentsSidebarList.Item = VeltCommentsSidebarListItem;

var VeltCommentsSidebarLocationFilterDropdownContent = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-location-filter-dropdown-content-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentsSidebarLocationFilterDropdownTriggerLabel = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-location-filter-dropdown-trigger-label-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentsSidebarLocationFilterDropdownTrigger = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-location-filter-dropdown-trigger-wireframe", __assign({}, transformedProps), children));
};
VeltCommentsSidebarLocationFilterDropdownTrigger.Label = VeltCommentsSidebarLocationFilterDropdownTriggerLabel;

var VeltCommentsSidebarLocationFilterDropdown = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-location-filter-dropdown-wireframe", __assign({}, transformedProps), children));
};
VeltCommentsSidebarLocationFilterDropdown.Trigger = VeltCommentsSidebarLocationFilterDropdownTrigger;
VeltCommentsSidebarLocationFilterDropdown.Content = VeltCommentsSidebarLocationFilterDropdownContent;

var VeltCommentsSidebarMinimalActionsDropdownContentMarkAllReadWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-minimal-actions-dropdown-content-mark-all-read-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentsSidebarMinimalActionsDropdownContentMarkAllResolvedWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-minimal-actions-dropdown-content-mark-all-resolved-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentsSidebarMinimalActionsDropdownContentWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-minimal-actions-dropdown-content-wireframe", __assign({}, transformedProps), children));
};
VeltCommentsSidebarMinimalActionsDropdownContentWireframe.MarkAllRead = VeltCommentsSidebarMinimalActionsDropdownContentMarkAllReadWireframe;
VeltCommentsSidebarMinimalActionsDropdownContentWireframe.MarkAllResolved = VeltCommentsSidebarMinimalActionsDropdownContentMarkAllResolvedWireframe;

var VeltCommentsSidebarMinimalActionsDropdownTriggerWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-minimal-actions-dropdown-trigger-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentsSidebarMinimalActionsDropdownWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-minimal-actions-dropdown-wireframe", __assign({}, transformedProps), children));
};
VeltCommentsSidebarMinimalActionsDropdownWireframe.Trigger = VeltCommentsSidebarMinimalActionsDropdownTriggerWireframe;
VeltCommentsSidebarMinimalActionsDropdownWireframe.Content = VeltCommentsSidebarMinimalActionsDropdownContentWireframe;

var VeltCommentsSidebarMinimalFilterDropdownContentFilterAll = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-minimal-filter-dropdown-content-filter-all-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentsSidebarMinimalFilterDropdownContentFilterRead = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-minimal-filter-dropdown-content-filter-read-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentsSidebarMinimalFilterDropdownContentFilterResolved = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-minimal-filter-dropdown-content-filter-resolved-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentsSidebarMinimalFilterDropdownContentFilterUnread = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-minimal-filter-dropdown-content-filter-unread-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentsSidebarMinimalFilterDropdownContentSelectedIcon = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-minimal-filter-dropdown-content-selected-icon-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentsSidebarMinimalFilterDropdownContentSortDate = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-minimal-filter-dropdown-content-sort-date-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentsSidebarMinimalFilterDropdownContentSortUnread = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-minimal-filter-dropdown-content-sort-unread-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentsSidebarMinimalFilterDropdownContent = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-minimal-filter-dropdown-content-wireframe", __assign({}, transformedProps), children));
};
VeltCommentsSidebarMinimalFilterDropdownContent.FilterAll = VeltCommentsSidebarMinimalFilterDropdownContentFilterAll;
VeltCommentsSidebarMinimalFilterDropdownContent.FilterUnread = VeltCommentsSidebarMinimalFilterDropdownContentFilterUnread;
VeltCommentsSidebarMinimalFilterDropdownContent.FilterRead = VeltCommentsSidebarMinimalFilterDropdownContentFilterRead;
VeltCommentsSidebarMinimalFilterDropdownContent.FilterResolved = VeltCommentsSidebarMinimalFilterDropdownContentFilterResolved;
VeltCommentsSidebarMinimalFilterDropdownContent.SelectedIcon = VeltCommentsSidebarMinimalFilterDropdownContentSelectedIcon;
VeltCommentsSidebarMinimalFilterDropdownContent.SortDate = VeltCommentsSidebarMinimalFilterDropdownContentSortDate;
VeltCommentsSidebarMinimalFilterDropdownContent.SortUnread = VeltCommentsSidebarMinimalFilterDropdownContentSortUnread;

var VeltCommentsSidebarMinimalFilterDropdownTrigger = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-minimal-filter-dropdown-trigger-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentsSidebarMinimalFilterDropdown = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-minimal-filter-dropdown-wireframe", __assign({}, transformedProps), children));
};
VeltCommentsSidebarMinimalFilterDropdown.Trigger = VeltCommentsSidebarMinimalFilterDropdownTrigger;
VeltCommentsSidebarMinimalFilterDropdown.Content = VeltCommentsSidebarMinimalFilterDropdownContent;

var VeltCommentsSidebarPageModeComposer = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-page-mode-composer-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentsSidebarPanel = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-panel-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentsSidebarSearch = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-search-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentsSidebarSkeleton = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-skeleton-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentsSidebarStatusDropdownContentItemIconWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-status-dropdown-content-item-icon-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentsSidebarStatusDropdownContentItemNameWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-status-dropdown-content-item-name-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentsSidebarStatusDropdownContentItemCheckboxCheckedWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-status-dropdown-content-item-checkbox-checked-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentsSidebarStatusDropdownContentItemCheckboxUncheckedWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-status-dropdown-content-item-checkbox-unchecked-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentsSidebarStatusDropdownContentItemCheckboxWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-status-dropdown-content-item-checkbox-wireframe", __assign({}, transformedProps), children));
};
VeltCommentsSidebarStatusDropdownContentItemCheckboxWireframe.Checked = VeltCommentsSidebarStatusDropdownContentItemCheckboxCheckedWireframe;
VeltCommentsSidebarStatusDropdownContentItemCheckboxWireframe.Unchecked = VeltCommentsSidebarStatusDropdownContentItemCheckboxUncheckedWireframe;

var VeltCommentsSidebarStatusDropdownContentItemCountWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-status-dropdown-content-item-count-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentsSidebarStatusDropdownContentItemWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-status-dropdown-content-item-wireframe", __assign({}, transformedProps), children));
};
VeltCommentsSidebarStatusDropdownContentItemWireframe.Icon = VeltCommentsSidebarStatusDropdownContentItemIconWireframe;
VeltCommentsSidebarStatusDropdownContentItemWireframe.Name = VeltCommentsSidebarStatusDropdownContentItemNameWireframe;
VeltCommentsSidebarStatusDropdownContentItemWireframe.Count = VeltCommentsSidebarStatusDropdownContentItemCountWireframe;
VeltCommentsSidebarStatusDropdownContentItemWireframe.Checkbox = VeltCommentsSidebarStatusDropdownContentItemCheckboxWireframe;

var VeltCommentsSidebarStatusDropdownContentWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-status-dropdown-content-wireframe", __assign({}, transformedProps), children));
};
VeltCommentsSidebarStatusDropdownContentWireframe.Item = VeltCommentsSidebarStatusDropdownContentItemWireframe;

var VeltCommentsSidebarStatusDropdownTriggerArrowWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-status-dropdown-trigger-arrow-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentsSidebarStatusDropdownTriggerIndicatorWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-status-dropdown-trigger-indicator-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentsSidebarStatusDropdownTriggerNameWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-status-dropdown-trigger-name-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentsSidebarStatusDropdownTriggerWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-status-dropdown-trigger-wireframe", __assign({}, transformedProps), children));
};
VeltCommentsSidebarStatusDropdownTriggerWireframe.Arrow = VeltCommentsSidebarStatusDropdownTriggerArrowWireframe;
VeltCommentsSidebarStatusDropdownTriggerWireframe.Name = VeltCommentsSidebarStatusDropdownTriggerNameWireframe;
VeltCommentsSidebarStatusDropdownTriggerWireframe.Indicator = VeltCommentsSidebarStatusDropdownTriggerIndicatorWireframe;

var VeltCommentsSidebarStatus = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-status-wireframe", __assign({}, transformedProps), children));
};
VeltCommentsSidebarStatus.Trigger = VeltCommentsSidebarStatusDropdownTriggerWireframe;
VeltCommentsSidebarStatus.Content = VeltCommentsSidebarStatusDropdownContentWireframe;

var VeltCommentsSidebarResetFilterButtonWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-reset-filter-button-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentsSidebarActionButton = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-action-button-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentsSidebarFocusedThreadBackButton = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-focused-thread-back-button-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentsSidebarFocusedThreadDialogContainer = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-focused-thread-dialog-container-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentsSidebarFocusedThread = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-focused-thread-wireframe", __assign({}, transformedProps), children));
};
VeltCommentsSidebarFocusedThread.BackButton = VeltCommentsSidebarFocusedThreadBackButton;
VeltCommentsSidebarFocusedThread.DialogContainer = VeltCommentsSidebarFocusedThreadDialogContainer;

var VeltCommentsSidebarWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-wireframe", __assign({}, transformedProps), children));
};
VeltCommentsSidebarWireframe.CloseButton = VeltCommentsSidebarCloseButton;
VeltCommentsSidebarWireframe.EmptyPlaceholder = VeltCommentsSidebarEmptyPlaceholder;
VeltCommentsSidebarWireframe.Filter = VeltCommentsSidebarFilter;
VeltCommentsSidebarWireframe.Header = VeltCommentsSidebarHeader;
VeltCommentsSidebarWireframe.List = VeltCommentsSidebarList;
VeltCommentsSidebarWireframe.PageModeComposer = VeltCommentsSidebarPageModeComposer;
VeltCommentsSidebarWireframe.Search = VeltCommentsSidebarSearch;
VeltCommentsSidebarWireframe.Status = VeltCommentsSidebarStatus;
VeltCommentsSidebarWireframe.FilterButton = VeltCommentsSidebarFilterButton;
VeltCommentsSidebarWireframe.Skeleton = VeltCommentsSidebarSkeleton;
VeltCommentsSidebarWireframe.Panel = VeltCommentsSidebarPanel;
VeltCommentsSidebarWireframe.MinimalFilterDropdown = VeltCommentsSidebarMinimalFilterDropdown;
VeltCommentsSidebarWireframe.LocationFilterDropdown = VeltCommentsSidebarLocationFilterDropdown;
VeltCommentsSidebarWireframe.MinimalActionsDropdown = VeltCommentsSidebarMinimalActionsDropdownWireframe;
VeltCommentsSidebarWireframe.ResetFilterButton = VeltCommentsSidebarResetFilterButtonWireframe;
VeltCommentsSidebarWireframe.ActionButton = VeltCommentsSidebarActionButton;
VeltCommentsSidebarWireframe.FocusedThread = VeltCommentsSidebarFocusedThread;

var VeltCommentPinGhostCommentIndicator = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-pin-ghost-comment-indicator-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentPinIndex = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-pin-index-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentPinTriangle = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-pin-triangle-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentPinUnreadCommentIndicator = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-pin-unread-comment-indicator-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentPinPrivateCommentIndicator = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-pin-private-comment-indicator-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentPinWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-pin-wireframe", __assign({}, transformedProps), children));
};
VeltCommentPinWireframe.GhostCommentIndicator = VeltCommentPinGhostCommentIndicator;
VeltCommentPinWireframe.Index = VeltCommentPinIndex;
VeltCommentPinWireframe.PrivateCommentIndicator = VeltCommentPinPrivateCommentIndicator;
VeltCommentPinWireframe.Triangle = VeltCommentPinTriangle;
VeltCommentPinWireframe.UnreadCommentIndicator = VeltCommentPinUnreadCommentIndicator;

var VeltSidebarButtonCommentsCount = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-sidebar-button-comments-count-wireframe", __assign({}, transformedProps), children));
};

var VeltSidebarButtonIcon = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-sidebar-button-icon-wireframe", __assign({}, transformedProps), children));
};

var VeltSidebarButtonWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-sidebar-button-wireframe", __assign({}, transformedProps), children));
};
VeltSidebarButtonWireframe.CommentsCount = VeltSidebarButtonCommentsCount;
VeltSidebarButtonWireframe.Icon = VeltSidebarButtonIcon;

var VeltCommentToolWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-tool-wireframe", __assign({}, transformedProps), children));
};

var VeltTextCommentToolWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-text-comment-tool-wireframe", __assign({}, transformedProps), children));
};

var VeltTextCommentToolbarCommentAnnotation = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-text-comment-toolbar-comment-annotation-wireframe", __assign({}, transformedProps), children));
};

var VeltTextCommentToolbarCopywriter = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-text-comment-toolbar-copywriter-wireframe", __assign({}, transformedProps), children));
};

var VeltTextCommentToolbarGeneric = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-text-comment-toolbar-generic-wireframe", __assign({}, transformedProps), children));
};

var VeltTextCommentToolbarDivider = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-text-comment-toolbar-divider-wireframe", __assign({}, transformedProps), children));
};

var VeltTextCommentToolbar = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-text-comment-toolbar-wireframe", __assign({}, transformedProps), children));
};
VeltTextCommentToolbar.CommentAnnotation = VeltTextCommentToolbarCommentAnnotation;
VeltTextCommentToolbar.Copywriter = VeltTextCommentToolbarCopywriter;
VeltTextCommentToolbar.Generic = VeltTextCommentToolbarGeneric;
VeltTextCommentToolbar.Divider = VeltTextCommentToolbarDivider;

var VeltUserSelectorDropdownAvatar = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-user-selector-dropdown-avatar-wireframe", __assign({}, transformedProps), children));
};

var VeltUserSelectorDropdownEmail = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-user-selector-dropdown-email-wireframe", __assign({}, transformedProps), children));
};

var VeltUserSelectorDropdownErrorIcon = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-user-selector-dropdown-error-icon-wireframe", __assign({}, transformedProps), children));
};

var VeltUserSelectorDropdownName = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-user-selector-dropdown-name-wireframe", __assign({}, transformedProps), children));
};

var VeltUserSelectorDropdown = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-user-selector-dropdown-wireframe", __assign({}, transformedProps), children));
};
VeltUserSelectorDropdown.Avatar = VeltUserSelectorDropdownAvatar;
VeltUserSelectorDropdown.Email = VeltUserSelectorDropdownEmail;
VeltUserSelectorDropdown.ErrorIcon = VeltUserSelectorDropdownErrorIcon;
VeltUserSelectorDropdown.Name = VeltUserSelectorDropdownName;

var VeltAutocompleteOptionIconWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-autocomplete-option-icon-wireframe", __assign({}, transformedProps), children));
};

var VeltAutocompleteOptionNameWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-autocomplete-option-name-wireframe", __assign({}, transformedProps), children));
};

var VeltAutocompleteOptionDescriptionWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-autocomplete-option-description-wireframe", __assign({}, transformedProps), children));
};

var VeltAutocompleteOptionErrorIconWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-autocomplete-option-error-icon-wireframe", __assign({}, transformedProps), children));
};

var VeltAutocompleteOptionWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-autocomplete-option-wireframe", __assign({}, transformedProps), children));
};
VeltAutocompleteOptionWireframe.Icon = VeltAutocompleteOptionIconWireframe;
VeltAutocompleteOptionWireframe.Description = VeltAutocompleteOptionDescriptionWireframe;
VeltAutocompleteOptionWireframe.ErrorIcon = VeltAutocompleteOptionErrorIconWireframe;
VeltAutocompleteOptionWireframe.Name = VeltAutocompleteOptionNameWireframe;

var VeltAutocompleteGroupOptionWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-autocomplete-group-option-wireframe", __assign({}, transformedProps), children));
};

var VeltAutocompleteChipTooltipDescriptionWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-autocomplete-chip-tooltip-description-wireframe", __assign({}, transformedProps), children));
};

var VeltAutocompleteChipTooltipIconWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-autocomplete-chip-tooltip-icon-wireframe", __assign({}, transformedProps), children));
};

var VeltAutocompleteChipTooltipNameWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-autocomplete-chip-tooltip-name-wireframe", __assign({}, transformedProps), children));
};

var VeltAutocompleteChipTooltipWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-autocomplete-chip-tooltip-wireframe", __assign({}, transformedProps), children));
};
VeltAutocompleteChipTooltipWireframe.Description = VeltAutocompleteChipTooltipDescriptionWireframe;
VeltAutocompleteChipTooltipWireframe.Icon = VeltAutocompleteChipTooltipIconWireframe;
VeltAutocompleteChipTooltipWireframe.Name = VeltAutocompleteChipTooltipNameWireframe;

var VeltCommentBubbleAvatar = function (props) {
    var children = props.children;
    return (React.createElement("velt-comment-bubble-avatar-wireframe", null, children));
};

var VeltCommentBubbleCommentsCount = function (props) {
    var children = props.children;
    return (React.createElement("velt-comment-bubble-comments-count-wireframe", null, children));
};

var VeltCommentBubbleWireframe = function (props) {
    var children = props.children, remainingProp = __rest(props, ["children"]);
    return (React.createElement("velt-comment-bubble-wireframe", __assign({}, remainingProp), children));
};
VeltCommentBubbleWireframe.Avatar = VeltCommentBubbleAvatar;
VeltCommentBubbleWireframe.CommentsCount = VeltCommentBubbleCommentsCount;

var VeltCommentsSidebarStatusDropdownWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comments-sidebar-status-dropdown-wireframe", __assign({}, transformedProps), children));
};
VeltCommentsSidebarStatusDropdownWireframe.Trigger = VeltCommentsSidebarStatusDropdownTriggerWireframe;
VeltCommentsSidebarStatusDropdownWireframe.Content = VeltCommentsSidebarStatusDropdownContentWireframe;

var VeltReactionToolWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-reaction-tool-wireframe", __assign({}, transformedProps), children));
};

var VeltReactionPinCountWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-reaction-pin-count-wireframe", __assign({}, transformedProps), children));
};

var VeltReactionPinEmojiWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-reaction-pin-emoji-wireframe", __assign({}, transformedProps), children));
};

var VeltReactionPinWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-reaction-pin-wireframe", __assign({}, transformedProps), children));
};
VeltReactionPinWireframe.Count = VeltReactionPinCountWireframe;
VeltReactionPinWireframe.Emoji = VeltReactionPinEmojiWireframe;

var VeltReactionPinTooltipUserAvatarWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-reaction-pin-tooltip-user-avatar-wireframe", __assign({}, transformedProps), children));
};

var VeltReactionPinTooltipUserNameWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-reaction-pin-tooltip-user-name-wireframe", __assign({}, transformedProps), children));
};

var VeltReactionPinTooltipUserWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-reaction-pin-tooltip-user-wireframe", __assign({}, transformedProps), children));
};
VeltReactionPinTooltipUserWireframe.Avatar = VeltReactionPinTooltipUserAvatarWireframe;
VeltReactionPinTooltipUserWireframe.Name = VeltReactionPinTooltipUserNameWireframe;

var VeltReactionPinTooltipUsersWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-reaction-pin-tooltip-users-wireframe", __assign({}, transformedProps), children));
};
VeltReactionPinTooltipUsersWireframe.User = VeltReactionPinTooltipUserWireframe;

var VeltReactionPinTooltipWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-reaction-pin-tooltip-wireframe", __assign({}, transformedProps), children));
};
VeltReactionPinTooltipWireframe.Users = VeltReactionPinTooltipUsersWireframe;

var VeltReactionsPanelItemEmojiWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-reactions-panel-item-emoji-wireframe", __assign({}, transformedProps), children));
};

var VeltReactionsPanelItemWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-reactions-panel-item-wireframe", __assign({}, transformedProps), children));
};
VeltReactionsPanelItemWireframe.Emoji = VeltReactionsPanelItemEmojiWireframe;

var VeltReactionsPanelItemsWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-reactions-panel-items-wireframe", __assign({}, transformedProps), children));
};
VeltReactionsPanelItemsWireframe.Item = VeltReactionsPanelItemWireframe;

var VeltReactionsPanelWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-reactions-panel-wireframe", __assign({}, transformedProps), children));
};
VeltReactionsPanelWireframe.Items = VeltReactionsPanelItemsWireframe;

var VeltInlineCommentsSectionCommentCountWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-inline-comments-section-comment-count-wireframe", __assign({}, transformedProps), children));
};

var VeltInlineCommentsSectionComposerContainerWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-inline-comments-section-composer-container-wireframe", __assign({}, transformedProps), children));
};

var VeltInlineCommentsSectionListWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-inline-comments-section-list-wireframe", __assign({}, transformedProps), children));
};

var VeltInlineCommentsSectionPanelWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-inline-comments-section-panel-wireframe", __assign({}, transformedProps), children));
};

var VeltInlineCommentsSectionSkeletonWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-inline-comments-section-skeleton-wireframe", __assign({}, transformedProps), children));
};

var VeltInlineCommentsSectionSortingDropdownContentItemIconWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-inline-comments-section-sorting-dropdown-content-item-icon-wireframe", __assign({}, transformedProps), children));
};

var VeltInlineCommentsSectionSortingDropdownContentItemNameWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-inline-comments-section-sorting-dropdown-content-item-name-wireframe", __assign({}, transformedProps), children));
};

var VeltInlineCommentsSectionSortingDropdownContentItemTickWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-inline-comments-section-sorting-dropdown-content-item-tick-wireframe", __assign({}, transformedProps), children));
};

var VeltInlineCommentsSectionSortingDropdownContentItemWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-inline-comments-section-sorting-dropdown-content-item-wireframe", __assign({}, transformedProps), children));
};
VeltInlineCommentsSectionSortingDropdownContentItemWireframe.Icon = VeltInlineCommentsSectionSortingDropdownContentItemIconWireframe;
VeltInlineCommentsSectionSortingDropdownContentItemWireframe.Name = VeltInlineCommentsSectionSortingDropdownContentItemNameWireframe;
VeltInlineCommentsSectionSortingDropdownContentItemWireframe.Tick = VeltInlineCommentsSectionSortingDropdownContentItemTickWireframe;

var VeltInlineCommentsSectionSortingDropdownContentWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-inline-comments-section-sorting-dropdown-content-wireframe", __assign({}, transformedProps), children));
};
VeltInlineCommentsSectionSortingDropdownContentWireframe.Item = VeltInlineCommentsSectionSortingDropdownContentItemWireframe;

var VeltInlineCommentsSectionSortingDropdownTriggerIconWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-inline-comments-section-sorting-dropdown-trigger-icon-wireframe", __assign({}, transformedProps), children));
};

var VeltInlineCommentsSectionSortingDropdownTriggerNameWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-inline-comments-section-sorting-dropdown-trigger-name-wireframe", __assign({}, transformedProps), children));
};

var VeltInlineCommentsSectionSortingDropdownTriggerWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-inline-comments-section-sorting-dropdown-trigger-wireframe", __assign({}, transformedProps), children));
};
VeltInlineCommentsSectionSortingDropdownTriggerWireframe.Icon = VeltInlineCommentsSectionSortingDropdownTriggerIconWireframe;
VeltInlineCommentsSectionSortingDropdownTriggerWireframe.Name = VeltInlineCommentsSectionSortingDropdownTriggerNameWireframe;

var VeltInlineCommentsSectionSortingDropdownWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-inline-comments-section-sorting-dropdown-wireframe", __assign({}, transformedProps), children));
};
VeltInlineCommentsSectionSortingDropdownWireframe.Content = VeltInlineCommentsSectionSortingDropdownContentWireframe;
VeltInlineCommentsSectionSortingDropdownWireframe.Trigger = VeltInlineCommentsSectionSortingDropdownTriggerWireframe;

var VeltInlineCommentsSectionWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-inline-comments-section-wireframe", __assign({}, transformedProps), children));
};
VeltInlineCommentsSectionWireframe.CommentCount = VeltInlineCommentsSectionCommentCountWireframe;
VeltInlineCommentsSectionWireframe.ComposerContainer = VeltInlineCommentsSectionComposerContainerWireframe;
VeltInlineCommentsSectionWireframe.List = VeltInlineCommentsSectionListWireframe;
VeltInlineCommentsSectionWireframe.Panel = VeltInlineCommentsSectionPanelWireframe;
VeltInlineCommentsSectionWireframe.Skeleton = VeltInlineCommentsSectionSkeletonWireframe;
VeltInlineCommentsSectionWireframe.SortingDropdown = VeltInlineCommentsSectionSortingDropdownWireframe;

var VeltNotificationsPanelContentAllListItemContentWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-notifications-panel-content-all-list-item-content-wireframe", __assign({}, transformedProps), children));
};

var VeltNotificationsPanelContentAllListItemLabelWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-notifications-panel-content-all-list-item-label-wireframe", __assign({}, transformedProps), children));
};

var VeltNotificationsPanelContentAllListItemWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-notifications-panel-content-all-list-item-wireframe", __assign({}, transformedProps), children));
};
VeltNotificationsPanelContentAllListItemWireframe.Label = VeltNotificationsPanelContentAllListItemLabelWireframe;
VeltNotificationsPanelContentAllListItemWireframe.Content = VeltNotificationsPanelContentAllListItemContentWireframe;

var VeltNotificationsPanelContentAllListWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-notifications-panel-content-all-list-wireframe", __assign({}, transformedProps), children));
};
VeltNotificationsPanelContentAllListWireframe.Item = VeltNotificationsPanelContentAllListItemWireframe;

var VeltNotificationsPanelContentAllWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-notifications-panel-content-all-wireframe", __assign({}, transformedProps), children));
};
VeltNotificationsPanelContentAllWireframe.List = VeltNotificationsPanelContentAllListWireframe;

var VeltNotificationsPanelContentDocumentsListItemContentWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-notifications-panel-content-documents-list-item-content-wireframe", __assign({}, transformedProps), children));
};

var VeltNotificationsPanelContentDocumentsListItemCountWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-notifications-panel-content-documents-list-item-count-wireframe", __assign({}, transformedProps), children));
};

var VeltNotificationsPanelContentDocumentsListItemNameWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-notifications-panel-content-documents-list-item-name-wireframe", __assign({}, transformedProps), children));
};

var VeltNotificationsPanelContentDocumentsListItemUnreadWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-notifications-panel-content-documents-list-item-unread-wireframe", __assign({}, transformedProps), children));
};

var VeltNotificationsPanelContentDocumentsListItemWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-notifications-panel-content-documents-list-item-wireframe", __assign({}, transformedProps), children));
};
VeltNotificationsPanelContentDocumentsListItemWireframe.Content = VeltNotificationsPanelContentDocumentsListItemContentWireframe;
VeltNotificationsPanelContentDocumentsListItemWireframe.Name = VeltNotificationsPanelContentDocumentsListItemNameWireframe;
VeltNotificationsPanelContentDocumentsListItemWireframe.Count = VeltNotificationsPanelContentDocumentsListItemCountWireframe;
VeltNotificationsPanelContentDocumentsListItemWireframe.Unread = VeltNotificationsPanelContentDocumentsListItemUnreadWireframe;

var VeltNotificationsPanelContentDocumentsListWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-notifications-panel-content-documents-list-wireframe", __assign({}, transformedProps), children));
};
VeltNotificationsPanelContentDocumentsListWireframe.Item = VeltNotificationsPanelContentDocumentsListItemWireframe;

var VeltNotificationsPanelContentDocumentsWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-notifications-panel-content-documents-wireframe", __assign({}, transformedProps), children));
};
VeltNotificationsPanelContentDocumentsWireframe.List = VeltNotificationsPanelContentDocumentsListWireframe;

var VeltNotificationsPanelContentForYouWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-notifications-panel-content-for-you-wireframe", __assign({}, transformedProps), children));
};

var VeltNotificationsPanelContentPeopleListItemAvatarWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-notifications-panel-content-people-list-item-avatar-wireframe", __assign({}, transformedProps), children));
};

var VeltNotificationsPanelContentPeopleListItemContentWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-notifications-panel-content-people-list-item-content-wireframe", __assign({}, transformedProps), children));
};

var VeltNotificationsPanelContentPeopleListItemCountWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-notifications-panel-content-people-list-item-count-wireframe", __assign({}, transformedProps), children));
};

var VeltNotificationsPanelContentPeopleListItemNameWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-notifications-panel-content-people-list-item-name-wireframe", __assign({}, transformedProps), children));
};

var VeltNotificationsPanelContentPeopleListItemWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-notifications-panel-content-people-list-item-wireframe", __assign({}, transformedProps), children));
};
VeltNotificationsPanelContentPeopleListItemWireframe.Avatar = VeltNotificationsPanelContentPeopleListItemAvatarWireframe;
VeltNotificationsPanelContentPeopleListItemWireframe.Name = VeltNotificationsPanelContentPeopleListItemNameWireframe;
VeltNotificationsPanelContentPeopleListItemWireframe.Count = VeltNotificationsPanelContentPeopleListItemCountWireframe;
VeltNotificationsPanelContentPeopleListItemWireframe.Content = VeltNotificationsPanelContentPeopleListItemContentWireframe;

var VeltNotificationsPanelContentPeopleListWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-notifications-panel-content-people-list-wireframe", __assign({}, transformedProps), children));
};
VeltNotificationsPanelContentPeopleListWireframe.Item = VeltNotificationsPanelContentPeopleListItemWireframe;

var VeltNotificationsPanelContentPeopleWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-notifications-panel-content-people-wireframe", __assign({}, transformedProps), children));
};
VeltNotificationsPanelContentPeopleWireframe.List = VeltNotificationsPanelContentPeopleListWireframe;

var VeltNotificationsPanelContentLoadMoreWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-notifications-panel-content-load-more-wireframe", __assign({}, transformedProps), children));
};

var VeltNotificationsPanelContentListItemAvatarWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-notifications-panel-content-list-item-avatar-wireframe", __assign({}, transformedProps), children));
};

var VeltNotificationsPanelContentListItemBodyWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-notifications-panel-content-list-item-body-wireframe", __assign({}, transformedProps), children));
};

var VeltNotificationsPanelContentListItemFileNameWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-notifications-panel-content-list-item-file-name-wireframe", __assign({}, transformedProps), children));
};

var VeltNotificationsPanelContentListItemHeadlineWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-notifications-panel-content-list-item-headline-wireframe", __assign({}, transformedProps), children));
};

var VeltNotificationsPanelContentListItemTimeWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-notifications-panel-content-list-item-time-wireframe", __assign({}, transformedProps), children));
};

var VeltNotificationsPanelContentListItemUnreadWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-notifications-panel-content-list-item-unread-wireframe", __assign({}, transformedProps), children));
};

var VeltNotificationsPanelContentListItemWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-notifications-panel-content-list-item-wireframe", __assign({}, transformedProps), children));
};
VeltNotificationsPanelContentListItemWireframe.Avatar = VeltNotificationsPanelContentListItemAvatarWireframe;
VeltNotificationsPanelContentListItemWireframe.Body = VeltNotificationsPanelContentListItemBodyWireframe;
VeltNotificationsPanelContentListItemWireframe.FileName = VeltNotificationsPanelContentListItemFileNameWireframe;
VeltNotificationsPanelContentListItemWireframe.Headline = VeltNotificationsPanelContentListItemHeadlineWireframe;
VeltNotificationsPanelContentListItemWireframe.Time = VeltNotificationsPanelContentListItemTimeWireframe;
VeltNotificationsPanelContentListItemWireframe.Unread = VeltNotificationsPanelContentListItemUnreadWireframe;

var VeltNotificationsPanelContentListWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-notifications-panel-content-list-wireframe", __assign({}, transformedProps), children));
};
VeltNotificationsPanelContentListWireframe.Item = VeltNotificationsPanelContentListItemWireframe;

var VeltNotificationsPanelContentAllReadContainerWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-notifications-panel-content-all-read-container-wireframe", __assign({}, transformedProps), children));
};

var VeltNotificationsPanelContentWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-notifications-panel-content-wireframe", __assign({}, transformedProps), children));
};
VeltNotificationsPanelContentWireframe.All = VeltNotificationsPanelContentAllWireframe;
VeltNotificationsPanelContentWireframe.ForYou = VeltNotificationsPanelContentForYouWireframe;
VeltNotificationsPanelContentWireframe.Documents = VeltNotificationsPanelContentDocumentsWireframe;
VeltNotificationsPanelContentWireframe.People = VeltNotificationsPanelContentPeopleWireframe;
VeltNotificationsPanelContentWireframe.LoadMore = VeltNotificationsPanelContentLoadMoreWireframe;
VeltNotificationsPanelContentWireframe.List = VeltNotificationsPanelContentListWireframe;
VeltNotificationsPanelContentWireframe.AllReadContainer = VeltNotificationsPanelContentAllReadContainerWireframe;

var VeltNotificationsPanelHeaderTabDocumentsWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-notifications-panel-header-tab-documents-wireframe", __assign({}, transformedProps), children));
};

var VeltNotificationsPanelHeaderTabForYouWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-notifications-panel-header-tab-for-you-wireframe", __assign({}, transformedProps), children));
};

var VeltNotificationsPanelHeaderTabPeopleWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-notifications-panel-header-tab-people-wireframe", __assign({}, transformedProps), children));
};

var VeltNotificationsPanelHeaderTabAllWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-notifications-panel-header-tab-all-wireframe", __assign({}, transformedProps), children));
};

var VeltNotificationsPanelHeaderWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-notifications-panel-header-wireframe", __assign({}, transformedProps), children));
};
VeltNotificationsPanelHeaderWireframe.TabAll = VeltNotificationsPanelHeaderTabAllWireframe;
VeltNotificationsPanelHeaderWireframe.TabDocuments = VeltNotificationsPanelHeaderTabDocumentsWireframe;
VeltNotificationsPanelHeaderWireframe.TabForYou = VeltNotificationsPanelHeaderTabForYouWireframe;
VeltNotificationsPanelHeaderWireframe.TabPeople = VeltNotificationsPanelHeaderTabPeopleWireframe;

var VeltNotificationsPanelReadAllButtonWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-notifications-panel-read-all-button-wireframe", __assign({}, transformedProps), children));
};

var VeltNotificationsPanelTitleWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-notifications-panel-title-wireframe", __assign({}, transformedProps), children));
};

var VeltNotificationsPanelViewAllButtonWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-notifications-panel-view-all-button-wireframe", __assign({}, transformedProps), children));
};

var VeltNotificationsPanelCloseButtonWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-notifications-panel-close-button-wireframe", __assign({}, transformedProps), children));
};

var VeltNotificationsPanelSkeletonWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-notifications-panel-skeleton-wireframe", __assign({}, transformedProps), children));
};

var VeltNotificationsPanelWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-notifications-panel-wireframe", __assign({}, transformedProps), children));
};
VeltNotificationsPanelWireframe.Content = VeltNotificationsPanelContentWireframe;
VeltNotificationsPanelWireframe.Header = VeltNotificationsPanelHeaderWireframe;
VeltNotificationsPanelWireframe.ReadAllButton = VeltNotificationsPanelReadAllButtonWireframe;
VeltNotificationsPanelWireframe.Title = VeltNotificationsPanelTitleWireframe;
VeltNotificationsPanelWireframe.ViewAllButton = VeltNotificationsPanelViewAllButtonWireframe;
VeltNotificationsPanelWireframe.CloseButton = VeltNotificationsPanelCloseButtonWireframe;
VeltNotificationsPanelWireframe.Skeleton = VeltNotificationsPanelSkeletonWireframe;

var VeltNotificationsToolIconWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-notifications-tool-icon-wireframe", __assign({}, transformedProps), children));
};

var VeltNotificationsToolLabelWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-notifications-tool-label-wireframe", __assign({}, transformedProps), children));
};

var VeltNotificationsToolUnreadCountWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-notifications-tool-unread-count-wireframe", __assign({}, transformedProps), children));
};

var VeltNotificationsToolUnreadIconWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-notifications-tool-unread-icon-wireframe", __assign({}, transformedProps), children));
};

var VeltNotificationsToolWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-notifications-tool-wireframe", __assign({}, transformedProps), children));
};
VeltNotificationsToolWireframe.Label = VeltNotificationsToolLabelWireframe;
VeltNotificationsToolWireframe.UnreadIcon = VeltNotificationsToolUnreadIconWireframe;
VeltNotificationsToolWireframe.Icon = VeltNotificationsToolIconWireframe;
VeltNotificationsToolWireframe.UnreadCount = VeltNotificationsToolUnreadCountWireframe;

var VeltConfirmDialogTitleWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-confirm-dialog-title-wireframe", __assign({}, transformedProps), children));
};

var VeltConfirmDialogMessageWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-confirm-dialog-message-wireframe", __assign({}, transformedProps), children));
};

var VeltConfirmDialogApproveButtonWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-confirm-dialog-approve-button-wireframe", __assign({}, transformedProps), children));
};

var VeltConfirmDialogRejectButtonWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-confirm-dialog-reject-button-wireframe", __assign({}, transformedProps), children));
};

var VeltConfirmDialogWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-confirm-dialog-wireframe", __assign({}, transformedProps), children));
};
VeltConfirmDialogWireframe.Title = VeltConfirmDialogTitleWireframe;
VeltConfirmDialogWireframe.Message = VeltConfirmDialogMessageWireframe;
VeltConfirmDialogWireframe.ApproveButton = VeltConfirmDialogApproveButtonWireframe;
VeltConfirmDialogWireframe.RejectButton = VeltConfirmDialogRejectButtonWireframe;

var VeltInlineReactionsSectionListWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-inline-reactions-section-list-wireframe", __assign({}, transformedProps), children));
};

var VeltInlineReactionsSectionPanelWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-inline-reactions-section-panel-wireframe", __assign({}, transformedProps), children));
};

var VeltInlineReactionsSectionToolContainerWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-inline-reactions-section-tool-container-wireframe", __assign({}, transformedProps), children));
};

var VeltInlineReactionsSectionWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-inline-reactions-section-wireframe", __assign({}, transformedProps), children));
};
VeltInlineReactionsSectionWireframe.List = VeltInlineReactionsSectionListWireframe;
VeltInlineReactionsSectionWireframe.Panel = VeltInlineReactionsSectionPanelWireframe;
VeltInlineReactionsSectionWireframe.ToolContainer = VeltInlineReactionsSectionToolContainerWireframe;

var VeltPersistentCommentModeCloseButtonWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-persistent-comment-mode-close-button-wireframe", __assign({}, transformedProps), children));
};

var VeltPersistentCommentModeLabelPrivateWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-persistent-comment-mode-label-private-wireframe", __assign({}, transformedProps), children));
};

var VeltPersistentCommentModeLabelPublicWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-persistent-comment-mode-label-public-wireframe", __assign({}, transformedProps), children));
};

var VeltPersistentCommentModeLabelWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-persistent-comment-mode-label-wireframe", __assign({}, transformedProps), children));
};
VeltPersistentCommentModeLabelWireframe.Private = VeltPersistentCommentModeLabelPrivateWireframe;
VeltPersistentCommentModeLabelWireframe.Public = VeltPersistentCommentModeLabelPublicWireframe;

var VeltPersistentCommentModeWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-persistent-comment-mode-wireframe", __assign({}, transformedProps), children));
};
VeltPersistentCommentModeWireframe.CloseButton = VeltPersistentCommentModeCloseButtonWireframe;
VeltPersistentCommentModeWireframe.Label = VeltPersistentCommentModeLabelWireframe;

var VeltMultiThreadCommentDialogCloseButtonWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-multi-thread-comment-dialog-close-button-wireframe", __assign({}, transformedProps), children));
};

var VeltMultiThreadCommentDialogCommentCountWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-multi-thread-comment-dialog-comment-count-wireframe", __assign({}, transformedProps), children));
};

var VeltMultiThreadCommentDialogComposerContainerWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-multi-thread-comment-dialog-composer-container-wireframe", __assign({}, transformedProps), children));
};

var VeltMultiThreadCommentDialogEmptyPlaceholderWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-multi-thread-comment-dialog-empty-placeholder-wireframe", __assign({}, transformedProps), children));
};

var VeltMultiThreadCommentDialogListWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-multi-thread-comment-dialog-list-wireframe", __assign({}, transformedProps), children));
};

var VeltMultiThreadCommentDialogMinimalActionsDropdownContentWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-multi-thread-comment-dialog-minimal-actions-dropdown-content-wireframe", __assign({}, transformedProps), children));
};
var MarkAllRead = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-multi-thread-comment-dialog-minimal-actions-dropdown-content-mark-all-read-wireframe", __assign({}, transformedProps), children));
};
var MarkAllResolved = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-multi-thread-comment-dialog-minimal-actions-dropdown-content-mark-all-resolved-wireframe", __assign({}, transformedProps), children));
};
VeltMultiThreadCommentDialogMinimalActionsDropdownContentWireframe.MarkAllRead = MarkAllRead;
VeltMultiThreadCommentDialogMinimalActionsDropdownContentWireframe.MarkAllResolved = MarkAllResolved;

var VeltMultiThreadCommentDialogMinimalActionsDropdownTriggerWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-multi-thread-comment-dialog-minimal-actions-dropdown-trigger-wireframe", __assign({}, transformedProps), children));
};

var VeltMultiThreadCommentDialogMinimalActionsDropdownWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-multi-thread-comment-dialog-minimal-actions-dropdown-wireframe", __assign({}, transformedProps), children));
};
VeltMultiThreadCommentDialogMinimalActionsDropdownWireframe.Content = VeltMultiThreadCommentDialogMinimalActionsDropdownContentWireframe;
VeltMultiThreadCommentDialogMinimalActionsDropdownWireframe.Trigger = VeltMultiThreadCommentDialogMinimalActionsDropdownTriggerWireframe;

var VeltMultiThreadCommentDialogMinimalFilterDropdownContentFilterAllWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-multi-thread-comment-dialog-minimal-filter-dropdown-content-filter-all-wireframe", __assign({}, transformedProps), children));
};

var VeltMultiThreadCommentDialogMinimalFilterDropdownContentFilterReadWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-multi-thread-comment-dialog-minimal-filter-dropdown-content-filter-read-wireframe", __assign({}, transformedProps), children));
};

var VeltMultiThreadCommentDialogMinimalFilterDropdownContentFilterResolvedWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-multi-thread-comment-dialog-minimal-filter-dropdown-content-filter-resolved-wireframe", __assign({}, transformedProps), children));
};

var VeltMultiThreadCommentDialogMinimalFilterDropdownContentFilterUnreadWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-multi-thread-comment-dialog-minimal-filter-dropdown-content-filter-unread-wireframe", __assign({}, transformedProps), children));
};

var VeltMultiThreadCommentDialogMinimalFilterDropdownContentSelectedIconWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-multi-thread-comment-dialog-minimal-filter-dropdown-content-selected-icon-wireframe", __assign({}, transformedProps), children));
};

var VeltMultiThreadCommentDialogMinimalFilterDropdownContentSortDateWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-multi-thread-comment-dialog-minimal-filter-dropdown-content-sort-date-wireframe", __assign({}, transformedProps), children));
};

var VeltMultiThreadCommentDialogMinimalFilterDropdownContentSortUnreadWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-multi-thread-comment-dialog-minimal-filter-dropdown-content-sort-unread-wireframe", __assign({}, transformedProps), children));
};

var VeltMultiThreadCommentDialogMinimalFilterDropdownContentWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-multi-thread-comment-dialog-minimal-filter-dropdown-content-wireframe", __assign({}, transformedProps), children));
};
VeltMultiThreadCommentDialogMinimalFilterDropdownContentWireframe.FilterAll = VeltMultiThreadCommentDialogMinimalFilterDropdownContentFilterAllWireframe;
VeltMultiThreadCommentDialogMinimalFilterDropdownContentWireframe.FilterUnread = VeltMultiThreadCommentDialogMinimalFilterDropdownContentFilterUnreadWireframe;
VeltMultiThreadCommentDialogMinimalFilterDropdownContentWireframe.FilterRead = VeltMultiThreadCommentDialogMinimalFilterDropdownContentFilterReadWireframe;
VeltMultiThreadCommentDialogMinimalFilterDropdownContentWireframe.FilterResolved = VeltMultiThreadCommentDialogMinimalFilterDropdownContentFilterResolvedWireframe;
VeltMultiThreadCommentDialogMinimalFilterDropdownContentWireframe.SelectedIcon = VeltMultiThreadCommentDialogMinimalFilterDropdownContentSelectedIconWireframe;
VeltMultiThreadCommentDialogMinimalFilterDropdownContentWireframe.SortDate = VeltMultiThreadCommentDialogMinimalFilterDropdownContentSortDateWireframe;
VeltMultiThreadCommentDialogMinimalFilterDropdownContentWireframe.SortUnread = VeltMultiThreadCommentDialogMinimalFilterDropdownContentSortUnreadWireframe;

var VeltMultiThreadCommentDialogMinimalFilterDropdownTriggerWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-multi-thread-comment-dialog-minimal-filter-dropdown-trigger-wireframe", __assign({}, transformedProps), children));
};

var VeltMultiThreadCommentDialogMinimalFilterDropdownWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-multi-thread-comment-dialog-minimal-filter-dropdown-wireframe", __assign({}, transformedProps), children));
};
VeltMultiThreadCommentDialogMinimalFilterDropdownWireframe.Content = VeltMultiThreadCommentDialogMinimalFilterDropdownContentWireframe;
VeltMultiThreadCommentDialogMinimalFilterDropdownWireframe.Trigger = VeltMultiThreadCommentDialogMinimalFilterDropdownTriggerWireframe;

var VeltMultiThreadCommentDialogNewThreadButtonWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-multi-thread-comment-dialog-new-thread-button-wireframe", __assign({}, transformedProps), children));
};

var VeltMultiThreadCommentDialogResetFilterButtonWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-multi-thread-comment-dialog-reset-filter-button-wireframe", __assign({}, transformedProps), children));
};

var VeltMultiThreadCommentDialogWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-multi-thread-comment-dialog-wireframe", __assign({}, transformedProps), children));
};
VeltMultiThreadCommentDialogWireframe.CommentCount = VeltMultiThreadCommentDialogCommentCountWireframe;
VeltMultiThreadCommentDialogWireframe.ComposerContainer = VeltMultiThreadCommentDialogComposerContainerWireframe;
VeltMultiThreadCommentDialogWireframe.List = VeltMultiThreadCommentDialogListWireframe;
VeltMultiThreadCommentDialogWireframe.CloseButton = VeltMultiThreadCommentDialogCloseButtonWireframe;
VeltMultiThreadCommentDialogWireframe.MinimalFilterDropdown = VeltMultiThreadCommentDialogMinimalFilterDropdownWireframe;
VeltMultiThreadCommentDialogWireframe.EmptyPlaceholder = VeltMultiThreadCommentDialogEmptyPlaceholderWireframe;
VeltMultiThreadCommentDialogWireframe.NewThreadButton = VeltMultiThreadCommentDialogNewThreadButtonWireframe;
VeltMultiThreadCommentDialogWireframe.MinimalActionsDropdown = VeltMultiThreadCommentDialogMinimalActionsDropdownWireframe;
VeltMultiThreadCommentDialogWireframe.ResetFilterButton = VeltMultiThreadCommentDialogResetFilterButtonWireframe;

var VeltCommentComposerWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-composer-wireframe", __assign({}, transformedProps), children));
};

var VeltCommentThreadWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-thread-wireframe", __assign({}, transformedProps), children));
};

var VeltMediaSourceSettingsToggleIconOpenWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-media-source-settings-toggle-icon-open-wireframe", __assign({}, transformedProps), children));
};

var VeltMediaSourceSettingsToggleIconCloseWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-media-source-settings-toggle-icon-close-wireframe", __assign({}, transformedProps), children));
};

var VeltMediaSourceSettingsToggleIconWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-media-source-settings-toggle-icon-wireframe", __assign({}, transformedProps), children));
};
VeltMediaSourceSettingsToggleIconWireframe.Open = VeltMediaSourceSettingsToggleIconOpenWireframe;
VeltMediaSourceSettingsToggleIconWireframe.Close = VeltMediaSourceSettingsToggleIconCloseWireframe;

var VeltMediaSourceSettingsSelectedLabelWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-media-source-settings-selected-label-wireframe", __assign({}, transformedProps), children));
};

var VeltMediaSourceSettingsOptionsItemLabelWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-media-source-settings-options-item-label-wireframe", __assign({}, transformedProps), children));
};

var VeltMediaSourceSettingsOptionsItemIconWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-media-source-settings-options-item-icon-wireframe", __assign({}, transformedProps), children));
};

var VeltMediaSourceSettingsOptionsItemWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-media-source-settings-options-item-wireframe", __assign({}, transformedProps), children));
};
VeltMediaSourceSettingsOptionsItemWireframe.Icon = VeltMediaSourceSettingsOptionsItemIconWireframe;
VeltMediaSourceSettingsOptionsItemWireframe.Label = VeltMediaSourceSettingsOptionsItemLabelWireframe;

var VeltMediaSourceSettingsOptionsWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-media-source-settings-options-wireframe", __assign({}, transformedProps), children));
};
VeltMediaSourceSettingsOptionsWireframe.Item = VeltMediaSourceSettingsOptionsItemWireframe;

var VeltMediaSourceSettingsDividerWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-media-source-settings-divider-wireframe", __assign({}, transformedProps), children));
};

var VeltMediaSourceSettingsAudioWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-media-source-settings-audio-wireframe", __assign({}, transformedProps), children));
};
VeltMediaSourceSettingsAudioWireframe.ToggleIcon = VeltMediaSourceSettingsToggleIconWireframe;
VeltMediaSourceSettingsAudioWireframe.SelectedLabel = VeltMediaSourceSettingsSelectedLabelWireframe;
VeltMediaSourceSettingsAudioWireframe.Options = VeltMediaSourceSettingsOptionsWireframe;
VeltMediaSourceSettingsAudioWireframe.Divider = VeltMediaSourceSettingsDividerWireframe;

var VeltMediaSourceSettingsVideoWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-media-source-settings-video-wireframe", __assign({}, transformedProps), children));
};
VeltMediaSourceSettingsVideoWireframe.ToggleIcon = VeltMediaSourceSettingsToggleIconWireframe;
VeltMediaSourceSettingsVideoWireframe.SelectedLabel = VeltMediaSourceSettingsSelectedLabelWireframe;
VeltMediaSourceSettingsVideoWireframe.Options = VeltMediaSourceSettingsOptionsWireframe;
VeltMediaSourceSettingsVideoWireframe.Divider = VeltMediaSourceSettingsDividerWireframe;

var VeltMediaSourceSettingsWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-media-source-settings-wireframe", __assign({}, transformedProps), children));
};
VeltMediaSourceSettingsWireframe.Audio = VeltMediaSourceSettingsAudioWireframe;
VeltMediaSourceSettingsWireframe.Video = VeltMediaSourceSettingsVideoWireframe;

var VeltRecorderAllToolWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-recorder-all-tool-wireframe", __assign({}, transformedProps), children));
};

var VeltRecorderAllToolMenuAudioWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-recorder-all-tool-menu-audio-wireframe", __assign({}, transformedProps), children));
};

var VeltRecorderAllToolMenuVideoWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-recorder-all-tool-menu-video-wireframe", __assign({}, transformedProps), children));
};

var VeltRecorderAllToolMenuScreenWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-recorder-all-tool-menu-screen-wireframe", __assign({}, transformedProps), children));
};

var VeltRecorderAllToolMenuWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-recorder-all-tool-menu-wireframe", __assign({}, transformedProps), children));
};
VeltRecorderAllToolMenuWireframe.Video = VeltRecorderAllToolMenuVideoWireframe;
VeltRecorderAllToolMenuWireframe.Audio = VeltRecorderAllToolMenuAudioWireframe;
VeltRecorderAllToolMenuWireframe.Screen = VeltRecorderAllToolMenuScreenWireframe;

var VeltRecorderAudioToolWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-recorder-audio-tool-wireframe", __assign({}, transformedProps), children));
};

var VeltRecorderScreenToolWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-recorder-screen-tool-wireframe", __assign({}, transformedProps), children));
};

var VeltRecorderVideoToolWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-recorder-video-tool-wireframe", __assign({}, transformedProps), children));
};

var VeltRecordingPreviewStepsDialogBottomPanelCloseWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-recording-preview-steps-dialog-bottom-panel-close-wireframe", __assign({}, transformedProps), children));
};

var VeltRecordingPreviewStepsDialogBottomPanelCountdownWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-recording-preview-steps-dialog-bottom-panel-countdown-wireframe", __assign({}, transformedProps), children));
};

var VeltRecordingPreviewStepsDialogBottomPanelIconWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-recording-preview-steps-dialog-bottom-panel-icon-wireframe", __assign({}, transformedProps), children));
};

var VeltRecordingPreviewStepsDialogBottomPanelWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-recording-preview-steps-dialog-bottom-panel-wireframe", __assign({}, transformedProps), children));
};
VeltRecordingPreviewStepsDialogBottomPanelWireframe.Icon = VeltRecordingPreviewStepsDialogBottomPanelIconWireframe;
VeltRecordingPreviewStepsDialogBottomPanelWireframe.Close = VeltRecordingPreviewStepsDialogBottomPanelCloseWireframe;
VeltRecordingPreviewStepsDialogBottomPanelWireframe.Countdown = VeltRecordingPreviewStepsDialogBottomPanelCountdownWireframe;

var VeltRecordingPreviewStepsDialogButtonPanelWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-recording-preview-steps-dialog-button-panel-wireframe", __assign({}, transformedProps), children));
};

var VeltRecordingPreviewStepsDialogCloseButtonWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-recording-preview-steps-dialog-close-button-wireframe", __assign({}, transformedProps), children));
};

var VeltRecordingPreviewStepsDialogMicButtonOffWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-recording-preview-steps-dialog-mic-button-off-wireframe", __assign({}, transformedProps), children));
};

var VeltRecordingPreviewStepsDialogMicButtonOnWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-recording-preview-steps-dialog-mic-button-on-wireframe", __assign({}, transformedProps), children));
};

var VeltRecordingPreviewStepsDialogMicButtonWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-recording-preview-steps-dialog-mic-button-wireframe", __assign({}, transformedProps), children));
};
VeltRecordingPreviewStepsDialogMicButtonWireframe.On = VeltRecordingPreviewStepsDialogMicButtonOnWireframe;
VeltRecordingPreviewStepsDialogMicButtonWireframe.Off = VeltRecordingPreviewStepsDialogMicButtonOffWireframe;

var VeltRecordingPreviewStepsDialogSettingsPanelWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-recording-preview-steps-dialog-settings-panel-wireframe", __assign({}, transformedProps), children));
};

var VeltRecordingPreviewStepsDialogSettingsWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-recording-preview-steps-dialog-settings-wireframe", __assign({}, transformedProps), children));
};

var VeltRecordingPreviewStepsDialogStartRecordingWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-recording-preview-steps-dialog-start-recording-wireframe", __assign({}, transformedProps), children));
};

var VeltRecordingPreviewStepsDialogTimerCountdownWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-recording-preview-steps-dialog-timer-countdown-wireframe", __assign({}, transformedProps), children));
};

var VeltRecordingPreviewStepsDialogTimerCancelWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-recording-preview-steps-dialog-timer-cancel-wireframe", __assign({}, transformedProps), children));
};

var VeltRecordingPreviewStepsDialogTimerWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-recording-preview-steps-dialog-timer-wireframe", __assign({}, transformedProps), children));
};
VeltRecordingPreviewStepsDialogTimerWireframe.Countdown = VeltRecordingPreviewStepsDialogTimerCountdownWireframe;
VeltRecordingPreviewStepsDialogTimerWireframe.Cancel = VeltRecordingPreviewStepsDialogTimerCancelWireframe;

var VeltRecordingPreviewStepsDialogWaveformWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-recording-preview-steps-dialog-waveform-wireframe", __assign({}, transformedProps), children));
};

var VeltRecordingPreviewStepsDialogAudioWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-recording-preview-steps-dialog-audio-wireframe", __assign({}, transformedProps), children));
};
VeltRecordingPreviewStepsDialogAudioWireframe.BottomPanel = VeltRecordingPreviewStepsDialogBottomPanelWireframe;
VeltRecordingPreviewStepsDialogAudioWireframe.ButtonPanel = VeltRecordingPreviewStepsDialogButtonPanelWireframe;
VeltRecordingPreviewStepsDialogAudioWireframe.CloseButton = VeltRecordingPreviewStepsDialogCloseButtonWireframe;
VeltRecordingPreviewStepsDialogAudioWireframe.MicButton = VeltRecordingPreviewStepsDialogMicButtonWireframe;
VeltRecordingPreviewStepsDialogAudioWireframe.SettingsPanel = VeltRecordingPreviewStepsDialogSettingsPanelWireframe;
VeltRecordingPreviewStepsDialogAudioWireframe.Settings = VeltRecordingPreviewStepsDialogSettingsWireframe;
VeltRecordingPreviewStepsDialogAudioWireframe.StartRecording = VeltRecordingPreviewStepsDialogStartRecordingWireframe;
VeltRecordingPreviewStepsDialogAudioWireframe.Timer = VeltRecordingPreviewStepsDialogTimerWireframe;
VeltRecordingPreviewStepsDialogAudioWireframe.Waveform = VeltRecordingPreviewStepsDialogWaveformWireframe;

var VeltRecordingPreviewStepsDialogCameraButtonOffWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-recording-preview-steps-dialog-camera-button-off-wireframe", __assign({}, transformedProps), children));
};

var VeltRecordingPreviewStepsDialogCameraButtonOnWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-recording-preview-steps-dialog-camera-button-on-wireframe", __assign({}, transformedProps), children));
};

var VeltRecordingPreviewStepsDialogCameraButtonWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-recording-preview-steps-dialog-camera-button-wireframe", __assign({}, transformedProps), children));
};
VeltRecordingPreviewStepsDialogCameraButtonWireframe.On = VeltRecordingPreviewStepsDialogCameraButtonOnWireframe;
VeltRecordingPreviewStepsDialogCameraButtonWireframe.Off = VeltRecordingPreviewStepsDialogCameraButtonOffWireframe;

var VeltRecordingPreviewStepsDialogCameraOffMessageWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-recording-preview-steps-dialog-camera-off-message-wireframe", __assign({}, transformedProps), children));
};

var VeltRecordingPreviewStepsDialogVideoPlayerWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-recording-preview-steps-dialog-video-player-wireframe", __assign({}, transformedProps), children));
};

var VeltRecordingPreviewStepsDialogVideoWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-recording-preview-steps-dialog-video-wireframe", __assign({}, transformedProps), children));
};
VeltRecordingPreviewStepsDialogVideoWireframe.BottomPanel = VeltRecordingPreviewStepsDialogBottomPanelWireframe;
VeltRecordingPreviewStepsDialogVideoWireframe.ButtonPanel = VeltRecordingPreviewStepsDialogButtonPanelWireframe;
VeltRecordingPreviewStepsDialogVideoWireframe.CameraButton = VeltRecordingPreviewStepsDialogCameraButtonWireframe;
VeltRecordingPreviewStepsDialogVideoWireframe.CameraOffMessage = VeltRecordingPreviewStepsDialogCameraOffMessageWireframe;
VeltRecordingPreviewStepsDialogVideoWireframe.CloseButton = VeltRecordingPreviewStepsDialogCloseButtonWireframe;
VeltRecordingPreviewStepsDialogVideoWireframe.MicButton = VeltRecordingPreviewStepsDialogMicButtonWireframe;
VeltRecordingPreviewStepsDialogVideoWireframe.SettingsPanel = VeltRecordingPreviewStepsDialogSettingsPanelWireframe;
VeltRecordingPreviewStepsDialogVideoWireframe.Settings = VeltRecordingPreviewStepsDialogSettingsWireframe;
VeltRecordingPreviewStepsDialogVideoWireframe.StartRecording = VeltRecordingPreviewStepsDialogStartRecordingWireframe;
VeltRecordingPreviewStepsDialogVideoWireframe.Timer = VeltRecordingPreviewStepsDialogTimerWireframe;
VeltRecordingPreviewStepsDialogVideoWireframe.VideoPlayer = VeltRecordingPreviewStepsDialogVideoPlayerWireframe;
VeltRecordingPreviewStepsDialogVideoWireframe.Waveform = VeltRecordingPreviewStepsDialogWaveformWireframe;

var VeltRecordingPreviewStepsDialogWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    transformWireframeProps(remainingProps);
    return (React.createElement(React.Fragment, null, children));
};
VeltRecordingPreviewStepsDialogWireframe.Video = VeltRecordingPreviewStepsDialogVideoWireframe;
VeltRecordingPreviewStepsDialogWireframe.Audio = VeltRecordingPreviewStepsDialogAudioWireframe;

var VeltRecorderControlPanelFloatingModeContainerWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-recorder-control-panel-floating-mode-container-wireframe", __assign({}, transformedProps), children));
};

var VeltRecorderControlPanelFloatingModeScreenVideoWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-recorder-control-panel-floating-mode-screen-video-wireframe", __assign({}, transformedProps), children));
};

var VeltRecorderControlPanelFloatingModeWaveformWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-recorder-control-panel-floating-mode-waveform-wireframe", __assign({}, transformedProps), children));
};

var VeltRecorderControlPanelActionBarWaveformWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-recorder-control-panel-action-bar-waveform-wireframe", __assign({}, transformedProps), children));
};

var VeltRecorderControlPanelActionBarClearWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-recorder-control-panel-action-bar-clear-wireframe", __assign({}, transformedProps), children));
};

var VeltRecorderControlPanelActionBarStopWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-recorder-control-panel-action-bar-stop-wireframe", __assign({}, transformedProps), children));
};

var VeltRecorderControlPanelActionBarTimeWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-recorder-control-panel-action-bar-time-wireframe", __assign({}, transformedProps), children));
};

var VeltRecorderControlPanelActionBarTogglePlayWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-recorder-control-panel-action-bar-toggle-play-wireframe", __assign({}, transformedProps), children));
};

var VeltRecorderControlPanelActionBarToggleWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-recorder-control-panel-action-bar-toggle-wireframe", __assign({}, transformedProps), children));
};
VeltRecorderControlPanelActionBarToggleWireframe.Pause = VeltRecorderControlPanelActionBarTogglePlayWireframe;
VeltRecorderControlPanelActionBarToggleWireframe.Play = VeltRecorderControlPanelActionBarTogglePlayWireframe;

var VeltRecorderControlPanelActionBarTypeIconWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-recorder-control-panel-action-bar-type-icon-wireframe", __assign({}, transformedProps), children));
};

var VeltRecorderControlPanelActionBarWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-recorder-control-panel-action-bar-wireframe", __assign({}, transformedProps), children));
};
VeltRecorderControlPanelActionBarWireframe.Clear = VeltRecorderControlPanelActionBarClearWireframe;
VeltRecorderControlPanelActionBarWireframe.Stop = VeltRecorderControlPanelActionBarStopWireframe;
VeltRecorderControlPanelActionBarWireframe.Time = VeltRecorderControlPanelActionBarTimeWireframe;
VeltRecorderControlPanelActionBarWireframe.Toggle = VeltRecorderControlPanelActionBarToggleWireframe;
VeltRecorderControlPanelActionBarWireframe.TypeIcon = VeltRecorderControlPanelActionBarTypeIconWireframe;
VeltRecorderControlPanelActionBarWireframe.Waveform = VeltRecorderControlPanelActionBarWaveformWireframe;

var VeltRecorderControlPanelCollapsedButtonOffWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-recorder-control-panel-collapsed-button-off-wireframe", __assign({}, transformedProps), children));
};

var VeltRecorderControlPanelCollapsedButtonOnWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-recorder-control-panel-collapsed-button-on-wireframe", __assign({}, transformedProps), children));
};

var VeltRecorderControlPanelCollapsedButtonWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-recorder-control-panel-collapsed-button-wireframe", __assign({}, transformedProps), children));
};
VeltRecorderControlPanelCollapsedButtonWireframe.On = VeltRecorderControlPanelCollapsedButtonOnWireframe;
VeltRecorderControlPanelCollapsedButtonWireframe.Off = VeltRecorderControlPanelCollapsedButtonOffWireframe;

var VeltRecorderControlPanelLoadingWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-recorder-control-panel-loading-wireframe", __assign({}, transformedProps), children));
};

var VeltRecorderControlPanelPausedWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-recorder-control-panel-paused-wireframe", __assign({}, transformedProps), children));
};

var VeltRecorderControlPanelVideoWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-recorder-control-panel-video-wireframe", __assign({}, transformedProps), children));
};

var VeltRecorderControlPanelFloatingModeWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-recorder-control-panel-floating-mode-wireframe", __assign({}, transformedProps), children));
};
VeltRecorderControlPanelFloatingModeWireframe.Container = VeltRecorderControlPanelFloatingModeContainerWireframe;
VeltRecorderControlPanelFloatingModeWireframe.ScreenVideo = VeltRecorderControlPanelFloatingModeScreenVideoWireframe;
VeltRecorderControlPanelFloatingModeWireframe.Waveform = VeltRecorderControlPanelFloatingModeWaveformWireframe;
VeltRecorderControlPanelFloatingModeWireframe.Video = VeltRecorderControlPanelVideoWireframe;
VeltRecorderControlPanelFloatingModeWireframe.CollapsedButton = VeltRecorderControlPanelCollapsedButtonWireframe;
VeltRecorderControlPanelFloatingModeWireframe.Paused = VeltRecorderControlPanelPausedWireframe;
VeltRecorderControlPanelFloatingModeWireframe.Loading = VeltRecorderControlPanelLoadingWireframe;
VeltRecorderControlPanelFloatingModeWireframe.ActionBar = VeltRecorderControlPanelActionBarWireframe;

var VeltRecorderControlPanelThreadModeWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-recorder-control-panel-thread-mode-wireframe", __assign({}, transformedProps), children));
};
VeltRecorderControlPanelThreadModeWireframe.Video = VeltRecorderControlPanelVideoWireframe;
VeltRecorderControlPanelThreadModeWireframe.Loading = VeltRecorderControlPanelLoadingWireframe;
VeltRecorderControlPanelThreadModeWireframe.ActionBar = VeltRecorderControlPanelActionBarWireframe;

var VeltRecorderControlPanelWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    transformWireframeProps(remainingProps);
    return (React.createElement(React.Fragment, null, children));
};
VeltRecorderControlPanelWireframe.FloatingMode = VeltRecorderControlPanelFloatingModeWireframe;
VeltRecorderControlPanelWireframe.ThreadMode = VeltRecorderControlPanelThreadModeWireframe;

var VeltRecorderPlayerAudioTogglePauseWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-recorder-player-audio-toggle-pause-wireframe", __assign({}, transformedProps), children));
};

var VeltRecorderPlayerAudioTogglePlayWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-recorder-player-audio-toggle-play-wireframe", __assign({}, transformedProps), children));
};

var VeltRecorderPlayerAudioToggleWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-recorder-player-audio-toggle-wireframe", __assign({}, transformedProps), children));
};
VeltRecorderPlayerAudioToggleWireframe.Play = VeltRecorderPlayerAudioTogglePlayWireframe;
VeltRecorderPlayerAudioToggleWireframe.Pause = VeltRecorderPlayerAudioTogglePauseWireframe;

var VeltRecorderPlayerAudioWaveformWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-recorder-player-audio-waveform-wireframe", __assign({}, transformedProps), children));
};

var VeltRecorderPlayerAudioWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-recorder-player-audio-wireframe", __assign({}, transformedProps), children));
};

var VeltRecorderPlayerCopyLinkWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-recorder-player-copy-link-wireframe", __assign({}, transformedProps), children));
};

var VeltRecorderPlayerDeleteWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-recorder-player-delete-wireframe", __assign({}, transformedProps), children));
};

var VeltRecorderPlayerNameWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-recorder-player-name-wireframe", __assign({}, transformedProps), children));
};

var VeltRecorderPlayerSubtitlesButtonWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-recorder-player-subtitles-button-wireframe", __assign({}, transformedProps), children));
};

var VeltRecorderPlayerSubtitlesWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-recorder-player-subtitles-wireframe", __assign({}, transformedProps), children));
};

var VeltRecorderPlayerTimeWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-recorder-player-time-wireframe", __assign({}, transformedProps), children));
};

var VeltRecorderPlayerTranscriptionWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-recorder-player-transcription-wireframe", __assign({}, transformedProps), children));
};

var VeltRecorderPlayerAvatarWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-recorder-player-avatar-wireframe", __assign({}, transformedProps), children));
};

var VeltRecorderPlayerAudioContainerWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-recorder-player-audio-container-wireframe", __assign({}, transformedProps), children));
};
VeltRecorderPlayerAudioContainerWireframe.AudioToggle = VeltRecorderPlayerAudioToggleWireframe;
VeltRecorderPlayerAudioContainerWireframe.Time = VeltRecorderPlayerTimeWireframe;
VeltRecorderPlayerAudioContainerWireframe.Audio = VeltRecorderPlayerAudioWireframe;
VeltRecorderPlayerAudioContainerWireframe.Subtitles = VeltRecorderPlayerSubtitlesWireframe;
VeltRecorderPlayerAudioContainerWireframe.Name = VeltRecorderPlayerNameWireframe;
VeltRecorderPlayerAudioContainerWireframe.SubtitlesButton = VeltRecorderPlayerSubtitlesButtonWireframe;
VeltRecorderPlayerAudioContainerWireframe.Transcription = VeltRecorderPlayerTranscriptionWireframe;
VeltRecorderPlayerAudioContainerWireframe.CopyLink = VeltRecorderPlayerCopyLinkWireframe;
VeltRecorderPlayerAudioContainerWireframe.Delete = VeltRecorderPlayerDeleteWireframe;
VeltRecorderPlayerAudioContainerWireframe.AudioWaveform = VeltRecorderPlayerAudioWaveformWireframe;
VeltRecorderPlayerAudioContainerWireframe.Avatar = VeltRecorderPlayerAvatarWireframe;

var VeltRecorderPlayerFullScreenButtonWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-recorder-player-full-screen-button-wireframe", __assign({}, transformedProps), children));
};

var VeltRecorderPlayerOverlayWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-recorder-player-overlay-wireframe", __assign({}, transformedProps), children));
};

var VeltRecorderPlayerPlayButtonWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-recorder-player-play-button-wireframe", __assign({}, transformedProps), children));
};

var VeltRecorderPlayerTimelineSeekBarWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-recorder-player-timeline-seek-bar-wireframe", __assign({}, transformedProps), children));
};

var VeltRecorderPlayerTimelineWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-recorder-player-timeline-wireframe", __assign({}, transformedProps), children));
};
VeltRecorderPlayerTimelineWireframe.SeekBar = VeltRecorderPlayerTimelineSeekBarWireframe;

var VeltRecorderPlayerVideoWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-recorder-player-video-wireframe", __assign({}, transformedProps), children));
};

var VeltRecorderPlayerVideoContainerWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-recorder-player-video-container-wireframe", __assign({}, transformedProps), children));
};
VeltRecorderPlayerVideoContainerWireframe.Video = VeltRecorderPlayerVideoWireframe;
VeltRecorderPlayerVideoContainerWireframe.Timeline = VeltRecorderPlayerTimelineWireframe;
VeltRecorderPlayerVideoContainerWireframe.PlayButton = VeltRecorderPlayerPlayButtonWireframe;
VeltRecorderPlayerVideoContainerWireframe.FullScreenButton = VeltRecorderPlayerFullScreenButtonWireframe;
VeltRecorderPlayerVideoContainerWireframe.Overlay = VeltRecorderPlayerOverlayWireframe;
VeltRecorderPlayerVideoContainerWireframe.Time = VeltRecorderPlayerTimeWireframe;
VeltRecorderPlayerVideoContainerWireframe.Subtitles = VeltRecorderPlayerSubtitlesWireframe;
VeltRecorderPlayerVideoContainerWireframe.Name = VeltRecorderPlayerNameWireframe;
VeltRecorderPlayerVideoContainerWireframe.SubtitlesButton = VeltRecorderPlayerSubtitlesButtonWireframe;
VeltRecorderPlayerVideoContainerWireframe.Transcription = VeltRecorderPlayerTranscriptionWireframe;
VeltRecorderPlayerVideoContainerWireframe.CopyLink = VeltRecorderPlayerCopyLinkWireframe;
VeltRecorderPlayerVideoContainerWireframe.Delete = VeltRecorderPlayerDeleteWireframe;
VeltRecorderPlayerVideoContainerWireframe.Avatar = VeltRecorderPlayerAvatarWireframe;

var VeltRecorderPlayerWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    transformWireframeProps(remainingProps);
    return (React.createElement(React.Fragment, null, children));
};
VeltRecorderPlayerWireframe.AudioContainer = VeltRecorderPlayerAudioContainerWireframe;
VeltRecorderPlayerWireframe.VideoContainer = VeltRecorderPlayerVideoContainerWireframe;

var VeltVideoPlayerControlsDeleteButtonWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-video-player-controls-delete-button-wireframe", __assign({}, transformedProps), children));
};

var VeltVideoPlayerControlsProgressBarWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-video-player-controls-progress-bar-wireframe", __assign({}, transformedProps), children));
};

var VeltVideoPlayerControlsSettingsButtonWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-video-player-controls-settings-button-wireframe", __assign({}, transformedProps), children));
};

var VeltVideoPlayerControlsSubtitleButtonIconWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-video-player-controls-subtitle-button-icon-wireframe", __assign({}, transformedProps), children));
};

var VeltVideoPlayerControlsSubtitleButtonTooltipWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-video-player-controls-subtitle-button-tooltip-wireframe", __assign({}, transformedProps), children));
};

var VeltVideoPlayerControlsSubtitleButtonWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-video-player-controls-subtitle-button-wireframe", __assign({}, transformedProps), children));
};
VeltVideoPlayerControlsSubtitleButtonWireframe.Icon = VeltVideoPlayerControlsSubtitleButtonIconWireframe;
VeltVideoPlayerControlsSubtitleButtonWireframe.Tooltip = VeltVideoPlayerControlsSubtitleButtonTooltipWireframe;

var VeltVideoPlayerControlsTimeWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-video-player-controls-time-wireframe", __assign({}, transformedProps), children));
};

var VeltVideoPlayerControlsTogglePauseWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-video-player-controls-toggle-pause-wireframe", __assign({}, transformedProps), children));
};

var VeltVideoPlayerControlsTogglePlayWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-video-player-controls-toggle-play-wireframe", __assign({}, transformedProps), children));
};

var VeltVideoPlayerControlsToggleButtonWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-video-player-controls-toggle-button-wireframe", __assign({}, transformedProps), children));
};
VeltVideoPlayerControlsToggleButtonWireframe.Play = VeltVideoPlayerControlsTogglePlayWireframe;
VeltVideoPlayerControlsToggleButtonWireframe.Pause = VeltVideoPlayerControlsTogglePauseWireframe;

var VeltVideoPlayerControlsTranscriptionIconWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-video-player-controls-transcription-icon-wireframe", __assign({}, transformedProps), children));
};

var VeltVideoPlayerControlsTranscriptionTooltipWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-video-player-controls-transcription-tooltip-wireframe", __assign({}, transformedProps), children));
};

var VeltVideoPlayerControlsTranscriptionButtonWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-video-player-controls-transcription-button-wireframe", __assign({}, transformedProps), children));
};
VeltVideoPlayerControlsTranscriptionButtonWireframe.Icon = VeltVideoPlayerControlsTranscriptionIconWireframe;
VeltVideoPlayerControlsTranscriptionButtonWireframe.Tooltip = VeltVideoPlayerControlsTranscriptionTooltipWireframe;

var VeltVideoPlayerControlsVolumeButtonWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-video-player-controls-volume-button-wireframe", __assign({}, transformedProps), children));
};

var VeltVideoPlayerControlsCurrentTimeWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-video-player-controls-current-time-wireframe", __assign({}, transformedProps), children));
};

var VeltVideoPlayerControlsTotalTimeWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-video-player-controls-total-time-wireframe", __assign({}, transformedProps), children));
};

var VeltVideoPlayerControlsWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-video-player-controls-wireframe", __assign({}, transformedProps), children));
};
VeltVideoPlayerControlsWireframe.DeleteButton = VeltVideoPlayerControlsDeleteButtonWireframe;
VeltVideoPlayerControlsWireframe.ProgressBar = VeltVideoPlayerControlsProgressBarWireframe;
VeltVideoPlayerControlsWireframe.SettingsButton = VeltVideoPlayerControlsSettingsButtonWireframe;
VeltVideoPlayerControlsWireframe.SubtitleButton = VeltVideoPlayerControlsSubtitleButtonWireframe;
VeltVideoPlayerControlsWireframe.Time = VeltVideoPlayerControlsTimeWireframe;
VeltVideoPlayerControlsWireframe.TranscriptionButton = VeltVideoPlayerControlsTranscriptionButtonWireframe;
VeltVideoPlayerControlsWireframe.ToggleButton = VeltVideoPlayerControlsToggleButtonWireframe;
VeltVideoPlayerControlsWireframe.VolumeButton = VeltVideoPlayerControlsVolumeButtonWireframe;
VeltVideoPlayerControlsWireframe.CurrentTime = VeltVideoPlayerControlsCurrentTimeWireframe;
VeltVideoPlayerControlsWireframe.TotalTime = VeltVideoPlayerControlsTotalTimeWireframe;

var VeltVideoPlayerCopyLinkWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-video-player-copy-link-wireframe", __assign({}, transformedProps), children));
};

var VeltVideoPlayerDisplayWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-video-player-display-wireframe", __assign({}, transformedProps), children));
};

var VeltVideoPlayerMinimizeButtonWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-video-player-minimize-button-wireframe", __assign({}, transformedProps), children));
};

var VeltVideoPlayerPanelWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-video-player-panel-wireframe", __assign({}, transformedProps), children));
};

var VeltVideoPlayerSubtitlesWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-video-player-subtitles-wireframe", __assign({}, transformedProps), children));
};

var VeltVideoPlayerTranscriptionWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-video-player-transcription-wireframe", __assign({}, transformedProps), children));
};

var VeltVideoPlayerWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-video-player-wireframe", __assign({}, transformedProps), children));
};
VeltVideoPlayerWireframe.Controls = VeltVideoPlayerControlsWireframe;
VeltVideoPlayerWireframe.CopyLink = VeltVideoPlayerCopyLinkWireframe;
VeltVideoPlayerWireframe.Display = VeltVideoPlayerDisplayWireframe;
VeltVideoPlayerWireframe.MinimizeButton = VeltVideoPlayerMinimizeButtonWireframe;
VeltVideoPlayerWireframe.Panel = VeltVideoPlayerPanelWireframe;
VeltVideoPlayerWireframe.Subtitles = VeltVideoPlayerSubtitlesWireframe;
VeltVideoPlayerWireframe.Transcription = VeltVideoPlayerTranscriptionWireframe;

var VeltVideoEditorPlayerTitleWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-video-editor-player-title-wireframe", __assign({}, transformedProps), children));
};

var VeltVideoEditorPlayerApplyButtonLoadingWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-video-editor-player-apply-button-loading-wireframe", __assign({}, transformedProps), children));
};

var VeltVideoEditorPlayerApplyButtonWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-video-editor-player-apply-button-wireframe", __assign({}, transformedProps), children));
};
VeltVideoEditorPlayerApplyButtonWireframe.Loading = VeltVideoEditorPlayerApplyButtonLoadingWireframe;

var VeltVideoEditorPlayerCloseButtonWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-video-editor-player-close-button-wireframe", __assign({}, transformedProps), children));
};

var VeltVideoEditorPlayerPreviewLoadingWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-video-editor-player-preview-loading-wireframe", __assign({}, transformedProps), children));
};

var VeltVideoEditorPlayerPreviewVideoWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-video-editor-player-preview-video-wireframe", __assign({}, transformedProps), children));
};

var VeltVideoEditorPlayerPreviewWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-video-editor-player-preview-wireframe", __assign({}, transformedProps), children));
};
VeltVideoEditorPlayerPreviewWireframe.Loading = VeltVideoEditorPlayerPreviewLoadingWireframe;
VeltVideoEditorPlayerPreviewWireframe.Video = VeltVideoEditorPlayerPreviewVideoWireframe;

var VeltVideoEditorPlayerToggleButtonWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-video-editor-player-toggle-button-wireframe", __assign({}, transformedProps), children));
};

var VeltVideoEditorPlayerTimeWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-video-editor-player-time-wireframe", __assign({}, transformedProps), children));
};

var VeltVideoEditorPlayerCurrentTimeWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-video-editor-player-current-time-wireframe", __assign({}, transformedProps), children));
};

var VeltVideoEditorPlayerTotalTimeWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-video-editor-player-total-time-wireframe", __assign({}, transformedProps), children));
};

var VeltVideoEditorPlayerSplitButtonWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-video-editor-player-split-button-wireframe", __assign({}, transformedProps), children));
};

var VeltVideoEditorPlayerDeleteButtonWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-video-editor-player-delete-button-wireframe", __assign({}, transformedProps), children));
};

var VeltVideoEditorPlayerTimelineWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-video-editor-player-timeline-wireframe", __assign({}, transformedProps), children));
};

var VeltVideoEditorPlayerWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-video-editor-player-wireframe", __assign({}, transformedProps), children));
};
VeltVideoEditorPlayerWireframe.Title = VeltVideoEditorPlayerTitleWireframe;
VeltVideoEditorPlayerWireframe.ApplyButton = VeltVideoEditorPlayerApplyButtonWireframe;
VeltVideoEditorPlayerWireframe.CloseButton = VeltVideoEditorPlayerCloseButtonWireframe;
VeltVideoEditorPlayerWireframe.Preview = VeltVideoEditorPlayerPreviewWireframe;
VeltVideoEditorPlayerWireframe.ToggleButton = VeltVideoEditorPlayerToggleButtonWireframe;
VeltVideoEditorPlayerWireframe.Time = VeltVideoEditorPlayerTimeWireframe;
VeltVideoEditorPlayerWireframe.CurrentTime = VeltVideoEditorPlayerCurrentTimeWireframe;
VeltVideoEditorPlayerWireframe.TotalTime = VeltVideoEditorPlayerTotalTimeWireframe;
VeltVideoEditorPlayerWireframe.SplitButton = VeltVideoEditorPlayerSplitButtonWireframe;
VeltVideoEditorPlayerWireframe.DeleteButton = VeltVideoEditorPlayerDeleteButtonWireframe;
VeltVideoEditorPlayerWireframe.Timeline = VeltVideoEditorPlayerTimelineWireframe;

var VeltSubtitlesTextWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-subtitles-text-wireframe", __assign({}, transformedProps), children));
};

var VeltSubtitlesEmbedModeWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-subtitles-embed-mode-wireframe", __assign({}, transformedProps), children));
};
VeltSubtitlesEmbedModeWireframe.Text = VeltSubtitlesTextWireframe;

var VeltSubtitlesPanelWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-subtitles-panel-wireframe", __assign({}, transformedProps), children));
};

var VeltSubtitlesButtonWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-subtitles-button-wireframe", __assign({}, transformedProps), children));
};

var VeltSubtitlesTooltipWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-subtitles-tooltip-wireframe", __assign({}, transformedProps), children));
};

var VeltSubtitlesCloseButtonWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-subtitles-close-button-wireframe", __assign({}, transformedProps), children));
};

var VeltSubtitlesFloatingModeWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-subtitles-floating-mode-wireframe", __assign({}, transformedProps), children));
};
VeltSubtitlesFloatingModeWireframe.Button = VeltSubtitlesButtonWireframe;
VeltSubtitlesFloatingModeWireframe.Tooltip = VeltSubtitlesTooltipWireframe;
VeltSubtitlesFloatingModeWireframe.Panel = VeltSubtitlesPanelWireframe;
VeltSubtitlesFloatingModeWireframe.CloseButton = VeltSubtitlesCloseButtonWireframe;
VeltSubtitlesFloatingModeWireframe.Text = VeltSubtitlesTextWireframe;

var VeltSubtitlesWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    transformWireframeProps(remainingProps);
    return (React.createElement(React.Fragment, null, children));
};
VeltSubtitlesWireframe.EmbedMode = VeltSubtitlesEmbedModeWireframe;
VeltSubtitlesWireframe.FloatingMode = VeltSubtitlesFloatingModeWireframe;

var VeltTranscriptionCloseButtonWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-transcription-close-button-wireframe", __assign({}, transformedProps), children));
};

var VeltTranscriptionContentItemTextWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-transcription-content-item-text-wireframe", __assign({}, transformedProps), children));
};

var VeltTranscriptionContentItemTimeWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-transcription-content-item-time-wireframe", __assign({}, transformedProps), children));
};

var VeltTranscriptionContentItemWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-transcription-content-item-wireframe", __assign({}, transformedProps), children));
};
VeltTranscriptionContentItemWireframe.Time = VeltTranscriptionContentItemTimeWireframe;
VeltTranscriptionContentItemWireframe.Text = VeltTranscriptionContentItemTextWireframe;

var VeltTranscriptionContentWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-transcription-content-wireframe", __assign({}, transformedProps), children));
};
VeltTranscriptionContentWireframe.Item = VeltTranscriptionContentItemWireframe;

var VeltTranscriptionCopyLinkButtonWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-transcription-copy-link-button-wireframe", __assign({}, transformedProps), children));
};

var VeltTranscriptionCopyLinkTooltipWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-transcription-copy-link-tooltip-wireframe", __assign({}, transformedProps), children));
};

var VeltTranscriptionCopyLinkWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-transcription-copy-link-wireframe", __assign({}, transformedProps), children));
};
VeltTranscriptionCopyLinkWireframe.Button = VeltTranscriptionCopyLinkButtonWireframe;
VeltTranscriptionCopyLinkWireframe.Tooltip = VeltTranscriptionCopyLinkTooltipWireframe;

var VeltTranscriptionSummaryExpandToggleOffWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-transcription-summary-expand-toggle-off-wireframe", __assign({}, transformedProps), children));
};

var VeltTranscriptionSummaryExpandToggleOnWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-transcription-summary-expand-toggle-on-wireframe", __assign({}, transformedProps), children));
};

var VeltTranscriptionSummaryExpandToggleWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-transcription-summary-expand-toggle-wireframe", __assign({}, transformedProps), children));
};
VeltTranscriptionSummaryExpandToggleWireframe.On = VeltTranscriptionSummaryExpandToggleOnWireframe;
VeltTranscriptionSummaryExpandToggleWireframe.Off = VeltTranscriptionSummaryExpandToggleOffWireframe;

var VeltTranscriptionSummaryTextWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-transcription-summary-text-wireframe", __assign({}, transformedProps), children));
};

var VeltTranscriptionSummaryWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-transcription-summary-wireframe", __assign({}, transformedProps), children));
};
VeltTranscriptionSummaryWireframe.ExpandToggle = VeltTranscriptionSummaryExpandToggleWireframe;
VeltTranscriptionSummaryWireframe.Text = VeltTranscriptionSummaryTextWireframe;

var VeltTranscriptionPanelWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-transcription-panel-wireframe", __assign({}, transformedProps), children));
};
VeltTranscriptionPanelWireframe.CloseButton = VeltTranscriptionCloseButtonWireframe;
VeltTranscriptionPanelWireframe.CopyLink = VeltTranscriptionCopyLinkWireframe;
VeltTranscriptionPanelWireframe.Summary = VeltTranscriptionSummaryWireframe;
VeltTranscriptionPanelWireframe.Content = VeltTranscriptionContentWireframe;

var VeltTranscriptionEmbedModeWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-transcription-embed-mode-wireframe", __assign({}, transformedProps), children));
};
VeltTranscriptionEmbedModeWireframe.Panel = VeltTranscriptionPanelWireframe;

var VeltTranscriptionPanelContainerWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-transcription-panel-container-wireframe", __assign({}, transformedProps), children));
};

var VeltTranscriptionButtonWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-transcription-button-wireframe", __assign({}, transformedProps), children));
};

var VeltTranscriptionTooltipWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-transcription-tooltip-wireframe", __assign({}, transformedProps), children));
};

var VeltTranscriptionFloatingModeWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-transcription-floating-mode-wireframe", __assign({}, transformedProps), children));
};
VeltTranscriptionFloatingModeWireframe.Button = VeltTranscriptionButtonWireframe;
VeltTranscriptionFloatingModeWireframe.Tooltip = VeltTranscriptionTooltipWireframe;
VeltTranscriptionFloatingModeWireframe.PanelContainer = VeltTranscriptionPanelContainerWireframe;
VeltTranscriptionFloatingModeWireframe.Panel = VeltTranscriptionPanelWireframe;

var VeltTranscriptionWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    transformWireframeProps(remainingProps);
    return (React.createElement(React.Fragment, null, children));
};
VeltTranscriptionWireframe.EmbedMode = VeltTranscriptionEmbedModeWireframe;
VeltTranscriptionWireframe.FloatingMode = VeltTranscriptionFloatingModeWireframe;

var VeltButtonWireframe = function (props) {
    var id = props.id, disabled = props.disabled, active = props.active, type = props.type, group = props.group, children = props.children, remainingProps = __rest(props, ["id", "disabled", "active", "type", "group", "children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    var ref = useRef();
    return (React.createElement("velt-button-wireframe", __assign({ ref: ref, id: id, disabled: [true, false].includes(disabled) ? (disabled ? 'true' : 'false') : undefined, active: [true, false].includes(active) ? (active ? 'true' : 'false') : undefined, type: type, group: group }, transformedProps), children));
};

function useClient() {
    var client = useVeltClient().client;
    var _a = React.useState(), veltClient = _a[0], setVeltClient = _a[1];
    React.useEffect(function () {
        if (!client || veltClient)
            return;
        setVeltClient(client);
    }, [client, setVeltClient, veltClient]);
    return veltClient;
}
function useIdentify(user, userOptions) {
    var client = useVeltClient().client;
    // Memoize the identify call
    var shouldIdentify = React.useMemo(function () {
        return { user: user, userOptions: userOptions };
    }, [JSON.stringify(user), JSON.stringify(userOptions)]);
    React.useEffect(function () {
        if (client) {
            client.identify(shouldIdentify.user, shouldIdentify.userOptions);
        }
    }, [client, shouldIdentify]);
}
function useSetDocument(documentId, documentMetadata) {
    var client = useVeltClient().client;
    // Memoize the setDocument call
    var shouldSetDocument = React.useMemo(function () {
        return {
            documentId: documentId,
            documentMetadata: documentMetadata
        };
    }, [documentId, JSON.stringify(documentMetadata)]);
    React.useEffect(function () {
        if (client) {
            client.setDocument(shouldSetDocument.documentId, shouldSetDocument.documentMetadata);
        }
    }, [client, shouldSetDocument]);
}
function useSetDocumentId(documentId) {
    var client = useVeltClient().client;
    // Memoize the documentId
    var memoizedDocumentId = React.useMemo(function () { return documentId; }, [documentId]);
    React.useEffect(function () {
        if (client) {
            client.setDocumentId(memoizedDocumentId);
        }
    }, [client, memoizedDocumentId]);
}
function useSetDocuments() {
    var client = useVeltClient().client;
    var _a = React.useState(undefined), data = _a[0], setData = _a[1];
    // Memoize the setDocuments call
    var memoizedData = React.useMemo(function () {
        return data;
    }, [JSON.stringify(data === null || data === void 0 ? void 0 : data.documents), JSON.stringify(data === null || data === void 0 ? void 0 : data.options)]);
    React.useEffect(function () {
        var _a;
        if (client && ((_a = memoizedData === null || memoizedData === void 0 ? void 0 : memoizedData.documents) === null || _a === void 0 ? void 0 : _a.length)) {
            client.setDocuments(memoizedData.documents, memoizedData.options);
        }
    }, [client === null || client === void 0 ? void 0 : client.setDocuments, memoizedData]);
    // Memoize the setDocuments callback
    var setDocumentsCallback = React.useCallback(function (documents, options) {
        setData({ documents: documents, options: options });
    }, []); // Empty dependency array since it only uses setState which is stable
    return {
        setDocuments: setDocumentsCallback
    };
}
function useUnsetDocumentId() {
    var client = useVeltClient().client;
    React.useEffect(function () {
        client && client.unsetDocumentId && client.unsetDocumentId();
    }, [client]);
}
function useUnsetDocuments() {
    var client = useVeltClient().client;
    React.useEffect(function () {
        client && client.unsetDocuments && client.unsetDocuments();
    }, [client]);
}
function useSetLocation(location, appendLocation) {
    var client = useVeltClient().client;
    // Memoize the setLocation call
    var shouldSetLocation = React.useMemo(function () {
        return { location: location, appendLocation: appendLocation };
    }, [JSON.stringify(location), appendLocation]);
    React.useEffect(function () {
        if (client) {
            client.setLocation(shouldSetLocation.location, shouldSetLocation.appendLocation);
        }
    }, [client, shouldSetLocation]);
}
function useVeltInitState() {
    var client = useVeltClient().client;
    var _a = React.useState(), data = _a[0], setData = _a[1];
    React.useEffect(function () {
        if (!(client === null || client === void 0 ? void 0 : client.getVeltInitState))
            return;
        var subscription = client === null || client === void 0 ? void 0 : client.getVeltInitState().subscribe(function (res) {
            setData(res);
        });
        return function () {
            subscription.unsubscribe();
        };
    }, [client === null || client === void 0 ? void 0 : client.getVeltInitState]);
    return data;
}

function useCommentUtils() {
    var _a = React.useState(), commentElement = _a[0], setCommentElement = _a[1];
    var client = useVeltClient().client;
    React.useEffect(function () {
        if (!client || commentElement)
            return;
        var loadedCommentElement = client.getCommentElement();
        setCommentElement(loadedCommentElement);
    }, [client, setCommentElement, commentElement]);
    return commentElement;
}
function useCommentAnnotations(documentId, location) {
    var commentElement = useCommentUtils();
    var _a = React.useState(undefined), data = _a[0], setData = _a[1];
    var subscriptionRef = React.useRef();
    // Memoize the inputs
    var inputs = React.useMemo(function () {
        return { documentId: documentId, location: location };
    }, [documentId, JSON.stringify(location)]);
    useEffect(function () {
        if (!(commentElement === null || commentElement === void 0 ? void 0 : commentElement.getAllCommentAnnotations))
            return;
        // Unsubscribe from the previous subscription if it exists
        if (subscriptionRef.current) {
            subscriptionRef.current.unsubscribe();
        }
        var subscription = commentElement.getAllCommentAnnotations(inputs.documentId, inputs.location)
            .subscribe(function (res) {
            setData(res);
        });
        // Store the new subscription
        subscriptionRef.current = subscription;
        // Cleanup function
        return function () {
            if (subscriptionRef.current) {
                subscriptionRef.current.unsubscribe();
            }
        };
    }, [commentElement === null || commentElement === void 0 ? void 0 : commentElement.getAllCommentAnnotations, inputs]);
    return data;
}
function useUnreadCommentCountByAnnotationId(annotationId) {
    var commentElement = useCommentUtils();
    var _a = React.useState(null), data = _a[0], setData = _a[1];
    var subscriptionRef = React.useRef();
    // Memoize the input
    var memoizedAnnotationId = React.useMemo(function () { return annotationId; }, [annotationId]);
    useEffect(function () {
        if (!(commentElement === null || commentElement === void 0 ? void 0 : commentElement.getUnreadCommentCountByAnnotationId))
            return;
        // Unsubscribe from the previous subscription if it exists
        if (subscriptionRef.current) {
            subscriptionRef.current.unsubscribe();
        }
        var subscription = commentElement.getUnreadCommentCountByAnnotationId(memoizedAnnotationId)
            .subscribe(function (res) {
            setData(res);
        });
        // Store the new subscription
        subscriptionRef.current = subscription;
        // Cleanup function
        return function () {
            if (subscriptionRef.current) {
                subscriptionRef.current.unsubscribe();
            }
        };
    }, [commentElement === null || commentElement === void 0 ? void 0 : commentElement.getUnreadCommentCountByAnnotationId, memoizedAnnotationId]);
    return data;
}
function useUnreadCommentAnnotationCountOnCurrentDocument() {
    var commentElement = useCommentUtils();
    var _a = React.useState(null), data = _a[0], setData = _a[1];
    useEffect(function () {
        if (!(commentElement === null || commentElement === void 0 ? void 0 : commentElement.getUnreadCommentAnnotationCountOnCurrentDocument))
            return;
        var subscription = commentElement.getUnreadCommentAnnotationCountOnCurrentDocument().subscribe(function (res) {
            setData(res);
        });
        return function () {
            subscription.unsubscribe();
        };
    }, [commentElement === null || commentElement === void 0 ? void 0 : commentElement.getUnreadCommentAnnotationCountOnCurrentDocument]);
    return data;
}
function useUnreadCommentCountOnCurrentDocument() {
    var commentElement = useCommentUtils();
    var _a = React.useState(null), data = _a[0], setData = _a[1];
    useEffect(function () {
        if (!(commentElement === null || commentElement === void 0 ? void 0 : commentElement.getUnreadCommentCountOnCurrentDocument))
            return;
        var subscription = commentElement.getUnreadCommentCountOnCurrentDocument().subscribe(function (res) {
            setData(res);
        });
        return function () {
            subscription.unsubscribe();
        };
    }, [commentElement === null || commentElement === void 0 ? void 0 : commentElement.getUnreadCommentCountOnCurrentDocument]);
    return data;
}
function useUnreadCommentCountByLocationId(locationId) {
    var commentElement = useCommentUtils();
    var _a = React.useState(null), data = _a[0], setData = _a[1];
    var subscriptionRef = React.useRef();
    // Memoize the input
    var memoizedLocationId = React.useMemo(function () { return locationId; }, [locationId]);
    useEffect(function () {
        if (!(commentElement === null || commentElement === void 0 ? void 0 : commentElement.getUnreadCommentCountByLocationId))
            return;
        // Unsubscribe from the previous subscription if it exists
        if (subscriptionRef.current) {
            subscriptionRef.current.unsubscribe();
        }
        var subscription = commentElement.getUnreadCommentCountByLocationId(memoizedLocationId)
            .subscribe(function (res) {
            setData(res);
        });
        // Store the new subscription
        subscriptionRef.current = subscription;
        // Cleanup function
        return function () {
            if (subscriptionRef.current) {
                subscriptionRef.current.unsubscribe();
            }
        };
    }, [commentElement === null || commentElement === void 0 ? void 0 : commentElement.getUnreadCommentCountByLocationId, memoizedLocationId]);
    return data;
}
function useUnreadCommentAnnotationCountByLocationId(locationId) {
    var commentElement = useCommentUtils();
    var _a = React.useState(null), data = _a[0], setData = _a[1];
    var subscriptionRef = React.useRef();
    // Memoize the input
    var memoizedLocationId = React.useMemo(function () { return locationId; }, [locationId]);
    useEffect(function () {
        if (!(commentElement === null || commentElement === void 0 ? void 0 : commentElement.getUnreadCommentAnnotationCountByLocationId))
            return;
        // Unsubscribe from the previous subscription if it exists
        if (subscriptionRef.current) {
            subscriptionRef.current.unsubscribe();
        }
        var subscription = commentElement.getUnreadCommentAnnotationCountByLocationId(memoizedLocationId)
            .subscribe(function (res) {
            setData(res);
        });
        // Store the new subscription
        subscriptionRef.current = subscription;
        // Cleanup function
        return function () {
            if (subscriptionRef.current) {
                subscriptionRef.current.unsubscribe();
            }
        };
    }, [commentElement === null || commentElement === void 0 ? void 0 : commentElement.getUnreadCommentAnnotationCountByLocationId, memoizedLocationId]);
    return data;
}
function useCommentModeState() {
    var commentElement = useCommentUtils();
    var _a = React.useState(), data = _a[0], setData = _a[1];
    useEffect(function () {
        if (!(commentElement === null || commentElement === void 0 ? void 0 : commentElement.onCommentModeChange))
            return;
        var subscription = commentElement.onCommentModeChange().subscribe(function (res) {
            setData(res);
        });
        return function () {
            subscription.unsubscribe();
        };
    }, [commentElement === null || commentElement === void 0 ? void 0 : commentElement.onCommentModeChange]);
    return data;
}
/**
 * @legacy Use `useCommentEventCallback('addCommentAnnotation')` event hook instead.
 */
function useCommentAddHandler() {
    var commentElement = useCommentUtils();
    var _a = React.useState(undefined), data = _a[0], setData = _a[1];
    useEffect(function () {
        if (!(commentElement === null || commentElement === void 0 ? void 0 : commentElement.onCommentAdd))
            return;
        var subscription = commentElement.onCommentAdd().subscribe(function (res) {
            setData(res);
        });
        return function () {
            subscription.unsubscribe();
        };
    }, [commentElement === null || commentElement === void 0 ? void 0 : commentElement.onCommentAdd]);
    return data;
}
/**
 * @legacy Use `useCommentEventCallback` event hook instead.
 */
function useCommentUpdateHandler() {
    var commentElement = useCommentUtils();
    var _a = React.useState(undefined), data = _a[0], setData = _a[1];
    useEffect(function () {
        if (!(commentElement === null || commentElement === void 0 ? void 0 : commentElement.onCommentUpdate))
            return;
        var subscription = commentElement.onCommentUpdate().subscribe(function (res) {
            setData(res);
        });
        return function () {
            subscription.unsubscribe();
        };
    }, [commentElement === null || commentElement === void 0 ? void 0 : commentElement.onCommentUpdate]);
    return data;
}
function useCommentDialogSidebarClickHandler() {
    var commentElement = useCommentUtils();
    var _a = React.useState(), data = _a[0], setData = _a[1];
    useEffect(function () {
        if (!(commentElement === null || commentElement === void 0 ? void 0 : commentElement.onSidebarButtonOnCommentDialogClick))
            return;
        var subscription = commentElement.onSidebarButtonOnCommentDialogClick().subscribe(function (res) {
            setData(res === undefined ? new Date().getTime() : res);
        });
        return function () {
            subscription.unsubscribe();
        };
    }, [commentElement === null || commentElement === void 0 ? void 0 : commentElement.onSidebarButtonOnCommentDialogClick]);
    return data;
}
function useCommentSelectionChangeHandler() {
    var commentElement = useCommentUtils();
    var _a = React.useState(), data = _a[0], setData = _a[1];
    useEffect(function () {
        if (!(commentElement === null || commentElement === void 0 ? void 0 : commentElement.onCommentSelectionChange))
            return;
        var subscription = commentElement.onCommentSelectionChange().subscribe(function (res) {
            setData(res);
        });
        return function () {
            subscription.unsubscribe();
        };
    }, [commentElement === null || commentElement === void 0 ? void 0 : commentElement.onCommentSelectionChange]);
    return data;
}
function useCommentCopyLinkHandler() {
    var commentElement = useCommentUtils();
    var _a = React.useState(undefined), data = _a[0], setData = _a[1];
    useEffect(function () {
        if (!(commentElement === null || commentElement === void 0 ? void 0 : commentElement.onCopyLink))
            return;
        var subscription = commentElement.onCopyLink().subscribe(function (res) {
            if (res) {
                setData({ link: res });
            }
        });
        return function () {
            subscription.unsubscribe();
        };
    }, [commentElement === null || commentElement === void 0 ? void 0 : commentElement.onCopyLink]);
    return data;
}
function useCommentAnnotationById(config) {
    var commentElement = useCommentUtils();
    var _a = React.useState(undefined), data = _a[0], setData = _a[1];
    var subscriptionRef = React.useRef();
    // Memoize the input
    var memoizedConfig = React.useMemo(function () { return config; }, [config.annotationId, config.documentId]);
    useEffect(function () {
        if (!(commentElement === null || commentElement === void 0 ? void 0 : commentElement.getCommentAnnotationById))
            return;
        // Unsubscribe from the previous subscription if it exists
        if (subscriptionRef.current) {
            subscriptionRef.current.unsubscribe();
        }
        var subscription = commentElement.getCommentAnnotationById(memoizedConfig)
            .subscribe(function (res) {
            setData(res);
        });
        // Store the new subscription
        subscriptionRef.current = subscription;
        // Cleanup function
        return function () {
            if (subscriptionRef.current) {
                subscriptionRef.current.unsubscribe();
            }
        };
    }, [commentElement === null || commentElement === void 0 ? void 0 : commentElement.getCommentAnnotationById, memoizedConfig]);
    return data;
}
function useCommentSidebarActionButtonClick() {
    var commentElement = useCommentUtils();
    var _a = React.useState(null), data = _a[0], setData = _a[1];
    useEffect(function () {
        if (!(commentElement === null || commentElement === void 0 ? void 0 : commentElement.onCommentSidebarActionButtonClick))
            return;
        var subscription = commentElement.onCommentSidebarActionButtonClick().subscribe(function (res) {
            setData(res);
        });
        return function () {
            subscription.unsubscribe();
        };
    }, [commentElement === null || commentElement === void 0 ? void 0 : commentElement.onCommentSidebarActionButtonClick]);
    return data;
}
function useCommentSidebarInit() {
    var commentElement = useCommentUtils();
    var _a = React.useState(null), data = _a[0], setData = _a[1];
    useEffect(function () {
        if (!(commentElement === null || commentElement === void 0 ? void 0 : commentElement.onCommentSidebarInit))
            return;
        var subscription = commentElement.onCommentSidebarInit().subscribe(function (res) {
            setData(res);
        });
        return function () {
            subscription.unsubscribe();
        };
    }, [commentElement === null || commentElement === void 0 ? void 0 : commentElement.onCommentSidebarInit]);
    return data;
}
function useCommentSidebarData() {
    var commentElement = useCommentUtils();
    var _a = React.useState(null), data = _a[0], setData = _a[1];
    useEffect(function () {
        if (!(commentElement === null || commentElement === void 0 ? void 0 : commentElement.onCommentSidebarData))
            return;
        var subscription = commentElement.onCommentSidebarData().subscribe(function (res) {
            setData(res);
        });
        return function () {
            subscription.unsubscribe();
        };
    }, [commentElement === null || commentElement === void 0 ? void 0 : commentElement.onCommentSidebarData]);
    return data;
}

function useAddCommentAnnotation() {
    var commentElement = useCommentUtils();
    return {
        addCommentAnnotation: function (request) {
            return new Promise(function (resolve, reject) {
                if (!(commentElement === null || commentElement === void 0 ? void 0 : commentElement.addCommentAnnotation))
                    return reject(new Error('Velt SDK is not initialized.'));
                commentElement.addCommentAnnotation(request).then(resolve).catch(reject);
            });
        }
    };
}
function useApproveCommentAnnotation() {
    var commentElement = useCommentUtils();
    return {
        approveCommentAnnotation: function (request) {
            return new Promise(function (resolve, reject) {
                if (!(commentElement === null || commentElement === void 0 ? void 0 : commentElement.approveCommentAnnotation))
                    return reject(new Error('Velt SDK is not initialized.'));
                commentElement.approveCommentAnnotation(request).then(resolve).catch(reject);
            });
        }
    };
}
function useRejectCommentAnnotation() {
    var commentElement = useCommentUtils();
    return {
        rejectCommentAnnotation: function (request) {
            return new Promise(function (resolve, reject) {
                if (!(commentElement === null || commentElement === void 0 ? void 0 : commentElement.rejectCommentAnnotation))
                    return reject(new Error('Velt SDK is not initialized.'));
                commentElement.rejectCommentAnnotation(request).then(resolve).catch(reject);
            });
        }
    };
}
function useSubscribeCommentAnnotation() {
    var commentElement = useCommentUtils();
    return {
        subscribeCommentAnnotation: function (request) {
            return new Promise(function (resolve, reject) {
                if (!(commentElement === null || commentElement === void 0 ? void 0 : commentElement.subscribeCommentAnnotation))
                    return reject(new Error('Velt SDK is not initialized.'));
                commentElement.subscribeCommentAnnotation(request).then(resolve).catch(reject);
            });
        }
    };
}
function useUnsubscribeCommentAnnotation() {
    var commentElement = useCommentUtils();
    return {
        unsubscribeCommentAnnotation: function (request) {
            return new Promise(function (resolve, reject) {
                if (!(commentElement === null || commentElement === void 0 ? void 0 : commentElement.unsubscribeCommentAnnotation))
                    return reject(new Error('Velt SDK is not initialized.'));
                commentElement.unsubscribeCommentAnnotation(request).then(resolve).catch(reject);
            });
        }
    };
}
function useDeleteCommentAnnotation() {
    var commentElement = useCommentUtils();
    return {
        deleteCommentAnnotation: function (request) {
            return new Promise(function (resolve, reject) {
                if (!(commentElement === null || commentElement === void 0 ? void 0 : commentElement.deleteCommentAnnotation))
                    return reject(new Error('Velt SDK is not initialized.'));
                commentElement.deleteCommentAnnotation(request).then(resolve).catch(reject);
            });
        }
    };
}
function useGetCommentAnnotations(query) {
    var commentElement = useCommentUtils();
    var _a = useState({ data: null }), data = _a[0], setData = _a[1];
    var subscriptionRef = useRef();
    // Memoize the inputs
    var memoizedData = useMemo(function () {
        return query;
    }, [JSON.stringify(query)]);
    useEffect(function () {
        if (!(commentElement === null || commentElement === void 0 ? void 0 : commentElement.getCommentAnnotations))
            return;
        // Unsubscribe from the previous subscription if it exists
        if (subscriptionRef.current) {
            subscriptionRef.current.unsubscribe();
        }
        var subscription = commentElement.getCommentAnnotations(memoizedData)
            .subscribe(function (res) {
            if (res) {
                setData(res);
            }
            else {
                setData({ data: null });
            }
        });
        // Store the new subscription
        subscriptionRef.current = subscription;
        // Cleanup function
        return function () {
            if (subscriptionRef.current) {
                subscriptionRef.current.unsubscribe();
            }
        };
    }, [commentElement === null || commentElement === void 0 ? void 0 : commentElement.getCommentAnnotations, memoizedData]);
    return data;
}
function useCommentAnnotationsCount(query) {
    var commentElement = useCommentUtils();
    var _a = useState({ data: null }), data = _a[0], setData = _a[1];
    var subscriptionRef = useRef();
    // Memoize the inputs
    var memoizedData = useMemo(function () {
        return query;
    }, [JSON.stringify(query)]);
    useEffect(function () {
        if (!(commentElement === null || commentElement === void 0 ? void 0 : commentElement.getCommentAnnotationsCount))
            return;
        // Unsubscribe from the previous subscription if it exists
        if (subscriptionRef.current) {
            subscriptionRef.current.unsubscribe();
        }
        var subscription = commentElement.getCommentAnnotationsCount(memoizedData)
            .subscribe(function (res) {
            if (res) {
                setData(res);
            }
            else {
                setData({ data: null });
            }
        });
        // Store the new subscription
        subscriptionRef.current = subscription;
        // Cleanup function
        return function () {
            if (subscriptionRef.current) {
                subscriptionRef.current.unsubscribe();
            }
        };
    }, [commentElement === null || commentElement === void 0 ? void 0 : commentElement.getCommentAnnotationsCount, memoizedData]);
    return data;
}
function useAssignUser() {
    var commentElement = useCommentUtils();
    return {
        assignUser: function (request) {
            return new Promise(function (resolve, reject) {
                if (!(commentElement === null || commentElement === void 0 ? void 0 : commentElement.assignUser))
                    return reject(new Error('Velt SDK is not initialized.'));
                commentElement.assignUser(request).then(resolve).catch(reject);
            });
        }
    };
}
function useUpdatePriority() {
    var commentElement = useCommentUtils();
    return {
        updatePriority: function (request) {
            return new Promise(function (resolve, reject) {
                if (!(commentElement === null || commentElement === void 0 ? void 0 : commentElement.updatePriority))
                    return reject(new Error('Velt SDK is not initialized.'));
                commentElement.updatePriority(request).then(resolve).catch(reject);
            });
        }
    };
}
function useUpdateStatus() {
    var commentElement = useCommentUtils();
    return {
        updateStatus: function (request) {
            return new Promise(function (resolve, reject) {
                if (!(commentElement === null || commentElement === void 0 ? void 0 : commentElement.updateStatus))
                    return reject(new Error('Velt SDK is not initialized.'));
                commentElement.updateStatus(request).then(resolve).catch(reject);
            });
        }
    };
}
function useUpdateAccess() {
    var commentElement = useCommentUtils();
    return {
        updateAccess: function (request) {
            return new Promise(function (resolve, reject) {
                if (!(commentElement === null || commentElement === void 0 ? void 0 : commentElement.updateAccess))
                    return reject(new Error('Velt SDK is not initialized.'));
                commentElement.updateAccess(request).then(resolve).catch(reject);
            });
        }
    };
}
function useResolveCommentAnnotation() {
    var commentElement = useCommentUtils();
    return {
        resolveCommentAnnotation: function (request) {
            return new Promise(function (resolve, reject) {
                if (!(commentElement === null || commentElement === void 0 ? void 0 : commentElement.resolveCommentAnnotation))
                    return reject(new Error('Velt SDK is not initialized.'));
                commentElement.resolveCommentAnnotation(request).then(resolve).catch(reject);
            });
        }
    };
}
function useGetLink() {
    var commentElement = useCommentUtils();
    return {
        getLink: function (request) {
            return new Promise(function (resolve, reject) {
                if (!(commentElement === null || commentElement === void 0 ? void 0 : commentElement.getLink))
                    return reject(new Error('Velt SDK is not initialized.'));
                commentElement.getLink(request).then(resolve).catch(reject);
            });
        }
    };
}
function useCopyLink() {
    var commentElement = useCommentUtils();
    return {
        copyLink: function (request) {
            return new Promise(function (resolve, reject) {
                if (!(commentElement === null || commentElement === void 0 ? void 0 : commentElement.copyLink))
                    return reject(new Error('Velt SDK is not initialized.'));
                commentElement.copyLink(request).then(resolve).catch(reject);
            });
        }
    };
}
function useAddComment() {
    var commentElement = useCommentUtils();
    return {
        addComment: function (request) {
            return new Promise(function (resolve, reject) {
                if (!(commentElement === null || commentElement === void 0 ? void 0 : commentElement.addComment))
                    return reject(new Error('Velt SDK is not initialized.'));
                commentElement.addComment(request).then(resolve).catch(reject);
            });
        }
    };
}
function useUpdateComment() {
    var commentElement = useCommentUtils();
    return {
        updateComment: function (request) {
            return new Promise(function (resolve, reject) {
                if (!(commentElement === null || commentElement === void 0 ? void 0 : commentElement.updateComment))
                    return reject(new Error('Velt SDK is not initialized.'));
                commentElement.updateComment(request).then(resolve).catch(reject);
            });
        }
    };
}
function useDeleteComment() {
    var commentElement = useCommentUtils();
    return {
        deleteComment: function (request) {
            return new Promise(function (resolve, reject) {
                if (!(commentElement === null || commentElement === void 0 ? void 0 : commentElement.deleteComment))
                    return reject(new Error('Velt SDK is not initialized.'));
                commentElement.deleteComment(request).then(resolve).catch(reject);
            });
        }
    };
}
function useGetComment() {
    var commentElement = useCommentUtils();
    return {
        getComment: function (request) {
            return new Promise(function (resolve, reject) {
                if (!(commentElement === null || commentElement === void 0 ? void 0 : commentElement.getComment))
                    return reject(new Error('Velt SDK is not initialized.'));
                commentElement.getComment(request).then(resolve).catch(reject);
            });
        }
    };
}
function useAddAttachment() {
    var commentElement = useCommentUtils();
    return {
        addAttachment: function (request) {
            return new Promise(function (resolve, reject) {
                if (!(commentElement === null || commentElement === void 0 ? void 0 : commentElement.addAttachment))
                    return reject(new Error('Velt SDK is not initialized.'));
                commentElement.addAttachment(request).then(resolve).catch(reject);
            });
        }
    };
}
function useDeleteAttachment() {
    var commentElement = useCommentUtils();
    return {
        deleteAttachment: function (request) {
            return new Promise(function (resolve, reject) {
                if (!(commentElement === null || commentElement === void 0 ? void 0 : commentElement.deleteAttachment))
                    return reject(new Error('Velt SDK is not initialized.'));
                commentElement.deleteAttachment(request).then(resolve).catch(reject);
            });
        }
    };
}
function useGetAttachment() {
    var commentElement = useCommentUtils();
    return {
        getAttachment: function (request) {
            return new Promise(function (resolve, reject) {
                if (!(commentElement === null || commentElement === void 0 ? void 0 : commentElement.getAttachment))
                    return reject(new Error('Velt SDK is not initialized.'));
                commentElement.getAttachment(request).then(resolve).catch(reject);
            });
        }
    };
}
function useDeleteRecording() {
    var commentElement = useCommentUtils();
    return {
        deleteRecording: function (request) {
            return new Promise(function (resolve, reject) {
                if (!(commentElement === null || commentElement === void 0 ? void 0 : commentElement.deleteRecording))
                    return reject(new Error('Velt SDK is not initialized.'));
                commentElement.deleteRecording(request).then(resolve).catch(reject);
            });
        }
    };
}
function useGetRecording() {
    var commentElement = useCommentUtils();
    return {
        getRecording: function (request) {
            return new Promise(function (resolve, reject) {
                if (!(commentElement === null || commentElement === void 0 ? void 0 : commentElement.getRecording))
                    return reject(new Error('Velt SDK is not initialized.'));
                commentElement.getRecording(request).then(resolve).catch(reject);
            });
        }
    };
}
function useAddReaction() {
    var commentElement = useCommentUtils();
    return {
        addReaction: function (request) {
            return new Promise(function (resolve, reject) {
                if (!(commentElement === null || commentElement === void 0 ? void 0 : commentElement.addReaction))
                    return reject(new Error('Velt SDK is not initialized.'));
                commentElement.addReaction(request).then(resolve).catch(reject);
            });
        }
    };
}
function useDeleteReaction() {
    var commentElement = useCommentUtils();
    return {
        deleteReaction: function (request) {
            return new Promise(function (resolve, reject) {
                if (!(commentElement === null || commentElement === void 0 ? void 0 : commentElement.deleteReaction))
                    return reject(new Error('Velt SDK is not initialized.'));
                commentElement.deleteReaction(request).then(resolve).catch(reject);
            });
        }
    };
}
function useToggleReaction() {
    var commentElement = useCommentUtils();
    return {
        toggleReaction: function (request) {
            return new Promise(function (resolve, reject) {
                if (!(commentElement === null || commentElement === void 0 ? void 0 : commentElement.toggleReaction))
                    return reject(new Error('Velt SDK is not initialized.'));
                commentElement.toggleReaction(request).then(resolve).catch(reject);
            });
        }
    };
}
/**
 * @deprecated Use useCommentEventCallback hook instead.
 */
function useCommentActionCallback(action) {
    var commentElement = useCommentUtils();
    var _a = useState(null), data = _a[0], setData = _a[1];
    var subscriptionRef = useRef(null);
    var memoizedAction = useMemo(function () { return action; }, [action]);
    useEffect(function () {
        var _a;
        if (!(commentElement === null || commentElement === void 0 ? void 0 : commentElement.on))
            return;
        if (subscriptionRef.current) {
            subscriptionRef.current.unsubscribe();
        }
        var subscription = (_a = commentElement === null || commentElement === void 0 ? void 0 : commentElement.on(memoizedAction)) === null || _a === void 0 ? void 0 : _a.subscribe(function (data) {
            setData(data);
        });
        // Store the new subscription
        subscriptionRef.current = subscription;
        // Cleanup function
        return function () {
            if (subscriptionRef.current) {
                subscriptionRef.current.unsubscribe();
            }
        };
    }, [commentElement === null || commentElement === void 0 ? void 0 : commentElement.on, memoizedAction]);
    return data;
}
function useCommentEventCallback(action) {
    var commentElement = useCommentUtils();
    var _a = useState(null), data = _a[0], setData = _a[1];
    var subscriptionRef = useRef(null);
    var memoizedAction = useMemo(function () { return action; }, [action]);
    useEffect(function () {
        var _a;
        if (!(commentElement === null || commentElement === void 0 ? void 0 : commentElement.on))
            return;
        if (subscriptionRef.current) {
            subscriptionRef.current.unsubscribe();
        }
        var subscription = (_a = commentElement === null || commentElement === void 0 ? void 0 : commentElement.on(memoizedAction)) === null || _a === void 0 ? void 0 : _a.subscribe(function (data) {
            setData(data);
        });
        // Store the new subscription
        subscriptionRef.current = subscription;
        // Cleanup function
        return function () {
            if (subscriptionRef.current) {
                subscriptionRef.current.unsubscribe();
            }
        };
    }, [commentElement === null || commentElement === void 0 ? void 0 : commentElement.on, memoizedAction]);
    return data;
}

function useVeltEventCallback(action) {
    var client = useVeltClient().client;
    var _a = useState(null), data = _a[0], setData = _a[1];
    var subscriptionRef = useRef(null);
    var memoizedAction = useMemo(function () { return action; }, [action]);
    useEffect(function () {
        var _a;
        if (!(client === null || client === void 0 ? void 0 : client.on))
            return;
        if (subscriptionRef.current) {
            subscriptionRef.current.unsubscribe();
        }
        var subscription = (_a = client === null || client === void 0 ? void 0 : client.on(memoizedAction)) === null || _a === void 0 ? void 0 : _a.subscribe(function (data) {
            setData(data);
        });
        // Store the new subscription
        subscriptionRef.current = subscription;
        // Cleanup function
        return function () {
            if (subscriptionRef.current) {
                subscriptionRef.current.unsubscribe();
            }
        };
    }, [client === null || client === void 0 ? void 0 : client.on, memoizedAction]);
    return data;
}

function useCursorUtils() {
    var _a = React.useState(), cursorElement = _a[0], setCursorElement = _a[1];
    var client = useVeltClient().client;
    React.useEffect(function () {
        if (!client || cursorElement)
            return;
        var loadedCursorElement = client.getCursorElement();
        setCursorElement(loadedCursorElement);
    }, [client, setCursorElement, cursorElement]);
    return cursorElement;
}
function useCursorUsers() {
    var cursorElement = useCursorUtils();
    var _a = React.useState(null), data = _a[0], setData = _a[1];
    useEffect(function () {
        if (!cursorElement)
            return;
        var subscription = cursorElement.getOnlineUsersOnCurrentDocument().subscribe(function (res) {
            setData(res);
        });
        return function () {
            subscription.unsubscribe();
        };
    }, [cursorElement]);
    return data;
}

function useHuddleUtils() {
    var _a = React.useState(), huddleElement = _a[0], setHuddleElement = _a[1];
    var client = useVeltClient().client;
    React.useEffect(function () {
        if (!client || huddleElement)
            return;
        var loadedHuddleElement = client.getHuddleElement();
        setHuddleElement(loadedHuddleElement);
    }, [client, setHuddleElement, huddleElement]);
    return huddleElement;
}

function useLiveStateSyncUtils() {
    var _a = React.useState(), liveStateSyncElement = _a[0], setLiveStateSyncElement = _a[1];
    var client = useVeltClient().client;
    React.useEffect(function () {
        if (!client || liveStateSyncElement)
            return;
        var loadedLiveStateSyncElement = client.getLiveStateSyncElement();
        setLiveStateSyncElement(loadedLiveStateSyncElement);
    }, [client, setLiveStateSyncElement, liveStateSyncElement]);
    return liveStateSyncElement;
}
function useLiveStateData(liveStateDataId, liveStateDataConfig) {
    var liveStateSyncElement = useLiveStateSyncUtils();
    var _a = React.useState(), data = _a[0], setData = _a[1];
    var subscriptionRef = React.useRef();
    // Memoize inputs
    var inputs = React.useMemo(function () {
        return { liveStateDataId: liveStateDataId, liveStateDataConfig: liveStateDataConfig };
    }, [liveStateDataId, JSON.stringify(liveStateDataConfig)]);
    useEffect(function () {
        if (!(liveStateSyncElement === null || liveStateSyncElement === void 0 ? void 0 : liveStateSyncElement.getLiveStateData))
            return;
        if (subscriptionRef.current) {
            subscriptionRef.current.unsubscribe();
        }
        var subscription = liveStateSyncElement.getLiveStateData(inputs.liveStateDataId, inputs.liveStateDataConfig)
            .subscribe(function (res) {
            setData(res);
        });
        subscriptionRef.current = subscription;
        return function () {
            if (subscriptionRef.current) {
                subscriptionRef.current.unsubscribe();
            }
        };
    }, [liveStateSyncElement === null || liveStateSyncElement === void 0 ? void 0 : liveStateSyncElement.getLiveStateData, inputs]);
    return data;
}
function useSetLiveStateData(liveStateDataId, liveStateData) {
    var liveStateSyncElement = useLiveStateSyncUtils();
    // Memoize inputs
    var inputs = React.useMemo(function () {
        return { liveStateDataId: liveStateDataId, liveStateData: liveStateData };
    }, [liveStateDataId, JSON.stringify(liveStateData)]);
    React.useEffect(function () {
        if (!(liveStateSyncElement === null || liveStateSyncElement === void 0 ? void 0 : liveStateSyncElement.setLiveStateData))
            return;
        if (inputs.liveStateDataId && inputs.liveStateData) {
            liveStateSyncElement.setLiveStateData(inputs.liveStateDataId, inputs.liveStateData);
        }
    }, [liveStateSyncElement === null || liveStateSyncElement === void 0 ? void 0 : liveStateSyncElement.setLiveStateData, inputs]);
}
function useUserEditorState() {
    var liveStateSyncElement = useLiveStateSyncUtils();
    var _a = React.useState(null), data = _a[0], setData = _a[1];
    useEffect(function () {
        if (!(liveStateSyncElement === null || liveStateSyncElement === void 0 ? void 0 : liveStateSyncElement.isUserEditor))
            return;
        var subscription = liveStateSyncElement.isUserEditor().subscribe(function (res) {
            setData(res);
        });
        return function () {
            subscription.unsubscribe();
        };
    }, [liveStateSyncElement === null || liveStateSyncElement === void 0 ? void 0 : liveStateSyncElement.isUserEditor]);
    return data;
}
function useEditor() {
    var liveStateSyncElement = useLiveStateSyncUtils();
    var _a = React.useState(null), data = _a[0], setData = _a[1];
    useEffect(function () {
        if (!(liveStateSyncElement === null || liveStateSyncElement === void 0 ? void 0 : liveStateSyncElement.getEditor))
            return;
        var subscription = liveStateSyncElement.getEditor().subscribe(function (res) {
            setData(res);
        });
        return function () {
            subscription.unsubscribe();
        };
    }, [liveStateSyncElement === null || liveStateSyncElement === void 0 ? void 0 : liveStateSyncElement.getEditor]);
    return data;
}
function useEditorAccessTimer() {
    var liveStateSyncElement = useLiveStateSyncUtils();
    var _a = React.useState({ state: 'idle' }), data = _a[0], setData = _a[1];
    useEffect(function () {
        if (!(liveStateSyncElement === null || liveStateSyncElement === void 0 ? void 0 : liveStateSyncElement.getEditorAccessTimer))
            return;
        var subscription = liveStateSyncElement.getEditorAccessTimer().subscribe(function (res) {
            setData(res);
        });
        return function () {
            subscription.unsubscribe();
        };
    }, [liveStateSyncElement === null || liveStateSyncElement === void 0 ? void 0 : liveStateSyncElement.getEditorAccessTimer]);
    return data;
}
function useEditorAccessRequestHandler() {
    var liveStateSyncElement = useLiveStateSyncUtils();
    var _a = React.useState(null), data = _a[0], setData = _a[1];
    useEffect(function () {
        if (!(liveStateSyncElement === null || liveStateSyncElement === void 0 ? void 0 : liveStateSyncElement.isEditorAccessRequested))
            return;
        var subscription = liveStateSyncElement.isEditorAccessRequested().subscribe(function (res) {
            setData(res);
        });
        return function () {
            subscription.unsubscribe();
        };
    }, [liveStateSyncElement === null || liveStateSyncElement === void 0 ? void 0 : liveStateSyncElement.isEditorAccessRequested]);
    return data;
}
function useServerConnectionStateChangeHandler() {
    var liveStateSyncElement = useLiveStateSyncUtils();
    var _a = React.useState(), data = _a[0], setData = _a[1];
    useEffect(function () {
        if (!(liveStateSyncElement === null || liveStateSyncElement === void 0 ? void 0 : liveStateSyncElement.onServerConnectionStateChange))
            return;
        var subscription = liveStateSyncElement.onServerConnectionStateChange().subscribe(function (res) {
            setData(res);
        });
        return function () {
            subscription.unsubscribe();
        };
    }, [liveStateSyncElement === null || liveStateSyncElement === void 0 ? void 0 : liveStateSyncElement.onServerConnectionStateChange]);
    return data;
}
function useLiveState(liveStateDataId, initialValue, options) {
    var liveStateSyncElement = useLiveStateSyncUtils();
    var client = useVeltClient().client;
    var serverConnectionState = useServerConnectionStateChangeHandler();
    var _a = React.useState(null), documentId = _a[0], setDocumentId = _a[1];
    var _b = React.useState(null), user = _b[0], setUser = _b[1];
    var _c = React.useState(initialValue), data = _c[0], setData = _c[1];
    useEffect(function () {
        resetLiveStateData();
    }, [documentId, user]);
    var resetLiveStateData = function () {
        if (user && documentId) {
            liveStateSyncElement === null || liveStateSyncElement === void 0 ? void 0 : liveStateSyncElement.setLiveStateData(liveStateDataId, data);
        }
    };
    useEffect(function () {
        if (!(liveStateSyncElement === null || liveStateSyncElement === void 0 ? void 0 : liveStateSyncElement.getLiveStateData))
            return;
        var documentPathsSubscription, userSubscription;
        if (options === null || options === void 0 ? void 0 : options.resetLiveState) {
            documentPathsSubscription = client.docService.getDocumentPaths$().subscribe(function (paths) {
                if (paths) {
                    setDocumentId(paths === null || paths === void 0 ? void 0 : paths.documentId);
                    documentPathsSubscription === null || documentPathsSubscription === void 0 ? void 0 : documentPathsSubscription.unsubscribe();
                }
            });
            userSubscription = client.authService.getUser$().subscribe(function (user) {
                if (user) {
                    setUser(user);
                    userSubscription === null || userSubscription === void 0 ? void 0 : userSubscription.unsubscribe();
                }
            });
        }
        var subscription = liveStateSyncElement.getLiveStateData(liveStateDataId, { listenToNewChangesOnly: options === null || options === void 0 ? void 0 : options.listenToNewChangesOnly }).subscribe(function (res) {
            setData(res);
        });
        return function () {
            subscription.unsubscribe();
            documentPathsSubscription === null || documentPathsSubscription === void 0 ? void 0 : documentPathsSubscription.unsubscribe();
            userSubscription === null || userSubscription === void 0 ? void 0 : userSubscription.unsubscribe();
        };
    }, [liveStateSyncElement === null || liveStateSyncElement === void 0 ? void 0 : liveStateSyncElement.getLiveStateData]);
    var useDebounce = function (callback) {
        var callbackRef = useRef(callback);
        var timerRef = useRef(null);
        useEffect(function () {
            callbackRef.current = callback;
        });
        var debounce = function (value, delay) {
            if (timerRef.current) {
                clearTimeout(timerRef.current);
            }
            timerRef.current = setTimeout(function () {
                callbackRef.current(value);
            }, delay);
        };
        return debounce;
    };
    var setDataFunction = function (value) {
        setData(value);
        debouncedOnInput(value, (options === null || options === void 0 ? void 0 : options.syncDuration) >= 0 ? options === null || options === void 0 ? void 0 : options.syncDuration : 50); // default 50ms debounce time
    };
    var debouncedOnInput = useDebounce(function (value) {
        if (liveStateSyncElement === null || liveStateSyncElement === void 0 ? void 0 : liveStateSyncElement.setLiveStateData) {
            liveStateSyncElement.setLiveStateData(liveStateDataId, value);
        }
    });
    return [data, setDataFunction, serverConnectionState];
}

function usePresenceUtils() {
    var _a = React.useState(), presenceElement = _a[0], setPresenceElement = _a[1];
    var client = useVeltClient().client;
    React.useEffect(function () {
        if (!client || presenceElement)
            return;
        var loadedPresenceElement = client.getPresenceElement();
        setPresenceElement(loadedPresenceElement);
    }, [client, setPresenceElement, presenceElement]);
    return presenceElement;
}
function usePresenceUsers() {
    var presenceElement = usePresenceUtils();
    var _a = React.useState(null), data = _a[0], setData = _a[1];
    useEffect(function () {
        if (!presenceElement)
            return;
        var subscription = presenceElement.getOnlineUsersOnCurrentDocument().subscribe(function (res) {
            setData(res);
        });
        return function () {
            subscription.unsubscribe();
        };
    }, [presenceElement]);
    return data;
}

function useRecorderUtils() {
    var _a = React.useState(), recorderElement = _a[0], setRecorderElement = _a[1];
    var client = useVeltClient().client;
    React.useEffect(function () {
        if (!client || recorderElement)
            return;
        var loadedRecorderElement = client.getRecorderElement();
        setRecorderElement(loadedRecorderElement);
    }, [client, setRecorderElement, recorderElement]);
    return recorderElement;
}
/**
* @deprecated Use `useRecorderEventCallback('recordingDone')` hook instead
*/
function useRecorderAddHandler() {
    var recorderElement = useRecorderUtils();
    var _a = React.useState(), data = _a[0], setData = _a[1];
    useEffect(function () {
        if (!recorderElement)
            return;
        var subscription = recorderElement.onRecordedData().subscribe(function (res) {
            setData(res);
        });
        return function () {
            subscription.unsubscribe();
        };
    }, [recorderElement]);
    return data;
}
/**
* @deprecated Use `recorderUtils.getRecordingData()` method instead
*/
function useRecordingDataByRecorderId(recorderId) {
    var recorderElement = useRecorderUtils();
    var _a = React.useState(null), data = _a[0], setData = _a[1];
    useEffect(function () {
        if (!recorderElement)
            return;
        var subscription = recorderElement.getRecordingDataByRecorderId(recorderId).subscribe(function (res) {
            setData(res);
        });
        return function () {
            subscription.unsubscribe();
        };
    }, [recorderElement]);
    return data;
}
function useRecordings(query) {
    var recorderElement = useRecorderUtils();
    var _a = React.useState([]), data = _a[0], setData = _a[1];
    var subscriptionRef = React.useRef();
    // Memoize the inputs
    var memoizedData = React.useMemo(function () {
        return query;
    }, [JSON.stringify(query)]);
    useEffect(function () {
        if (!(recorderElement === null || recorderElement === void 0 ? void 0 : recorderElement.getRecordings))
            return;
        // Unsubscribe from the previous subscription if it exists
        if (subscriptionRef.current) {
            subscriptionRef.current.unsubscribe();
        }
        var subscription = recorderElement === null || recorderElement === void 0 ? void 0 : recorderElement.getRecordings(memoizedData).subscribe(function (res) {
            if (res) {
                setData(res);
            }
            else {
                setData([]);
            }
        });
        // Store the new subscription
        subscriptionRef.current = subscription;
        // Cleanup function
        return function () {
            if (subscriptionRef.current) {
                subscriptionRef.current.unsubscribe();
            }
        };
    }, [recorderElement === null || recorderElement === void 0 ? void 0 : recorderElement.getRecordings, memoizedData]);
    return data;
}

function useRecorderEventCallback(action) {
    var recorderElement = useRecorderUtils();
    var _a = useState(null), data = _a[0], setData = _a[1];
    var subscriptionRef = useRef(null);
    var memoizedAction = useMemo(function () { return action; }, [action]);
    useEffect(function () {
        var _a;
        if (!(recorderElement === null || recorderElement === void 0 ? void 0 : recorderElement.on))
            return;
        if (subscriptionRef.current) {
            subscriptionRef.current.unsubscribe();
        }
        var subscription = (_a = recorderElement === null || recorderElement === void 0 ? void 0 : recorderElement.on(memoizedAction)) === null || _a === void 0 ? void 0 : _a.subscribe(function (data) {
            setData(data);
        });
        // Store the new subscription
        subscriptionRef.current = subscription;
        // Cleanup function
        return function () {
            if (subscriptionRef.current) {
                subscriptionRef.current.unsubscribe();
            }
        };
    }, [recorderElement === null || recorderElement === void 0 ? void 0 : recorderElement.on, memoizedAction]);
    return data;
}

function useAIRewriterUtils() {
    var _a = React.useState(), rewriterElement = _a[0], setRewriterElement = _a[1];
    var client = useVeltClient().client;
    React.useEffect(function () {
        if (!client || rewriterElement)
            return;
        var loadedRewriterElement = client.getRewriterElement();
        setRewriterElement(loadedRewriterElement);
    }, [client, setRewriterElement, rewriterElement]);
    return rewriterElement;
}

function useLiveSelectionUtils() {
    var _a = React.useState(), selectionElement = _a[0], setSelectionElement = _a[1];
    var client = useVeltClient().client;
    React.useEffect(function () {
        if (!client || selectionElement)
            return;
        var loadedSelectionElement = client.getSelectionElement();
        setSelectionElement(loadedSelectionElement);
    }, [client, setSelectionElement, selectionElement]);
    return selectionElement;
}
function useLiveSelectionDataHandler() {
    var selectionElement = useLiveSelectionUtils();
    var _a = React.useState(null), data = _a[0], setData = _a[1];
    useEffect(function () {
        if (!(selectionElement === null || selectionElement === void 0 ? void 0 : selectionElement.getLiveSelectionData))
            return;
        var subscription = selectionElement.getLiveSelectionData().subscribe(function (res) {
            setData(res);
        });
        return function () {
            subscription.unsubscribe();
        };
    }, [selectionElement === null || selectionElement === void 0 ? void 0 : selectionElement.getLiveSelectionData]);
    return data;
}

function useTagUtils() {
    var _a = React.useState(), tagElement = _a[0], setTagElement = _a[1];
    var client = useVeltClient().client;
    React.useEffect(function () {
        if (!client || tagElement)
            return;
        var loadedTagElement = client.getTagElement();
        setTagElement(loadedTagElement);
    }, [client, setTagElement, tagElement]);
    return tagElement;
}
function useTagAnnotations(documentId, location) {
    var tagElement = useTagUtils();
    var _a = React.useState(null), data = _a[0], setData = _a[1];
    useEffect(function () {
        if (!tagElement)
            return;
        var subscription = tagElement.getAllTagAnnotations(documentId, location).subscribe(function (res) {
            setData(res);
        });
        return function () {
            subscription.unsubscribe();
        };
    }, [tagElement]);
    return data;
}

function useViewsUtils() {
    var _a = React.useState(), viewsElement = _a[0], setViewsElement = _a[1];
    var client = useVeltClient().client;
    React.useEffect(function () {
        if (!client || viewsElement)
            return;
        var loadedViewsElement = client.getViewsElement();
        setViewsElement(loadedViewsElement);
    }, [client, setViewsElement, viewsElement]);
    return viewsElement;
}
function useUniqueViewsByUser(clientLocationId) {
    var viewsElement = useViewsUtils();
    var _a = React.useState(null), data = _a[0], setData = _a[1];
    var subscriptionRef = React.useRef();
    // Memoize the input
    var memoizedClientLocationId = React.useMemo(function () { return clientLocationId; }, [clientLocationId]);
    useEffect(function () {
        if (!(viewsElement === null || viewsElement === void 0 ? void 0 : viewsElement.getUniqueViewsByUser))
            return;
        // Unsubscribe from the previous subscription if it exists
        if (subscriptionRef.current) {
            subscriptionRef.current.unsubscribe();
        }
        var subscription = viewsElement.getUniqueViewsByUser(memoizedClientLocationId).subscribe(function (res) {
            setData(res);
        });
        // Store the new subscription
        subscriptionRef.current = subscription;
        return function () {
            if (subscriptionRef.current) {
                subscriptionRef.current.unsubscribe();
            }
        };
    }, [viewsElement === null || viewsElement === void 0 ? void 0 : viewsElement.getUniqueViewsByUser, memoizedClientLocationId]);
    return data;
}
function useUniqueViewsByDate(clientLocationId) {
    var viewsElement = useViewsUtils();
    var _a = React.useState(null), data = _a[0], setData = _a[1];
    var subscriptionRef = React.useRef();
    // Memoize the input
    var memoizedClientLocationId = React.useMemo(function () { return clientLocationId; }, [clientLocationId]);
    useEffect(function () {
        if (!(viewsElement === null || viewsElement === void 0 ? void 0 : viewsElement.getUniqueViewsByDate))
            return;
        // Unsubscribe from the previous subscription if it exists
        if (subscriptionRef.current) {
            subscriptionRef.current.unsubscribe();
        }
        var subscription = viewsElement.getUniqueViewsByDate(memoizedClientLocationId).subscribe(function (res) {
            setData(res);
        });
        // Store the new subscription
        subscriptionRef.current = subscription;
        return function () {
            if (subscriptionRef.current) {
                subscriptionRef.current.unsubscribe();
            }
        };
    }, [viewsElement === null || viewsElement === void 0 ? void 0 : viewsElement.getUniqueViewsByDate, memoizedClientLocationId]);
    return data;
}

function useNotificationUtils() {
    var _a = React.useState(), notificationElement = _a[0], setNotificationElement = _a[1];
    var client = useVeltClient().client;
    React.useEffect(function () {
        if (!client || notificationElement)
            return;
        var loadedNotificationElement = client.getNotificationElement();
        setNotificationElement(loadedNotificationElement);
    }, [client, setNotificationElement, notificationElement]);
    return notificationElement;
}
function useNotificationsData() {
    var notificationElement = useNotificationUtils();
    var _a = React.useState(null), data = _a[0], setData = _a[1];
    useEffect(function () {
        if (!(notificationElement === null || notificationElement === void 0 ? void 0 : notificationElement.getNotificationsData))
            return;
        var subscription = notificationElement.getNotificationsData().subscribe(function (res) {
            setData(res);
        });
        return function () {
            subscription.unsubscribe();
        };
    }, [notificationElement === null || notificationElement === void 0 ? void 0 : notificationElement.getNotificationsData]);
    return data;
}
function useUnreadNotificationsCount() {
    var notificationElement = useNotificationUtils();
    var _a = React.useState({ forYou: null, all: null }), data = _a[0], setData = _a[1];
    useEffect(function () {
        if (!(notificationElement === null || notificationElement === void 0 ? void 0 : notificationElement.getUnreadNotificationsCount))
            return;
        var subscription = notificationElement.getUnreadNotificationsCount().subscribe(function (res) {
            setData(res);
        });
        return function () {
            subscription.unsubscribe();
        };
    }, [notificationElement === null || notificationElement === void 0 ? void 0 : notificationElement.getUnreadNotificationsCount]);
    return data;
}

function useAutocompleteUtils() {
    var _a = React.useState(), autocompleteElement = _a[0], setAutocompleteElement = _a[1];
    var client = useVeltClient().client;
    React.useEffect(function () {
        if (!client || autocompleteElement)
            return;
        var loadedAutocompleteElement = client.getAutocompleteElement();
        setAutocompleteElement(loadedAutocompleteElement);
    }, [client, setAutocompleteElement, autocompleteElement]);
    return autocompleteElement;
}
function useAutocompleteChipClick() {
    var autocompleteElement = useAutocompleteUtils();
    var _a = React.useState(), data = _a[0], setData = _a[1];
    useEffect(function () {
        if (!autocompleteElement)
            return;
        var subscription = autocompleteElement.onAutocompleteChipClick().subscribe(function (res) {
            setData(res);
        });
        return function () {
            subscription.unsubscribe();
        };
    }, [autocompleteElement]);
    return data;
}

function useContactUtils() {
    var _a = React.useState(), contactElement = _a[0], setContactElement = _a[1];
    var client = useVeltClient().client;
    React.useEffect(function () {
        if (!client || contactElement)
            return;
        var loadedContactElement = client.getContactElement();
        setContactElement(loadedContactElement);
    }, [client, setContactElement, contactElement]);
    return contactElement;
}
function useContactSelected() {
    var contactElement = useContactUtils();
    var _a = React.useState(), data = _a[0], setData = _a[1];
    useEffect(function () {
        if (!contactElement)
            return;
        var subscription = contactElement.onContactSelected().subscribe(function (res) {
            setData(res);
        });
        return function () {
            subscription.unsubscribe();
        };
    }, [contactElement === null || contactElement === void 0 ? void 0 : contactElement.onContactSelected]);
    return data;
}
function useContactList() {
    var contactElement = useContactUtils();
    var _a = React.useState(null), data = _a[0], setData = _a[1];
    var subscriptionRef = React.useRef();
    useEffect(function () {
        if (!contactElement)
            return;
        // Unsubscribe from the previous subscription if it exists
        if (subscriptionRef.current) {
            subscriptionRef.current.unsubscribe();
        }
        var subscription = contactElement.getContactList().subscribe(function (res) {
            setData(res);
        });
        // Store the new subscription
        subscriptionRef.current = subscription;
        // Cleanup function
        return function () {
            if (subscriptionRef.current) {
                subscriptionRef.current.unsubscribe();
            }
        };
    }, [contactElement === null || contactElement === void 0 ? void 0 : contactElement.getContactList]);
    return data;
}

var sessionId = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
var getSessionId = function () {
    return (sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.getItem(VELT_TAB_ID)) || sessionId;
};
var VELT_DEFAULT_LIVE_STATE_ID = 'velt-default-redux-live-state';
var createLiveStateMiddleware = function (config) {
    if (config === void 0) { config = {}; }
    var _a = config.allowedActionTypes, allowedActionTypes = _a === void 0 ? new Set() : _a, // Set of allowed action types for sync
    _b = config.disabledActionTypes, // Set of allowed action types for sync
    disabledActionTypes = _b === void 0 ? new Set() : _b, // Set of disabled action types for sync
    _c = config.allowAction, // Set of disabled action types for sync
    allowAction = _c === void 0 ? function () { return true; } : _c, // Callback to decide if an action should sync with live state
    _d = config.liveStateDataId, // Callback to decide if an action should sync with live state
    liveStateDataId = _d === void 0 ? VELT_DEFAULT_LIVE_STATE_ID : _d;
    if (!liveStateDataId) {
        liveStateDataId = VELT_DEFAULT_LIVE_STATE_ID;
    }
    var internalStore; // This variable will hold the reference to the store
    var dataSubscription; // This variable will hold the reference to the data subscription
    var isSdkInitialized = false;
    var setupGetDataSubscription = function () {
        var _a, _b;
        if (!dataSubscription && window.Velt && ((_a = window.Velt) === null || _a === void 0 ? void 0 : _a.getLiveStateSyncElement)) {
            var liveStateSyncElement = (_b = window.Velt) === null || _b === void 0 ? void 0 : _b.getLiveStateSyncElement();
            dataSubscription = liveStateSyncElement === null || liveStateSyncElement === void 0 ? void 0 : liveStateSyncElement.getLiveStateData(liveStateDataId).subscribe(function (data) {
                // Dispatch action to update local state, marking it as remote
                if (data) {
                    var sessionId_1 = getSessionId();
                    if (data.id === sessionId_1) {
                        return;
                    }
                    else {
                        internalStore === null || internalStore === void 0 ? void 0 : internalStore.dispatch(__assign(__assign({}, data.action), { isRemote: true }));
                    }
                }
            });
        }
    };
    var updateLiveStateDataId = function (newId) {
        liveStateDataId = newId || VELT_DEFAULT_LIVE_STATE_ID;
        if (dataSubscription) {
            dataSubscription.unsubscribe();
            dataSubscription = null;
        }
        if (isSdkInitialized) {
            setupGetDataSubscription();
        }
    };
    var middleware = function (store) {
        internalStore = store;
        var veltSdkInitializedListener = function () {
            isSdkInitialized = true;
            setupGetDataSubscription();
            // Remove the event listener after it's triggered
            window.removeEventListener(VELT_SDK_INIT_EVENT, veltSdkInitializedListener);
        };
        // Add the event listener for the veltSdkInitialized event
        window.addEventListener(VELT_SDK_INIT_EVENT, veltSdkInitializedListener);
        return function (next) { return function (action) {
            // Always process the action locally
            var result = next(action);
            // Decide whether to sync this action with Firebase
            if (isSdkInitialized && !action.isRemote && allowAction(action) && !disabledActionTypes.has(action.type) && (allowedActionTypes.size === 0 || allowedActionTypes.has(action.type))) {
                logLiveState(action, liveStateDataId);
            }
            return result;
        }; };
    };
    return {
        middleware: middleware,
        updateLiveStateDataId: updateLiveStateDataId,
    };
};
var logLiveState = function (action, liveStateDataId) {
    var _a;
    if (window.Velt) {
        var sessionId_2 = getSessionId();
        var liveStateElement = (_a = window === null || window === void 0 ? void 0 : window.Velt) === null || _a === void 0 ? void 0 : _a.getLiveStateSyncElement();
        if (liveStateElement === null || liveStateElement === void 0 ? void 0 : liveStateElement.setLiveStateData) {
            liveStateElement.setLiveStateData(liveStateDataId, {
                id: sessionId_2,
                action: action
            });
        }
        liveStateElement.setLiveStateData(liveStateDataId, {
            id: sessionId_2,
            action: action
        });
    }
};

export { SnippylyArrowTool as VeltArrowTool, SnippylyArrows as VeltArrows, VeltAutocomplete, VeltAutocompleteChipTooltipWireframe, VeltAutocompleteGroupOptionWireframe, VeltAutocompleteOptionWireframe, VeltButtonWireframe, VeltCanvasComment, VeltChartComment, SnippylyCommentBubble as VeltCommentBubble, VeltCommentBubbleWireframe, VeltCommentComposer, VeltCommentComposerWireframe, VeltCommentDialogOptionsDropdownContentWireframe, VeltCommentDialogOptionsDropdownTriggerWireframe, VeltCommentDialogPriorityDropdownContentWireframe, VeltCommentDialogPriorityDropdownTriggerWireframe, VeltCommentDialogStatusDropdownContentWireframe, VeltCommentDialogStatusDropdownTriggerWireframe, VeltCommentDialogWireframe, VeltCommentPin, VeltCommentPinWireframe, VeltCommentPlayerTimeline, VeltCommentText, VeltCommentThread, VeltCommentThreadWireframe, SnippylyCommentTool as VeltCommentTool, VeltCommentToolWireframe, SnippylyComments as VeltComments, VeltCommentsMinimap, SnippylyCommentsSidebar as VeltCommentsSidebar, VeltCommentsSidebarButton, VeltCommentsSidebarStatusDropdownWireframe, VeltCommentsSidebarWireframe, VeltConfirmDialogWireframe, SnippylyCursor as VeltCursor, VeltData, VeltHighChartComments, SnippylyHuddle as VeltHuddle, SnippylyHuddleTool as VeltHuddleTool, VeltIf, VeltInlineCommentsSection, VeltInlineCommentsSectionWireframe, VeltInlineReactionsSection, VeltInlineReactionsSectionWireframe, VeltMediaSourceSettingsWireframe, VeltMultiThreadCommentDialogWireframe, VeltNivoChartComments, VeltNotificationsHistoryPanel, VeltNotificationsPanel, VeltNotificationsPanelWireframe, VeltNotificationsTool, VeltNotificationsToolWireframe, VeltPersistentCommentModeWireframe, SnippylyPresence as VeltPresence, SnippylyProvider as VeltProvider, VeltReactionPinTooltipWireframe, VeltReactionPinWireframe, VeltReactionTool, VeltReactionToolWireframe, VeltReactionsPanelWireframe, VeltRecorderAllToolMenuWireframe, VeltRecorderAllToolWireframe, VeltRecorderAudioToolWireframe, SnippylyRecorderControlPanel as VeltRecorderControlPanel, VeltRecorderControlPanelWireframe, SnippylyRecorderNotes as VeltRecorderNotes, SnippylyRecorderPlayer as VeltRecorderPlayer, VeltRecorderPlayerWireframe, VeltRecorderScreenToolWireframe, SnippylyRecorderTool as VeltRecorderTool, VeltRecorderVideoToolWireframe, VeltRecordingPreviewStepsDialogWireframe, SnippylySidebarButton as VeltSidebarButton, VeltSidebarButtonWireframe, VeltSubtitlesWireframe, SnippylyTagTool as VeltTagTool, SnippylyTags as VeltTags, VeltTextCommentToolWireframe, VeltTextCommentToolbar as VeltTextCommentToolbarWireframe, VeltTranscriptionWireframe, SnippylyUserInviteTool as VeltUserInviteTool, SnippylyUserRequestTool as VeltUserRequestTool, VeltUserSelectorDropdown as VeltUserSelectorDropdownWireframe, VeltVideoEditorPlayerWireframe, VeltVideoPlayer, VeltVideoPlayerWireframe, VeltViewAnalytics, VeltWireframe, createLiveStateMiddleware, useAIRewriterUtils, useAddAttachment, useAddComment, useAddCommentAnnotation, useAddReaction, useApproveCommentAnnotation, useAssignUser, useAutocompleteChipClick, useAutocompleteUtils, useClient, useCommentActionCallback, useCommentAddHandler, useCommentAnnotationById, useCommentAnnotations, useCommentAnnotationsCount, useCommentCopyLinkHandler, useCommentDialogSidebarClickHandler, useCommentEventCallback, useCommentModeState, useCommentSelectionChangeHandler, useCommentSidebarActionButtonClick, useCommentSidebarData, useCommentSidebarInit, useCommentUpdateHandler, useCommentUtils, useContactList, useContactSelected, useContactUtils, useCopyLink, useCursorUsers, useCursorUtils, useDeleteAttachment, useDeleteComment, useDeleteCommentAnnotation, useDeleteReaction, useDeleteRecording, useEditor, useEditorAccessRequestHandler, useEditorAccessTimer, useGetAttachment, useGetComment, useGetCommentAnnotations, useGetLink, useGetRecording, useHuddleUtils, useIdentify, useLiveSelectionDataHandler, useLiveSelectionUtils, useLiveState, useLiveStateData, useLiveStateSyncUtils, useNotificationUtils, useNotificationsData, usePresenceUsers, usePresenceUtils, useRecorderAddHandler, useRecorderEventCallback, useRecorderUtils, useRecordingDataByRecorderId, useRecordings, useRejectCommentAnnotation, useResolveCommentAnnotation, useServerConnectionStateChangeHandler, useSetDocument, useSetDocumentId, useSetDocuments, useSetLiveStateData, useSetLocation, useSubscribeCommentAnnotation, useTagAnnotations, useTagUtils, useToggleReaction, useUniqueViewsByDate, useUniqueViewsByUser, useUnreadCommentAnnotationCountByLocationId, useUnreadCommentAnnotationCountOnCurrentDocument, useUnreadCommentCountByAnnotationId, useUnreadCommentCountByLocationId, useUnreadCommentCountOnCurrentDocument, useUnreadNotificationsCount, useUnsetDocumentId, useUnsetDocuments, useUnsubscribeCommentAnnotation, useUpdateAccess, useUpdateComment, useUpdatePriority, useUpdateStatus, useUserEditorState, useVeltClient, useVeltEventCallback, useVeltInitState, useViewsUtils };
//# sourceMappingURL=index.js.map
